/* eslint-disable prettier/prettier */
module.exports = {
  app: "Application",
  news: "Actualités",
  component: "Composant",
  download: "Télécharger",
  downloading: "Téléchargement",
  unableToDownload: "Impossible de télécharger",
  features: "Fonctionnalités",
  applications: "Applications",
  dashboard: "Tableau de bord",
  customers: "Clients",
  warehouses: "Entrepôts",
  management: "Gestion",
  carriers: "Transporteurs",
  operations: "Opérations",
  warehousing: "Entreposage",
  quote: "Devis",
  business: "Entreprise",
  invoices: "Factures",
  prepayments: "Prépaiements",
  billsToPay: "Factures à payer",
  modules: "Modules",
  agency: "Agence",
  pages: "Pages",
  gallery: "Galerie",
  pricing: "Tarification",
  privacyPolicy: "Politique de confidentialité",
  feedback: "Commentaires",
  report: "Rapport",
  faqS: "FAQ",
  advanceComponent: "Composant avancé",
  blank: "Vide",
  session: "Session",
  login: "Connexion",
  reset: "Réinitialiser",
  register: "S'inscrire",
  lockScreen: "Écran de verrouillage",
  forgotPassword: "Mot de passe oublié",
  forgotYourPassword: "Mot de passe oublié ?",
  letsGetYouBackIn: "Reconnectez-vous",
  recoverPassword: "Récupérer le mot de passe",
  dontWorryJustEnterYourEmailAddressBelowAndWellAssistYou:
    "Ne vous inquiétez pas ! Entrez simplement votre adresse e-mail ci-dessous et nous vous aiderons.",
  withInstructionsToResetYourPassword: "avec les instructions pour réinitialiser votre mot de passe",
  checkYourEmail: "Vérifiez votre e-mail",
  emailNotReceived: "E-mail non reçu ?",
  resend: "Renvoyer",
  uiComponents: "Composants UI",
  alerts: "Alertes",
  appBar: "Barre d'application",
  avatars: "Avatars",
  buttons: "Boutons",
  bottomNavigations: "Navigations inférieures",
  badges: "Badges",
  cards: "Cartes",
  cardsMasonry: "Cartes en maçonnerie",
  chip: "Puce",
  dialog: "Dialogue",
  dividers: "Séparateurs",
  drawers: "Tiroirs",
  draft: "Brouillon",
  totalQuotes: "Total des devis",
  inspect: "Inspecter",
  expansionPanel: "Panneau d'expansion",
  gridList: "Liste en grille",
  list: "Liste",
  menu: "Menu",
  popOverTooltip: "Info-bulle et pop-over",
  progress: "Progression",
  snackbar: "Snackbar",
  selectionControls: "Contrôles de sélection",
  dateTimePicker: "Sélecteur de date et heure",
  tabs: "Onglets",
  stepper: "Étapes",
  notification: "Notification",
  notifications: "Notifications",
  sweetAlert: "Alerte animée",
  autoComplete: "Saisie automatique",
  aboutUs: "À propos",
  widgets: "Widgets",
  forms: "Formulaires",
  formElements: "Éléments de formulaire",
  textField: "Champ de texte",
  selectList: "Liste de sélection",
  charts: "Graphiques",
  reCharts: "Re Charts",
  reactChartjs2: "React Chartjs 2",
  icons: "Icônes",
  themifyIcons: "Icônes Themify",
  simpleLineIcons: "Icônes de lignes simples",
  materialIcons: "Icônes Material",
  tables: "Tableaux",
  basic: "De base",
  dataTable: "Tableau de données",
  responsive: "Responsif",
  maps: "Cartes",
  googleMaps: "Google Maps",
  leafletMaps: "Cartes Leaflet",
  inbox: "Boîte de réception",
  users: "Utilisateurs",
  userProfile1: "Profil utilisateur 1",
  userProfile2: "Profil utilisateur 2",
  userManagement: "Gestion des utilisateurs",
  userList: "Liste des utilisateurs",
  calendar: "Calendrier",
  cultures: "Cultures",
  selectable: "Sélectionnable",
  customRendering: "Rendu personnalisé",
  chat: "Discussion",
  todo: "ToDo",
  editor: "Éditeur",
  wysiwygEditor: "Éditeur WYSIWYG",
  quillEditor: "Éditeur Quill",
  dragAndDrop: "Glisser-déposer",
  reactDragula: "React Dragula",
  reactDnd: "React Dnd",
  ecommerce: "Commerce électronique",
  shopList: "Liste de boutique",
  shopGrid: "Grille de boutique",
  invoice: "Facture",
  crm: "CRM",
  ratings: "Évaluations",
  number: "Numéro",
  welcomeBack: "Bon retour !",
  pleaseCreateANewPasswordForYourAccount: "Veuillez créer un nouveau mot de passe pour votre compte",
  emailOrUsername: "E-mail ou nom d'utilisateur",
  rememberMe: "Se souvenir de moi",
  notRegisteredYet: "Pas encore inscrit ?",
  clickToResend: "Cliquer pour renvoyer",
  clickHere: "cliquez ici.",
  youWillBeRedirectedToTheSignInPageIfYouAreNotRedirectedAutomatically:
    "Vous serez redirigé vers la page de connexion. Si vous n'êtes pas redirigé automatiquement, ",
  createAnAccount: "Créer un compte",
  web: "Web",
  done: "Terminé",
  inProgress: "En cours",
  waiting: "En attente",
  subscribed: "Abonné",
  searchItem: "Rechercher un article",
  startDate: "Date de début",
  endDate: "Date de fin",
  password: "Mot de passe",
  newPassword: "Nouveau mot de passe",
  createNewPassword: "Créer un nouveau mot de passe",
  filters: "Filtres",
  private: "Privé",
  corporate: "Entreprise",
  name: "Nom",
  volume: "Volume",
  sidebarOverlay: "Superposition barre latérale",
  appSettings: "Paramètres de l'application",
  sidebarImage: "Image barre latérale",
  miniSidebar: "Barre latérale réduite",
  boxLayout: "Mise en page encadrée",
  rtlLayout: "Mise en page RTL",
  darkMode: "Mode sombre",
  light: "Clair",
  dark: "Sombre",
  refresh: "Actualiser",
  refreshing: "Actualisation",
  record: "Enregistrer",
  play: "Lire",
  start: "Démarrer",
  cancel: "Annuler",
  copy: "Copier",
  send: "Envoyer",
  add: "Ajouter",
  update: "Mettre à jour",
  confirm: "Confirmer",
  delete: "Supprimer",
  yes: "Oui",
  no: "Non",
  addNewContact: "Ajouter un nouveau contact",
  editAContact: "Modifier un contact",
  addNewLocation: "Ajouter un nouvel emplacement",
  editALocation: "Modifier un emplacement",
  summary: "Résumé",
  week: "Semaine",
  weekday: "Jour ouvrable",
  month: "Mois",
  firstName: "Prénom",
  lastName: "Nom de famille",
  address: "Adresse",
  description: "Description",
  total: "Total",
  selectRoom: "Sélectionner une pièce",
  selectDescription: "Sélectionner une description",
  addNew: "Ajouter nouveau",
  revoke: "Révoquer",
  assign: "Attribuer",
  save: "Enregistrer",
  saveComment: "Enregistrer le commentaire",
  create: "Créer",
  savePublishTask: "Enregistrer et publier la tâche",
  accept: "Accepter",
  accepted: "Accepté",
  complete: "Terminer",
  back: "Retour",
  ok: "Ok",
  next: "Suivant",
  saveChanges: "Enregistrer les modifications",
  cancelChanges: "Annuler les modifications",
  more: "Plus",
  remove: "Retirer",
  changePhoto: "Changer la photo",
  booking: "Réservation",
  enterBooking: "Saisir une réservation",
  user: "Utilisateur",
  promo: "Promo",
  themeColor: "Couleur du thème",
  selectProject: "Sélectionner un projet",
  shop: "Boutique",
  cart: "Panier",
  checkout: "Paiement",
  product: "Produit",
  removeProduct: "Retirer Produit",
  noItemFound: "Aucun article trouvé",
  saas: "SAAS",
  multilevel: "Multi-niveaux",
  level1: "Niveau 1",
  level2: "Niveau 2",
  imageCropper: "Rogneur d'image",
  videoPlayer: "Lecteur vidéo",
  dropzone: "Dropzone",
  cropImage: "Rogner l'image",
  preview: "Aperçu",
  projects: "Projets",
  projectDetail: "Détail du projet",
  clients: "Clients",
  shipments: "Expéditions",
  editShipment: "Modifier l'expédition",
  viewShipment: "Voir l'expédition",
  newShipment: "Nouvelle expédition",
  loadBy: "Charger par",
  createShipment: "Créer une expédition",
  products: "Produits",
  latestScan: "Dernier scan",
  dateOfLoading: "Date de chargement",
  editProduct: "Modifier le produit",
  newProduct: "Nouveau produit",
  noProductsToShow: "Aucun Produit à afficher",
  theProductWasRemovedSuccesfully: "Le produit a été supprimé avec succès",
  containers: "Conteneurs",
  settings: "Paramètres",
  cartonQuantity: "Quantité de cartons",
  palletQuantity: "Quantité de palettes",
  despatches: "Expéditions",
  edit: "Modifier",
  details: "Détails",
  detail: "Détail",
  locations: "Emplacements",
  comments: "Commentaires",
  estimatedDates: "Dates estimées",
  destinationWh: "Entrepôt de Destination",
  vessel: "Navire",
  vesselName: "Nom du navire",
  travel: "Voyage",
  container: "Conteneur",
  containerType: "Type de conteneur",
  selectContainerType: "Sélectionner le type de conteneur",
  shipmentType: "Type d'expédition",
  containerNumbers: "Numéros de conteneur",
  grossWeight: "Poids Brut",
  inputWeight: "Saisir le poids",
  project: "Projet",
  totalQuantity: "Quantité totale",
  totalPallets: "Total des palettes",
  eta: "ETA",
  etaFinalPort: "ETA Port final",
  etaWarehouse: "ETA Entrepôt",
  pickUpDate: "Date d'Enlèvement",
  scanDate: "Date de scan",
  departureDate: "Date de Départ",
  arrivalAtDestination: "Date de Livraison",
  hawb: "HAWB",
  flightNumber: "Numéro de vol",
  airline: "Compagnie aérienne",
  etaUnpackData: "ETA données de déballage",
  actualDates: "Dates réelles",
  agent: "Agent",
  agentId: "ID de l'Agent",
  agentParentCode: "ID parent de l'agent",
  email: "E-mail",
  businessAddress: "Adresse professionnelle",
  businessContacts: "Contacts professionnels",
  businessName: "Raison sociale",
  businessNumber: "Numéro Professionnel",
  businessRegistration: "Enregistrement commercial",
  businessRegistrationNumber: "Numéro d'enregistrement commercial",
  mainEmailAddress: "Adresse e-mail principale",
  website: "Site web",
  bodyType: "Type de carrosserie",
  fuelType: "Type de carburant",
  condition: "État",
  engine: "Moteur",
  ownership: "Propriété",
  branch: "Agence",
  fleetStatus: "Statut de la flotte",
  dryStandard: "Standard sec",
  dryHigh: "Hauteur sèche",
  tank: "Tank",
  open: "Ouvert",
  openTop: "Toit ouvert",
  openTopHigh: "Toit ouvert haut",
  flat: "Plat",
  flatStandard: "Plat standard",
  flatHigh: "Plat haut",
  reeferStandard: "Réfrigéré standard",
  reeferHigh: "Réfrigéré haut",
  po: "PO #",
  sku: "SKU",
  itemRemovedSuccessfully: "Article supprimé avec succès !",
  import: "Importer",
  export: "Exporter",
  importCsvFile: "Importer un fichier CSV",
  printDeliveryDocket: "Imprimer le bon de livraison",
  despatch: "Expédition",
  qtyOfCartonsDespatched: "Qté de cartons expédiés",
  qtyOfPalletsDespatched: "Qté de palettes expédiées",
  ofDespatches: "# d'expéditions",
  ofOrdersDespatched: "# de commandes expédiées",
  stockOnHand: "Stock disponible",
  stockOnHandDetailed: "Stock disponible - Détaillé",
  crossDockStatus: "Statut cross-dock",
  packing: "Emballage",
  addMaterial: "Ajouter un matériau",
  fillAllFieldsToSave: "Remplir tous les champs pour enregistrer",
  addItem: "Ajouter un article",
  instructionStatus: "Statut de l'instruction",
  selectWhen: "Sélectionner quand",
  addInstruction: "Ajouter une instruction",
  availableInstructions: "Instructions disponibles",
  remark: "Remarque",
  inputYourRemarkAndPressEnter: "Saisissez votre remarque et appuyez sur Entrée",
  uplift: "Majoration",
  coordinator: "Coordinateur",
  selectedInstructions: "Instructions sélectionnées",
  selectAStatus: "Sélectionner un statut",
  applyChooseLocations: "Appliquer et choisir les emplacements",
  filterConditions: "Filtrer les conditions",
  filterLocations: "Filtrer les emplacements",
  conditions: "Conditions",
  typeOfPacking: "Type d'emballage",
  itemStatus: "Statut de l'article",
  itemNumber: "Numéro d'article",
  width: "Largeur",
  length: "Longueur",
  leader: "Responsable",
  searchLeader: "Rechercher un responsable",
  staffs: "Personnel",
  searchForStaff: "Rechercher du personnel",
  fleets: "Flottes",
  searchForFleet: "Rechercher une flotte",
  height: "Hauteur",
  cartonPerPallet: "Carton par palette",
  palletHeight: "Hauteur de palette",
  heightWithPallet: "Hauteur avec palette",
  heightIncPallet: "Hauteur incluant palette",
  ti: "Ti",
  hi: "Hi",
  selectProductsBelowToAddThem: "Sélectionnez les produits ci-dessous pour les ajouter",
  productSkuSearch: "Recherche produit (SKU)",
  productName: "Nom du produit",
  shippingItem: "Article d'expédition",
  truckTransport: "Camion/Transport",
  customerName: "Nom du client",
  addNewProject: "Ajouter un nouveau projet",
  projectName: "Nom du projet",
  projectCustomer: "Client du projet",
  importFiles: "Importer des fichiers",
  fileHistory: "Historique des fichiers",
  projectCreatedWithSuccess: "Projet créé avec succès !",
  uploadNewFile: "Téléverser un nouveau fichier",
  imapHost: "Hôte IMAP",
  imapPort: "Port IMAP",
  emailUser: "Utilisateur e-mail",
  emailPassword: "Mot de passe e-mail",
  useTls: "Utiliser TLS",
  addNewComment: "Ajouter un nouveau commentaire",
  typeYourCommentHere: "Saisissez votre commentaire ici",
  order: "Commande",
  origin: "Origine",
  destination: "Destination",
  type: "Type",
  dateCreated: "Date de création",
  dateUpdated: "Date de mise à jour",
  buyerName: "Nom de l'acheteur",
  shipVia: "Expédier via",
  shipTo: "Expédier à",
  incoterm: "Incoterm",
  createNewSupplier: "Créer un nouveau fournisseur",
  fulfilled: "Exécuté",
  quantityOrdered: "Quantité commandée",
  quantityRequested: "Quantité demandée",
  quantityFullfilled: "Quantité exécutée",
  variation: "Variation",
  switchToActualInventory: "Passer à l'inventaire réel",
  switchToQuotedInventory: "Passer à l'inventaire estimé",
  switchToEstimatedInventory: "Switch to Estimé Inventaire",
  searchByNameOrEmail: "Rechercher par nom ou e-mail",
  supplierDetails: "Fournisseur Détails",
  supplier: "Fournisseur",
  supplierName: "Nom du Fournisseur",
  supplierCode: "Code Fournisseur",
  address1: "Adresse 1",
  address2: "Adresse 2",
  suburbTown: "Quartier/Ville",
  streetNumber: "Street Numéro",
  postalCode: "Code Postal",
  state: "État/Région",
  country: "Pays",
  contactName: "Nom du Contact",
  locationStatus: "Emplacement status",
  filterByShipment: "Filtrer par n° d'expédition",
  noInformationToBeShown: "Aucune information à afficher.",
  loadingShipments: "Loading Expéditions",
  loadingDispatches: "Chargement des expéditions",
  loadingSuppliers: "Loading Fournisseurs...",
  loadingNotifications: "Chargement des notifications",
  task: "Tâche",
  usedBy: "Utilisé par",
  fleetNumber: "Flotte number",
  make: "Marque",
  model: "Modèle",
  body: "Carrosserie",
  position: "Position",
  username: "Nom d'utilisateur",
  location: "Emplacement",
  mainContact: "Contact Principal",
  role: "Rôle",
  rooms: "Pièces",
  fullName: "Nom complet",
  symbol: "Symbole",
  decimalPoints: "Décimales",
  lastUpdate: "Dernière Mise à Jour",
  lastModified: "Dernière Modification",
  flatFee: "Frais Fixes",
  hourlyFee: "Frais Horaires",
  halfHourFee: "Frais de demi-heure",
  triggers: "Déclencheurs",
  tasksType: "Type de Tâches",
  jobsType: "Type de Travaux",
  branches: "Agences",
  updated: "Mis à jour",
  color: "Couleur",
  icon: "Icône",
  packaging: "Emballage",
  configuration: "Configuration",
  currency: "Devise",
  currencies: "Devises",
  measurements: "Mesures",
  addCustomCurrency: "Ajouter une devise personnalisée",
  displayUnit: "Unité d'affichage",
  languages: "Langues",
  prefix: "Préfixe",
  language: "Langue",
  room: "Pièce",
  types: "Types",
  descriptiveSymbol: "Symbole descriptif",
  descriptiveSymbols: "Symboles descriptifs",
  exceptionSymbol: "SYMBOLE D'EXCEPTION",
  exceptionSymbols: "Symboles d'exception",
  locationSymbol: "SYMBOLE DE LIEU",
  locationSymbols: "Emplacement Symbols",
  photoIsMandatory: "La photo est obligatoire",
  selectTheRoom: "Sélectionner la pièce",
  editRoom: "Modifier room",
  addNewType: "Ajouter un nouveau type",
  editType: "Modifier type",
  addNewDescriptiveSymbol: "Ajouter un nouveau symbole descriptif",
  selectSymbol: "Sélectionner Symbol",
  editDescriptiveSymbol: "Modifier descriptive symbol",
  addNewExceptionSymbol: "Ajouter un nouveau symbole d'exception",
  editExceptionSymbol: "Modifier exception symbol",
  addNewLocationSymbol: "Ajouter un nouveau symbole de lieu",
  editLocationSymbol: "Modifier location symbol",
  addNewOne: "Ajouter un nouveau",
  createFleet: "Créer une Flotte",
  editFleet: "Modifier la Flotte",
  viewFleet: "Voir la Flotte",
  editThisFleet: "Modifier cette flotte",
  addANewFleet: "Ajouter une nouvelle flotte",
  viewThisFleet: "Voir cette flotte",
  vinNumber: "Numéro VIN",
  year: "Année",
  engineType: "Type de Moteur",
  plateNumber: "Numéro de Plaque",
  addCondition: "Ajouter Condition",
  typeMode: "Type de mode",
  warehouse: "Entrepôt",
  searchForWarehouse: "Rechercher un entrepôt",
  searchForBranch: "Rechercher une agence",
  capacity: "Capacité",
  capacityOfEachLiftvan: "Capacité de chaque liftvan",
  volumeCapacityM3: "Capacité volumique (m³)",
  weightCapacityKG: "Poids Capacity (Kg)",
  outOfService: "Hors service",
  serialNumber: "Numéro de Série",
  inputSerialNumber: "Saisir le numéro de série",
  mechanicalElectricalChecklist: "Liste de contrôle mécanique et électrique",
  hasTheMEChecklistBeenDoneOnThisItem: "La liste de contrôle M&E a-t-elle été faite sur cet article ?",
  isItWorking: "Est-ce que ça fonctionne ?",
  userDetails: "Détails de l'Utilisateur",
  permissions: "Autorisations",
  placeName: "Nom du lieu",
  local: "Local",
  companyId: "ID de l'entreprise",
  suppliers: "Fournisseurs",
  newSupplier: "Nouveau Fournisseur",
  viewSupplier: "Voir le Fournisseur",
  editSupplier: "Modifier le Fournisseur",
  printSupplier: "Imprimer Fournisseur",
  editPlace: "Modifier le Lieu",
  newPlace: "Nouveau Lieu",
  newUser: "Nouvel Utilisateur",
  createdAt: "Créé le",
  voyage: "Voyage",
  voyageNumber: "Numéro de Voyage",
  voyageStatus: "Statut du Voyage",
  voyageInformation: "Informations sur le voyage",
  containerNumber: "Numéro de Conteneur",
  inputContainer: "Saisir le Conteneur",
  inputShipment: "Saisir l'expédition",
  internalReference: "Référence Interne",
  exportShipment: "Exporter l'Expédition",
  eventProductUpdate: "Mise à jour produit",
  importProductsEvents: "Importer les événements produits",
  view: "Voir",
  close: "Fermer",
  closed: "Fermé",
  closedForInvoicing: "Fermé pour facturation",
  closedForReceiving: "Fermé pour réception",
  createNetwork: "Créer un réseau",
  createCustomer: "Créer un client",
  createAgent: "Créer un agent",
  createSupplier: "Créer un fournisseur",
  linkAccounts: "Lier les comptes",
  understood: "Compris",
  productEvents: "Événements Produit",
  birthDate: "Date de Naissance",
  emergencyName: "Nom d'urgence",
  emergencyPhone: "Téléphone d'urgence",
  emergencyRelationship: "Relation d'urgence",
  gender: "Genre",
  skills: "Compétences",
  residencyStatus: "Statut de résidence",
  certificates: "Certificats",
  addressLine1: "Ligne d'Adresse 1",
  addressLine2: "Ligne d'Adresse 2",
  suburb: "Banlieue",
  staffStatus: "Statut du Personnel",
  staffMnt: "Personnel - MNT",
  editStaff: "Modifier le Personnel",
  newStaff: "Nouveau Personnel",
  saveAsUser: "Enregistrer comme Utilisateur",
  yourPasswordMustBeAtLeast12CharactersLong: "Votre mot de passe doit comporter au moins 12 caractères",
  yourPasswordMustContainAtLeastOneSpecialCharacter:
    "Votre mot de passe doit contenir au moins un caractère spécial",
  pleaseEnterYourPassword: "Veuillez entrer votre mot de passe",
  yourPasswordMustBeAtMaximumOf30CharactersLong:
    "Votre mot de passe ne doit pas dépasser 30 caractères",
  pleaseEnterAValidPhoneNumber: "Veuillez entrer un numéro de téléphone valide",
  phoneNumber: "Numéro de téléphone",
  pleaseEnterALastName: "Veuillez entrer un nom de famille",
  yourLastNameMustBeAtLeast4CharactersLong: "Votre nom de famille doit comporter au moins 4 caractères",
  pleaseEnterAFirstName: "Veuillez entrer un prénom",
  yourFirstNameMustBeAtLeast4CharactersLong: "Votre prénom doit comporter au moins 4 caractères",
  pleaseEnterAName: "Veuillez entrer un nom",
  yourNameMustBeAtLeast4CharactersLong: "Votre nom doit comporter au moins 4 caractères",
  yourRegistrationNumberMustBeAtLeast4CharactersLong:
    "Votre numéro d'immatriculation doit comporter au moins 4 caractères",
  pleaseEnterAPhoneNumber: "Veuillez entrer un numéro de téléphone",
  yourPhoneMustBeAtLeast6CharactersLong: "Votre téléphone doit comporter au moins 6 caractères",
  yourWebMustBeAtLeast4CharactersLong: "Votre site web doit comporter au moins 4 caractères",
  pleaseEnterAAddressLine: "Veuillez entrer une ligne d'adresse",
  yourAddressLineMustBeAtLeast4CharactersLong:
    "Votre ligne d'adresse doit comporter au moins 4 caractères",
  pleaseEnterASuburb: "Veuillez entrer un quartier",
  yourSuburbMustBeAtLeast4CharactersLong: "Votre quartier doit comporter au moins 4 caractères",
  pleaseEnterAStateNumber: "Veuillez entrer un numéro d'état/région",
  yourStateMustBeAtLeast3CharactersLong: "Votre état/région doit comporter au moins 3 caractères",
  pleaseEnterAPostalCodeNumber: "Veuillez entrer un code postal",
  yourPostalCodeMustBeAtLeast4CharactersLong: "Votre code postal doit comporter au moins 4 caractères",
  pleaseEnterACountry: "Veuillez entrer un pays",
  yourCountryMustBeAtLeast4CharactersLong: "Votre pays doit comporter au moins 4 caractères",
  newItemSType: "Type du nouvel article",
  editItemSType: "Modifier le type d'article",
  newItemSDescription: "Description du nouvel article",
  editItemSDescription: "Modifier la description de l'article",
  network: "Réseau",
  anErrorOccurredTryAgain: "Une erreur s'est produite, veuillez réessayer",
  operationPerformedSuccessfully: "Opération effectuée avec succès",
  resendWelcomeEmail: "Renvoyer l'e-mail de bienvenue",
  resendWelcomeEmailConfirmation: "Envoyer un e-mail de bienvenue à [name] ?",
  welcomeEmailSentSuccessfully: "E-mail de bienvenue envoyé avec succès",
  labelCreated: "Étiquette Créée",
  sunday: "Dimanche",
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  saturday: "Samedi",
  january: "Janvier",
  february: "Février",
  march: "Mars",
  april: "Avril",
  may: "Mai",
  june: "Juin",
  july: "Juillet",
  august: "Août",
  september: "Septembre",
  october: "Octobre",
  november: "Novembre",
  december: "Décembre",
  customerSTimeZone: "Fuseau horaire du client",
  startTime: "Heure de Début",
  endTime: "Heure de Fin",
  whatsapp: "WhatsApp",
  sms: "SMS",
  originAddress: "Adresse d'Origine",
  destinationAddress: "Adresse de Destination",
  active: "Actif",
  Active: "Actif",
  disabled: "Désactivé",
  sendToAmos: "Envoyer to AMOS",
  printReports: "Imprimer reports",
  cancelOrder: "Annuler la commande",
  cancelQuote: "Annuler le devis",
  inactive: "Inactif",
  Inactive: "Inactif",
  invertStatuses: "Inverser les statuts",
  filterByStatus: "Filtrer par Statut",
  activeInactive: "Actif / Inactif",
  selectType: "Sélectionner le type",
  selectStatus: "Sélectionner le statut",
  userCode: "Code utilisateur",
  enterUserCode: "Entrer le code utilisateur",
  emailAddress: "Adresse E-mail",
  mobileNumber: "Numéro de portable",
  contactType: "Type de contact",
  enterHere: "Saisir ici",
  dateOfBirth: "Date de naissance",
  typeOfUser: "Type d'utilisateur",
  thisUserIsALeader: "Cet utilisateur est un responsable",
  checkThisBoxIfTheUserAboveIsAlsoALeader: "Cochez cette case si l'utilisateur ci-dessus est aussi un responsable",
  useEmailAddress: "Utiliser l'adresse e-mail",
  citySuburb: "Ville / Quartier",
  postcode: "Code postal",
  countryOrRegion: "Pays ou région",
  timezone: "Fuseau horaire",
  enterFirstName: "Entrer le prénom",
  enterLastName: "Entrer le nom de famille",
  dateNumberFormat: "Format de date / nombre",
  defaultCurrency: "Par défaut currency",
  userInactive: "Utilisateur Inactif",
  roles: "Rôles",
  communications: "Communications",
  communicationSubscriptions: "Abonnements aux communications",
  searchByEnter: "Rechercher en appuyant sur Entrée",
  approve: "Approuver",
  decline: "Refuser",
  activeNetwork: "Actif Réseau",
  invites: "Invitations",
  reject: "Rejeter",
  approved: "Approuvé",
  waitingForApproval: "En attente d'approbation",
  sendToReview: "Envoyer to review",
  automaticallyInvitationSentBy: "Invitation envoyée automatiquement par",
  importerExporter: "Importateur et Exportateur",
  newRole: "Nouveau Rôle",
  editRole: "Modifier le Rôle",
  continue: "Continuer",
  saveWithoutAssigning: "Enregistrer without assigning",
  saveAndAssign: "Enregistrer et attribuer",
  createRole: "Créer un rôle",
  createRoom: "Créer une pièce",
  updateRole: "Mettre à jour le rôle",
  assignUser: "Attribuer un utilisateur",
  productSIsRequired: "Produit(s) requis !",
  roleName: "Nom du rôle",
  roleDescriptionOptional: "Rôle description (optional)",
  quoteAssignedTo: "Devis assigned to",
  manager: "Responsable",
  searchForManager: "Rechercher un responsable",
  youMustEnterAnEntityName: "*Vous devez entrer un nom d'entité",
  youMustEnterAnAddress: "*Vous devez entrer une adresse",
  youMustEnterASuburbTown: "*Vous devez entrer un quartier/ville",
  youMustEnterAState: "*Vous devez entrer un état/région",
  youMustEnterACountry: "*Vous devez entrer un pays",
  youMustEnterAPostalcode: "*Vous devez entrer un code postal",
  youMustEnterARegistrationNumber: "*Vous devez entrer un numéro d'immatriculation",
  youMustEnterABillingEmail: "*Vous devez entrer un e-mail de facturation",
  youMustEnterAMobile: "*Vous devez entrer un numéro de mobile",
  youMustEnterATimezone: "*Vous devez entrer un fuseau horaire",
  youMustEnterAConsultant: "*Vous devez entrer un consultant",
  youMustEnterAContactPerson: "*Vous devez entrer une personne de contact",
  youMustEnterAFirstName: "*Vous devez entrer un prénom",
  youMustEnterALastName: "*Vous devez entrer un nom de famille",
  youMustEnterAnEmail: "*Vous devez entrer un e-mail",
  youMustEnterAName: "*Vous devez entrer un nom",
  youMustEnterAPhoneNumber: "*Vous devez entrer un numéro de téléphone",
  youMustEnterAParentCode: "*Vous devez entrer un numéro ID parent",
  youMustEnterALocationName: "*Vous devez entrer un nom d'emplacement",
  youMustEnterAStatus: "*Vous devez entrer un statut",
  youMustEnterAnEstablishedYear: "*Vous devez entrer une année de création",
  youMustEnterASince: "*Vous devez entrer une date de création",
  youMustEnterAnEntityLegalName: "*Vous devez entrer un nom légal d'entité",
  youMustEnterAWebsite: "*Vous devez entrer un site web",
  youMustEnterAContactName: "*Vous devez entrer un nom de contact",
  youMustEnterAContactType: "*Vous devez entrer un type de contact",
  startTypingToSearchDots: "Commencez à taper pour rechercher...",
  established: "Fondé",
  establishedYear: "Année de création",
  since: "Depuis",
  entity: "Entité",
  entityLegalName: "Nom légal de l'entité",
  mobile: "Portable",
  customerDetails: "Détails du Client",
  editCustomer: "Modifier le client",
  useTheSameAddressForPostalAddress: "Même adresse pour l'Adresse Postale?",
  registrationNumber: "Numéro d'immatriculation",
  addAnotherContact: "Ajouter un autre contact",
  includeInEmail: "Inclure dans l'e-mail",
  consultant: "Consultant",
  searchConsultant: "Rechercher un Consultant",
  searchWarehouse: "Rechercher un Entrepôt",
  searchTimezone: "Rechercher un Fuseau Horaire",
  billingEmail: "E-mail de Facturation",
  postalAddress: "Adresse Postale",
  contact: "Contact",
  contactPerson: "Personne de contact",
  invalidLink: "Lien invalide",
  closeWindow: "Fermer la fenêtre",
  youHaventAcceptedTheInvitation: "Vous n'avez pas accepté l'invitation",
  thisLinkIsNotValidPleaseCheckIfYouHaveAccessedTheCorrectLink:
    "Ce lien n'est pas valide. Veuillez vérifier que vous avez accédé au bon lien.",
  youCanSafelyCloseThisWindowNowIfYouNeedAnyFurtherAssistanceFeelFreeToReachOutHaveAGreatDay:
    "Vous pouvez fermer cette fenêtre en toute sécurité. Si vous avez besoin d'aide supplémentaire, n'hésitez pas à nous contacter. Bonne journée !",
  enterLocationName: "Entrer le nom de l'emplacement",
  enterWebsite: "Entrer le site web",
  enterRegistrationNumber: "Entrer le numéro d'immatriculation",
  primaryContact: "Principal Contact",
  createLocation: "Créer un Lieu",
  viewLocation: "Voir le Lieu",
  editLocation: "Modifier le Lieu",
  jobType: "Type de travail",
  warehouseOrigin: "Entrepôt d'Origine",
  warehouseDestination: "Entrepôt de Destination",
  tag: "Étiquette",
  billingAs: "Facturation comme :",
  leadSourceFrom: "Source du prospect",
  moveCoordinator: "Coordinateur de déménagement",
  inventoryQuoted: "Inventaire devisé",
  inventoryLeader: "Responsable de l'inventaire",
  inventoryActual: "Inventaire réel",
  myDetails: "Mes détails",
  orderDetails: "Détails de la commande",
  actualAsQuoted: "Réel comme Devisé",
  movingFrom: "Déménagement de",
  movingTo: "Déménagement à",
  itemQuantity: "Quantité d'articles",
  inventories: "Inventaires",
  originContact: "Contact d'origine",
  destinationContact: "Contact de destination",
  seeAccessChecklist: "See Accès Checklist",
  pickupAccessDetails: "Détails d'Accès Enlèvement",
  deliveryAccessDetails: "Détails d'Accès Livraison",
  noContactsAdded: "Aucun contact ajouté",
  complement: "Complément",
  street: "Rue",
  typeOfBuilding: "Type de bâtiment",
  loadingDockHeight: "Hauteur du quai de chargement",
  liftAvailable: "Ascenseur disponible",
  accessInstructions: "Instructions d'accès",
  navigationNotes: "Notes de navigation",
  createYourShipeeziAccount: "Créer votre compte Shipeezi",
  createAccount: "Créer un compte",
  haveAnAccountSignIn: "Vous avez un compte? Connectez-vous",
  mode: "Mode",
  service: "Service",
  editOrder: "Modifier la Commande",
  newOrder: "Nouvelle Commande",
  weight: "Poids",
  truckType: "Type de camion",
  carrier: "Transporteur",
  truckBookingNumber: "Numéro de Réservation Camion",
  trackingNumber: "Numéro de suivi",
  palletsPerTruck: "Palettes par Camion",
  deliveryDate: "Date de Livraison",
  proposedDeliveryDate: "Date de Livraison Proposée",
  bookingDetails: "Détails de la Réservation",
  deliveryAddress: "Adresse de Livraison",
  deliveryAddressLine: "Ligne d'Adresse de Livraison",
  deliveryAddressSuburb: "Banlieue de l'Adresse de Livraison",
  receiver: "Destinataire",
  senderAddress: "Adresse de l'Expéditeur",
  senderAddressLine: "Ligne d'Adresse Expéditeur",
  senderAddressSuburb: "Banlieue de l'Adresse Expéditeur",
  palletsQty: "Qté de Palettes",
  cartonQty: "Qté de Cartons",
  despatchDate: "Date d'Expédition",
  pleaseEnterAYourFirstName: "*Veuillez entrer votre prénom.",
  pleaseEnterAYourLastName: "*Veuillez entrer votre nom de famille.",
  pleaseEnterAYourEmailAddress: "*Veuillez entrer votre adresse e-mail.",
  pleaseEnterAPassword: "*Veuillez entrer un mot de passe.",
  pleaseConfirmAPassword: "*Veuillez confirmer un mot de passe.",
  pleaseEnterAUsername: "*Veuillez entrer un nom d'utilisateur.",
  pleaseEnterAMobilePhone: "*Veuillez entrer un téléphone mobile.",
  atLeastOnePhotoIsRequired: "*Au moins une photo est requise",
  atLeastOneProductIsRequired: "Au moins un produit est requis",
  thisEmailIsInvalid: "*Cet e-mail est invalide",
  thisFieldIsRequired: "Ce champ est obligatoire",
  selectAnAccessRule: "Sélectionner une règle d'accès",
  youNeedToSelectAtLeastOneBranch: "*Vous devez sélectionner au moins une agence",
  youNeedToSelectAtLeastOneSection: "*Vous devez sélectionner au moins une section",
  youNeedToSelectAtLeastOneContact: "*Vous devez sélectionner au moins un contact",
  youMustEnterACustomer: "*Vous devez entrer un client",
  youMustEnterAEmail: "*Vous devez entrer un e-mail",
  youMustEnterAnMobile: "*Vous devez entrer un numéro de mobile",
  youMustHaveAtLeastOneLocation: "*Vous devez avoir au moins un emplacement",
  youMustHaveAtLeastOnePrimaryLocation: "*Vous devez avoir au moins un emplacement principal",
  pleaseEnterAValidEmail: "*Veuillez entrer un e-mail valide",
  quoted: "Devisé",
  actual: "Réel",
  totalItems: "Total des articles",
  registered: "Enregistré",
  loaded: "Chargé",
  taken: "Pris",
  delivered: "Livré",
  void: "Nul",
  disposal: "Élimination",
  missing: "Manquant",
  missingShipment: "Expédition manquante",
  shipped: "Expédié",
  packed: "Emballé",
  uplifted: "Chargé",
  bol: "Connaissement",
  selectNewStatusForItem: "Sélectionner un nouveau statut pour l'article",
  item: "Article",
  items: "Articles",
  packer: "Emballeur",
  selectPacker: "Sélectionner l'Emballeur",
  selectNewStatusForItems: "Sélectionner un nouveau statut pour les articles",
  newStatus: "Nouveau statut",
  changeItemsStatus: "Changer le statut des articles",
  addNewItem: "Ajouter un nouvel article",
  createNewItem: "Créer un nouvel article",
  addNewRoom: "Ajouter une Nouvelle Pièce",
  editItem: "Modifier l'Article",
  viewItem: "Voir l'Article",
  createNewOne: "Créer + Nouveau",
  comment: "Commentaire",
  createNewComment: "Créer un nouveau commentaire",
  newComment: "Nouveau commentaire",
  commentBy: "Commentaire de",
  hideCommentHistory: "Masquer l'historique des commentaires",
  seeCommentHistory: "Voir l'historique des commentaires",
  copyInfoFromPickup: "Copier les infos de l'Enlèvement",
  copyInfoFromDelivery: "Copier les infos de la Livraison",
  pickup: "enlèvement",
  pickUp: "Enlèvement",
  delivery: "Livraison",
  switchToManual: "Passer à la saisie manuelle d'adresse",
  switchToGoogle: "Passer à la saisie Google Maps",
  addAnotherAddress: "Ajouter une autre adresse",
  selectATask: "Sélectionner une tâche",
  enterADateInField: "Saisir une date dans le champ",
  theSurveyDateMustBeGreaterThanTheCurrentDate:
    "La date de la visite doit être postérieure à la date actuelle",
  time: "Heure",
  date: "Date",
  addATask: "Ajouter une tâche",
  enterOnTheVideoSurvey: "Accéder à la visite vidéo",
  startVideoSurvey: "Démarrer la visite vidéo",
  scheduleAVideoSurvey: "Planifier une Visite Vidéo",
  thisDateIsInvalid: "Cette date est invalide",
  notAvailable: "Non disponible",
  addATaskHomeSurveyOrVideoSurveyToCreateAQuote:
    "Ajoutez une tâche Visite à domicile ou Visite vidéo pour créer un devis",
  pickupAccess: "Accès Enlèvement",
  deliveryAccess: "Accès Livraison",
  switchToPickupAccess: "Basculer vers l'accès enlèvement",
  switchToDeliveryAccess: "Basculer vers l'accès livraison",
  duplicate: "Dupliquer",
  willTheEntryOfTheHouseBeObstructed: "L'entrée de la maison sera-t-elle obstruée?",
  driveway: "Allée",
  steep: "Raide",
  long: "Long",
  whatIsTheLengthM: "Quelle est la longueur (m) ?",
  residence: "Résidence",
  residenceType: "Type de résidence",
  house: "Maison",
  apartment: "Appartement",
  level: "Niveau",
  howManyLevels: "Combien d'étages?",
  groundFloor: "Rez-de-chaussée",
  split: "Duplex",
  multiStorey: "Multi-étages",
  steps: "Étapes",
  notAuthorizedByCustomer: "Non autorisé par le client",
  photos: "Photos",
  addPhoto: "Ajouter une photo",
  hasLift: "A un ascenseur?",
  lift: "Ascenseur",
  internal: "Interne",
  external: "Externe",
  streetAccess: "Accès par la Rue",
  wide: "Large",
  narrow: "Étroit",
  step: "Étape",
  normal: "Normal",
  permitRequired: "Permis requis",
  oneWay: "Sens unique",
  culDeSac: "Cul-de-sac",
  roundabout: "Rond-point",
  speedHumps: "Ralentisseurs",
  noThroughRoad: "Rue sans issue",
  road: "Route",
  sea: "Mer",
  air: "Aérien",
  ferry: "Ferry",
  storage: "Stockage",
  other: "Autre",
  parking: "Stationnement",
  parkingType: "Type de stationnement",
  carry: "Portage",
  carryM: "Portage(m)",
  treesPowerline: "Arbres/Lignes électriques",
  overhanging: "En surplomb",
  low: "Bas",
  action: "Action",
  vehicleSize: "Taille du véhicule",
  small: "Petit",
  rigid: "Rigide",
  semi: "Semi",
  isFerryRequired: "Un ferry est-il nécessaire?",
  saveAComment: "Enregistrer un commentaire",
  createComment: "Créer comment",
  saveABookmark: "Enregistrer un signet",
  takeAScreenshot: "Prendre une capture d'écran",
  accessDetailsDescribedAboveAreAccurateToTheBestOfMyKnowledge:
    "Les détails d'accès décrits ci-dessus sont exacts au meilleur de ma connaissance.",
  specialInstructions: "Instructions Spéciales",
  itemInstructionStatus: "Article instruction status",
  deleteAddress: "Supprimer l'adresse",
  thereAreItemsOrMaterialsRegisteredWithThisAddressIfYouDeleteThisAddressNowAllItemsWillBeRegisteredWithTheMainDeliveryAddressWouldYouLikeToDoThat:
    "Des articles ou matériaux sont enregistrés à cette adresse. Si vous supprimez cette adresse maintenant, tous les articles seront enregistrés à l'adresse de livraison principale. Souhaitez-vous continuer ?",
  inventory: "Inventaire",
  itemDetails: "Détails de l'article",
  materialDetails: "Matériau - Détails",
  addAnother: "Ajouter un Autre",
  fileIsTooBigMax2Mb: "Fichier trop volumineux (Max 2Mo)",
  thisFileExtensionIsNotAllowed: "Cette extension de fichier n'est pas autorisée",
  fileIsTooBigMax8Mb: "Fichier trop volumineux (Max 8Mo)",
  fileAlreadyExistsInThisFolder: "Le fichier existe déjà dans ce dossier",
  anotherFolderWithThisNameAlreadyExists: "Un autre dossier avec ce nom existe déjà",
  newFolder: "Nouveau Dossier",
  upload: "Téléverser",
  uploading: "Téléversement",
  uploadingYourContent: "Téléversement de votre contenu",
  share: "Partager",
  shared: "Partagé",
  unshare: "Arrêter le partage",
  notBeingShared: "Non partagé",
  stopSharing: "Arrêter le partage",
  cancelRequest: "Annuler la demande",
  requestDocument: "Demander un document",
  empty: "Vide",
  file: "Fichier",
  files: "Fichiers",
  folder: "Dossier",
  rename: "Renommer",
  currentStock: "Stock Actuel",
  theFolderNameIsRequired: "Le nom du dossier est obligatoire",
  theFileNameIsRequired: "Le nom du fichier est obligatoire",
  accessChecklistSummary: "Accès Checklist Résumé",
  selectAnOption: "Sélectionner une option",
  searchTask: "Rechercher une Tâche",
  anErrorOccuredTryAgain: "Une erreur est survenue, veuillez réessayer.",
  secondContact: "Deuxième contact",
  pleaseSelectAQuoteType: "Veuillez sélectionner un type de devis",
  pleaseFillAReference: "Veuillez remplir une référence",
  pleaseSelectAStatus: "Veuillez sélectionner un statut",
  pleaseSelectAConsultant: "Veuillez sélectionner un consultant",
  pleaseSelectAManager: "Veuillez sélectionner un responsable",
  pleaseSelectAMode: "Veuillez sélectionner un mode",
  pleaseFillPickUpCustomerFields: "Veuillez remplir les champs du client d'enlèvement",
  pleaseFillPickUpAddressFields: "Veuillez remplir les champs d'adresse d'enlèvement",
  pleaseFillDeliveryCustomerFields: "Veuillez remplir les champs du client de livraison",
  pleaseFillDeliveryAddressFields: "Veuillez remplir les champs d'adresse de livraison",
  pleaseCheckTheAccessDetailsDescribedOnPickupAccess:
    "Veuillez vérifier les détails d'accès décrits dans l'accès d'enlèvement",
  customRange: "Personnalisé Range",
  summaryFromSales: "Résumé des ventes",
  toAddAnOrderClickOnTheButtonBelow: "Pour ajouter une commande, cliquez sur le bouton ci-dessous.",
  addOrderToAShipment: "Ajouter une commande à une expédition",
  addOrder: "Ajouter Commande",
  addOrders: "Ajouter Commandes",
  changeOrderToAShipment: "Changer la commande vers une expédition",
  selectShipmentsBelowToAddThem: "Sélectionnez les expéditions ci-dessous pour les ajouter.",
  matchOrigin: "Correspondance origine",
  matchDestination: "Correspondance destination",
  notSent: "Not Envoyé",
  shipmentOrigin: "Origine de l'Expédition",
  shipmentDestination: "Destination de l'Expédition",
  portName: "Nom du Port",
  airportName: "Nom de l'Aéroport",
  recordDeleted: "Enregistrement supprimé",
  noVideoRecorded: "Aucune vidéo enregistrée",
  noCommentsRegistered: "Aucun commentaire enregistré",
  noScreenshotsRegistered: "Aucune capture d'écran enregistrée",
  noBookmarksRegistered: "Aucun favori enregistré",
  videoSurvey: "Visite Vidéo",
  videos: "Vidéos",
  communication: "Communication",
  document: "Document",
  documents: "Documents",
  documentSharing: "Partage de documents",
  documentsForThisBooking: "Documents pour cette réservation",
  map: "Carte",
  costing: "Coûts",
  addProduct: "Ajouter un Produit",
  addProducts: "Ajouter des Produits",
  addProductToCarton: "Ajouter un produit au carton",
  sendEmail: "Envoyer un E-mail",
  sendSMS: "Envoyer un SMS",
  attachmentFailedPleaseTryAgainLater: "Pièce jointe échouée. Veuillez réessayer plus tard !",
  clickToViewJson: "Cliquer pour voir le JSON",
  closeJsonFile: "Fermer le fichier JSON",
  invalidEmailFormat: "Format d'e-mail invalide",
  emailSuccessfullySent: "E-mail envoyé avec succès !",
  somethingWentWrongPleaseTryAgain: "Quelque chose s'est mal passé. Veuillez réessayer !",
  typeTheEmailAddressEnter: "Saisissez l'adresse e-mail + Entrée",
  addGroupCosting: "Ajouter un groupe de coûts",
  deleteConfirmation: "Confirmation de Suppression",
  areYouSureYouWantToRemoveThisItem: "Êtes-vous sûr de vouloir retirer cet article ?",
  selectAtLeastOneItemToChangeStatus: "Sélectionnez au moins un article pour changer le statut",
  anItemWasAddToTheSelectedRoom: "Un article a été ajouté à la pièce sélectionnée",
  aRoomHasBeenAddedToTheInventory: "Une pièce a été ajoutée à l'inventaire",
  anItemWasUpdatedAtTheSelectedRoom: "Un article a été mis à jour dans la pièce sélectionnée",
  anItemWasRemovedFromTheSelectedRoom: "Un article a été retiré de la pièce sélectionnée",
  couldNotFindItemToDuplicate: "Impossible de trouver l'article à dupliquer",
  emailSentSuccesfuly: "E-mail envoyé avec succès !",
  smsSentSuccesfuly: "SMS envoyé avec succès !",
  couldNotSendEmail: "Impossible d'envoyer l'e-mail",
  ifAMatchingAccountWasFoundAnEmailWasSentTo:
    "Si un compte correspondant a été trouvé, un e-mail a été envoyé à",
  toAllowYouToResetYourPassword: "pour vous permettre de réinitialiser votre mot de passe.",
  isAnUser: "Est un utilisateur",
  isNotAnUser: "N'est pas un utilisateur",
  allContacts: "Tous les contacts",
  seeAllOfYourBusinessContacts: "Voir tous vos contacts professionnels",
  editContact: "Modifier le contact",
  addContact: "Ajouter un contact",
  addLocation: "Ajouter un lieu",
  addContactUser: "Ajouter un utilisateur contact",
  editContactUser: "Modifier l'utilisateur contact",
  viewAllContacts: "Voir tous les contacts",
  registerAsAnUser: "S'inscrire en tant qu'utilisateur",
  editThisBusinessContact: "Modifier ce contact professionnel",
  contactDetails: "Détails du contact",
  pleaseEnterARegistrationNumber: "Veuillez entrer un numéro d'immatriculation",
  otherDetails: "Autres détails",
  shipeeziNetwork: "Réseau Shipeezi",
  agentIsConnectedToTheShipeezisNetwork: "L'agent est connecté au réseau Shipeezi",
  inviteToNetwork: "Inviter dans le réseau",
  actions: "Actions",
  sortBy: "Trier par",
  inactiveCompany: "Entreprise inactive",
  billing: "Facturation",
  primary: "Principal",
  secondary: "Secondaire",
  general: "Général",
  generalPhoto: "Photo générale",
  overview: "Aperçu",
  manageUsers: "Gérer les utilisateurs",
  monthlyPayment: "Paiement mensuel",
  addSeats: "Ajouter des sièges",
  currentPlan: "Plan actuel",
  changePlan: "Changer de plan",
  lastPaidInvoice: "Dernière facture payée",
  billingDetails: "Détails de facturation",
  editPaymentDetails: "Modifier les détails de paiement",
  cardHolder: "Titulaire de la carte",
  creditCardNumber: "Numéro de carte de crédit",
  cvv: "CVV",
  expDate: "Date d'expiration",
  billingAddress: "Adresse de facturation",
  people: "Personnes",
  resources: "Ressources",
  configurations: "Configurations",
  preferences: "Préférences",
  orderType: "Type de commande",
  leadSource: "Source du prospect",
  statuses: "Statuts",
  integrations: "Intégrations",
  apiAllied: "API Allied",
  history: "Historique",
  checklistForms: "Listes de contrôle et formulaires",
  fleet: "Flotte",
  equimpent: "Équipement",
  staff: "Personnel",
  itemList: "Liste des Articles",
  packagingType: "Type d'emballage",
  modeType: "Type de mode",
  exceptionCodes: "Codes d'exception",
  exceptionLocationCode: "Code de lieu d'exception",
  materials: "Matériaux",
  instructions: "Instructions",
  itemDestination: "Article destination",
  automation: "Automatisation",
  access: "Accès",
  iso174511: "ISO17451-1:2016 - Certificate",
  createNewUser: "Créer un nouvel utilisateur",
  createNewRole: "Créer un nouveau rôle",
  createNewCustomer: "Créer un nouveau client",
  deleteCustomer: "Supprimer le client",
  deleteAgent: "Supprimer l'agent",
  deleteSelected: "Supprimer la sélection",
  typePressEnter: "Tapez + Appuyez sur Entrée",
  createUser: "Créer un utilisateur",
  viewUser: "Voir l'utilisateur",
  viewUsers: "Voir les utilisateurs",
  editUser: "Modifier l'utilisateur",
  useCompanyAddress: "Utiliser l'adresse de l'entreprise",
  timezoneIsUpdatedAutomaticallyToMatchYourComputerTimezone:
    "Le fuseau horaire est mis à jour automatiquement pour correspondre au fuseau horaire de votre ordinateur",
  inactiveUser: "Utilisateur Inactif",
  activeUser: "Utilisateur Actif",
  logUserOut: "Déconnecter l'utilisateur",
  searchAndSelectTheRoleTo: "Rechercher et sélectionner le rôle pour",
  assignUsers: "Attribuer users",
  searchAndSelectUsersTo: "Rechercher et sélectionner les utilisateurs pour",
  viewRole: "Voir le rôle",
  editThisRole: "Modifier ce rôle",
  viewThisRole: "Voir ce rôle",
  setPermissions: "Définir les autorisations",
  addANewItem: "Ajouter un nouvel article",
  viewAnItem: "Voir un article",
  editAnItem: "Modifier un article",
  editLocationForCustomer: "Modifier l'emplacement du client",
  createNewLocationForCustomer: "Créer un nouvel emplacement pour le client",
  viewLocationForCustomer: "Voir l'emplacement du client",
  editOrderType: "Modifier le type de commande",
  createNewOrderType: "Créer un nouveau type de commande",
  editLeadSource: "Modifier lead source",
  createNewLeadSource: "Créer une nouvelle source de prospect",
  leadSourceStatus: "Statut de la source du prospect",
  editStatus: "Modifier status",
  createNewStatus: "Créer un nouveau statut",
  itemName: "Nom de l'Article",
  itemCode: "Code de l'Article",
  itemVolume: "Volume de l'Article",
  itemWeight: "Poids de l'Article",
  photosAreMandatory: "Les photos sont obligatoires",
  brandIsMandatory: "La marque est obligatoire",
  commentIsMandatory: "Le commentaire est obligatoire",
  mEChecklistIsMandatory: "La liste de contrôle M&E est obligatoire",
  inactiveItem: "Inactif item",
  roomName: "Nom de la Pièce",
  roomCode: "Code de la Pièce",
  inactiveLocation: "Inactif Emplacement",
  editPackagingType: "Modifier Packaging Type",
  createPackagingType: "Créer Packaging Type",
  packagingTypeName: "Nom du type d'emballage",
  packagingTypeCode: "Code type d'emballage",
  yourComment: "Votre commentaire",
  packagingTypeStatus: "Statut du type d'emballage",
  reason: "Raison",
  code: "Code",
  enterTypeOfContact: "Entrer le type de contact",
  dimensions: "Dimensions",
  couldnTSubscribeShipment: "Impossible de s'abonner à l'expédition",
  couldnTRetrieveShipmentStatus: "Impossible de récupérer le statut de l'expédition",
  voyageStatusUpdated: "Statut du voyage mis à jour",
  pod: "Pod",
  pressEnterToAdd: "Appuyez sur Entrée pour ajouter",
  inputYourComments: "Saisissez vos commentaires",
  portOfDestination: "Port de Déchargement (PoD)",
  placeOfDestination: "Lieu de destination",
  containerGateInAtPol: "Entrée du conteneur au POL",
  containerGateInPort: "Entrée du conteneur au port",
  nextPort: "Suivant Port",
  containerLoadedAtFirstPolPortOfLoad: "Conteneur chargé au premier POL (port de chargement)",
  containerGateOutAtPodPortOfDischarge: "Sortie du conteneur au POD (port de déchargement)",
  originPort: "Port d'Origine",
  finalDestinationPort: "Port de Destination Final",
  estimatedArrival: "Arrivée Estimée",
  actualArrival: "Arrivée Réelle",
  carrierEstimatedArrival: "Transporteur Estimé Arrival",
  carrierActualArrival: "Transporteur Réel Arrival",
  arrivalAtPort: "Arrivée au Port",
  departureAtPort: "Départ du Port",
  predictiveArrivalAt: "Arrivée prédictive à",
  arrivalAt: "Arrivée à",
  editCurrency: "Modifier la Devise",
  createCurrency: "Créer une Devise",
  editItemInstruction: "Modifier Article Instruction",
  createItemInstruction: "Créer Article Instruction",
  addANewCurrency: "Ajouter une nouvelle devise",
  australianDollar: "Dollar australien",
  a: "A$",
  currencyView: "Currency Voir",
  currencyStatus: "Statut de la devise",
  editLanguage: "Modifier la Langue",
  actualStatus: "Réel Statut",
  createNewLanguage: "Créer une nouvelle langue",
  baseLanguage: "Langue de base",
  en: "EN",
  measurementStatus: "Statut des mesures",
  flag: "Drapeau",
  where: "Où",
  usage: "Utilisation",
  filteringBy: "Filtrage par ",
  editModeType: "Modifier Mode Type",
  createModeType: "Créer Mode Type",
  editThisModeType: "Modifier ce type de mode",
  addNewModeType: "Ajouter un nouveau type de mode",
  modeTypeStatus: "Statut du type de mode",
  needAddAHomeOrVideoSurvey: "Vous devez ajouter une visite à domicile ou vidéo",
  quotedInventory: "Inventaire devisé",
  chooseADestination: "Choisir une destination",
  aMaterialWasAddToTheSelectedRoom: "Un matériau a été ajouté à la pièce sélectionnée",
  pressEnterToSaveOrEscToCancel: "Appuyez sur Entrée pour enregistrer ou ESC pour annuler",
  youHaveToChooseAQuoteModeToAddAnItem: "Vous devez choisir un mode de devis pour ajouter un article",
  youHaveToChooseAQuoteModeToAddAMaterial: "Vous devez choisir un mode de devis pour ajouter un matériau",
  youHaveToSelectARoomBeforeAddAMaterial: "Vous devez sélectionner une pièce avant d'ajouter un matériau",
  aRoomWithThisNameAlreadyExists: "Une pièce avec ce nom existe déjà",
  youHaveToSelectARoomBeforeAddAnItem: "Vous devez sélectionner une pièce avant d'ajouter un article",
  generateToken: "Générer un token",
  copyToken: "Copier le token",
  copiedSuccessfully: "Copié avec succès",
  unitQty: "Qté unitaire",
  productQty: "Produit Qty",
  qtyStock: "Qté (Stock)",
  qtyShipping: "Qté (Expédition)",
  latitude: "Latitude",
  longitude: "Longitude",
  vesselType: "Type de Vessel",
  vesselPosition: "Position du navire",
  speedKnots: "Vitesse (Nœuds)",
  editMeasurement: "Modifier la Mesure",
  createMeasurement: "Créer une Mesure",
  createNewStaff: "Créer un nouveau membre du personnel",
  viewStaff: "Voir le personnel",
  male: "Homme",
  female: "Femme",
  createService: "Créer un Service",
  editService: "Modifier le service",
  viewService: "Voir le service",
  serviceStatus: "Statut du service",
  sellDescription: "Description de vente",
  serviceDescription: "Description du service",
  sellType: "Type de vente",
  m3Fee: "Frais M3",
  defaultPrice: "Par défaut price",
  serviceGroup: "Groupe de service",
  inputMessage: "Message de Saisie",
  viewChecklist: "Voir la Liste",
  editChecklist: "Modifier la Liste",
  createChecklist: "Créer une Liste",
  emptyList: "Liste Vide",
  addAll: "Ajouter tout",
  addType: "Ajouter Type",
  addBranch: "Ajouter branch",
  jobTypeAlreadyExistInTheList: "Le type de travail existe déjà dans la liste",
  branchAlreadyExistInTheList: "L'agence existe déjà dans la liste",
  riskAssessment: "Évaluation des Risques",
  vehicleTrailer: "Véhicule/Trailer",
  required: "Obligatoire",
  title: "Titre",
  needAction: "Action Requise",
  answerAction: "Répondre à l'Action",
  addNewQuestion: "Ajouter une nouvelle question",
  trigger: "Déclencheur",
  addNewTrigger: "Ajouter un nouveau déclencheur",
  notes: "Notes",
  taskTypeAlreadyExistInTheList: "Le type de tâche existe déjà dans la liste",
  taskType: "Type de Tâche",
  questions: "Questions",
  appTriggers: "Déclencheurs d'application",
  beforeStartTask: "Avant de démarrer la tâche",
  beforeContinueTask: "Avant de continuer la tâche",
  beforeFinishTask: "Avant de terminer la tâche",
  beforeAcceptTask: "Avant d'accepter la tâche",
  text: "Texte",
  checkbox: "Case à cocher",
  decimal: "Décimal",
  integer: "Entier",
  signature: "Signature",
  photo: "Photo",
  checkboxText: "Case à cocher et texte",
  radioButton: "Bouton radio",
  textarea: "Zone de texte",
  radioButtonText: "Bouton radio et texte",
  johnny: "Johnny",
  bravo: "Bravo",
  john: "John",
  sampleEmailCom: "sample@email.com",
  emergency: "Urgence",
  pendingCustomerUpload: "En attente du téléversement client",
  sharedWithCustomer: "Partagé avec le client",
  resendRequest: "Renvoyer la demande",
  uploadedByCustomer: "Téléversé par le client",
  noDocumentsRequestedYet: "Aucun document demandé pour l'instant",
  donTWorryIfAnyDocumentsAreRequestedByUsYouWillBeNotifiedAndWillBeAbleToManageThem:
    "Ne vous inquiétez pas, si des documents sont demandés par nous, vous serez notifié et pourrez les gérer.",
  oneOrMoreRequiredFieldsAreEmpty: "Un ou plusieurs champs obligatoires sont vides",
  noChangeHasBeenDetected: "Aucun changement n'a été détecté",
  noCommentsBeTheFirstToComment: "Aucun commentaire ! Soyez le premier à commenter...",
  mainAddress: "Adresse principale",
  createANewBusinessContact: "Créer un nouveau contact professionnel",
  editABusinessContact: "Modifier un contact professionnel",
  includeInCommunications: "Inclure dans les communications",
  thisUserNeedsToHaveSomeProjectSelected: "Cet utilisateur doit avoir un projet sélectionné",
  thisUserNeedsToHaveSomeRoleSelected: "Cet utilisateur doit avoir un rôle sélectionné",
  thePasswordDoesNotMatch: "Le mot de passe ne correspond pas",
  selectPerformancePrediction: "Sélectionner la prédiction de performance",
  performancePrediction: "Prédiction de performance",
  passwordAndConfirmPasswordMustBeTheSame: "Le mot de passe et la confirmation doivent être identiques",
  newPasswordAndConfirmPasswordMustBeTheSame: "Le nouveau mot de passe et la confirmation doivent être identiques",
  hiThere: "Bonjour !",
  pleaseFindTheJsonFileAttachedForShipmentS: "Veuillez trouver le fichier JSON joint pour les expéditions",
  best: "Cordialement, ",
  discard: "Annuler",
  discardChanges: "Annuler les modifications",
  areYouSureYouWantToDiscardAllChanges: "Êtes-vous sûr de vouloir annuler toutes les modifications ?",
  thisActionIsPermanentAndCannotBeUndone: "Cette action est permanente et ne peut pas être annulée !",
  shipeeziAustralia: "Shipeezi  Australia",
  supportShipeeziCom: "support@shipeezi.com",
  wwwShipeeziCom: "www.shipeezi.com",
  shipeeziKey: "Shipeezi Key",
  termsOfUsePrivacyPolicySecurityPolicy: "Conditions d'utilisation, Politique de confidentialité, Politique de sécurité",
  andSaasAgreement: " et accord SaaS ",
  agreed: "convenu",
  thisCurrencyIsAlreadyRelatedToACompanyThereforeYouCannotChangeHisStatus:
    "Cette devise est déjà liée à une entreprise, vous ne pouvez donc pas modifier son statut.",
  select: "Sélectionner",
  hello: "Bonjour,",
  dateRange: "Plage de dates",
  viewToday: "Voir aujourd'hui",
  activeQuotes: "Devis actifs",
  quotedVolume: "Volume devisé",
  videoSurveys: "Visites vidéo",
  activeOrders: "Commandes actives",
  orderVolume: "Volume des commandes",
  branchOrigin: "Agence d'origine",
  branchDestination: "Agence de destination",
  material: "Matériau",
  accessStatus: "Statut d'accès",
  instruction: "Instruction",
  scheduleCreateSuccessfully: "Planning créé avec succès",
  sendAutomaticalyASmsEmailInvite: "Envoyer automatiquement une invitation SMS/e-mail",
  theEmailOrPhoneIsAlreadyInUseByAnotherCustomer:
    "L'e-mail ou le téléphone est déjà utilisé par un autre client",
  wouldYouLikeToSendTheDetailsOfTheCallToYourCustomerBy:
    "Souhaitez-vous envoyer les détails de l'appel à votre client par",
  assignRole: "Attribuer Rôle",
  duplicateRole: "Dupliquer Rôle",
  accessRule: "Règle d'accès",
  accessRules: "Règles d'accès",
  membersInGroup: "Membres de ce groupe",
  showAll: "Afficher Tous",
  enterNameForThisGroup: "Entrer le nom de ce groupe",
  describeThisGroupInFewWords: "Décrivez ce groupe en quelques mots",
  groupCreatedSuccessfully: "Groupe '{{groupName}}' créé avec succès",
  groupUpdatedSuccessfully: "Groupe '{{groupName}}' mis à jour avec succès",
  anErrorOccurredWhileUpdatingGroup:
    "Une erreur s'est produite lors de la mise à jour du groupe '{{groupName}}'. Veuillez contacter le support Shipeezi pour obtenir de l'aide",
  thisIsADefaultSystemGroupThatCannotBeModifiedButYouCanAddOrRemoveMembersFromIt:
    "Il s'agit d'un groupe système par défaut qui ne peut pas être modifié, mais vous pouvez y ajouter ou en retirer des membres",
  kindlyResolveTheFormErrorsBeforeProceeding:
    "Veuillez résoudre les erreurs du formulaire avant de continuer...",
  theGroupNameAlreadyExistsPleaseChooseADifferentName:
    "Le nom du groupe '{{groupName}}' existe déjà. Veuillez choisir un nom différent.",
  changeStatus: "Changer Statut",
  purchase: "Achat",
  purchaseOrder: "Bon de Commande",
  salesOrder: "Commande de Vente",
  asPlanned: "Comme prévu",
  potentialDelay: "Retard Potentiel",
  delayed: "Retardé",
  selectAVideoSurveyOfToday: "Sélectionner une visite vidéo d'aujourd'hui",
  openVideoSurvey: "Ouvrir la Visite Vidéo",
  searchOrAddAReference: "Rechercher ou ajouter une référence",
  searchOriginAddress: "Rechercher Origin Adresse",
  searchDestinationAddress: "Rechercher Destination Adresse",
  searchOrAddACustomer: "Rechercher ou ajouter un client",
  jobAlreadyExists: "Le travail existe déjà",
  associateCustomer: "Associate Client",
  thereIsAlreadyACustomerWithThisEmailOrPhoneNumberDoYouWantToAssociateTheTask:
    "Il existe déjà un client avec cet e-mail ou ce numéro de téléphone, souhaitez-vous associer la tâche ?",
  associate: "Associer",
  phone: "Téléphone",
  translation: "Traduction",
  viewActivity: "Voir l'Activité",
  seeActivity: "Voir l'activité",
  activity: "Activité",
  createItem: "Créer un Article",
  folders: "dossiers",
  shipment: "Expédition",
  quotes: "Devis",
  estimate: "Estimation",
  loadingQuotes: "Loading Devis",
  quotesWonVsLost: "Devis gagnés vs perdus",
  quotesWon: "devis gagnés",
  quotesLost: "devis perdus",
  won: "Gagné",
  lost: "Perdu",
  lastUpdatedOn: "Dernière mise à jour le",
  instructionsNotFound: "Instructions introuvables",
  quotesPerformed: "Devis Performed",
  ordersByType: "Commandes par type",
  orders: "Commandes",
  loadingOrders: "Loading Commandes",
  itFeelsABitEmpty: "C'est un peu vide ici",
  videoName: "Video Nom",
  fetchingVideo: "Chargement de la vidéo",
  fetchDetails: "Fetch Détails",
  videoUploadInProgress: "Téléversement vidéo en cours",
  noVideoAvailable: "Non video available",
  screenshots: "Captures d'écran",
  imageOfAScreenshot: "Image d'une capture d'écran",
  fetchingScreenshots: "Chargement des captures d'écran",
  seeMore: "Voir plus",
  noScreenshotAvailable: "Non screenshot available",
  fetchingComments: "Fetching Commentaires",
  noCommentsAvailable: "Aucun commentaire disponible",
  screenSharing: "Partage d'écran",
  bookmarks: "Favoris",
  fetchingBookmarks: "Chargement des favoris",
  noBookmarksAvailable: "Non bookmarks available",
  bookmarkSavedSuccessfully: "Favori enregistré avec succès.",
  couldNotSaveBookmark: "Impossible d'enregistrer le favori",
  searchByCustomerNamePhoneNumberOrEmailAddress:
    "Rechercher par nom de client, numéro de téléphone ou adresse e-mail",
  searchManager: "Rechercher manager",
  totalQty: "Qté totale",
  totalVolume: "Volume total",
  totalWeight: "Total Poids",
  contacts: "Contacts",
  createANewWarehouse: "Créer un nouvel entrepôt",
  editWarehouse: "Modifier warehouse",
  createANewBranch: "Créer une nouvelle agence",
  editBranch: "Modifier branch",
  viewBranch: "Voir branch",
  viewWarehouse: "Voir warehouse",
  closeAllPanels: "Fermer tous les panneaux",
  collapseAllPanels: "Réduire tous les panneaux",
  expandAllPanels: "Développer tous les panneaux",
  expandAll: "Tout développer",
  collapseAll: "Tout réduire",
  tba: "TBA",
  editMaterial: "Modifier material",
  createANewMaterial: "Créer un nouveau matériau",
  materialStatus: "Matériau status",
  isAnItem: "Est un article ?",
  editInstruction: "Modifier instruction",
  createInstruction: "Créer instruction",
  when: "Quand",
  editTaskType: "Modifier le type de tâche",
  createTaskType: "Créer un type de tâche",
  taskTypeStatus: "Tâche type status",
  isBookable: "Est réservable ?",
  isItBookable: "Est-ce réservable ?",
  viewDestination: "Voir destination",
  editDestination: "Modifier destination",
  createDestination: "Créer destination",
  destinationStatus: "Statut de destination",
  colorValueMustStartWithAndCannotBeAWhiteColor:
    "La valeur de couleur doit commencer par # et ne peut pas être une couleur blanche",
  automaticSequencing: "Séquençage automatique",
  nextNumber: "Suivant number",
  changeStatuses: "Changer statuses",
  changeAllSelectedStatusesTo: "Changer tous les statuts sélectionnés en",
  changeItemStatuses: "Changer les statuts des articles",
  changeAllSelectedItemsStatusesTo: "Changer le statut de tous les articles sélectionnés en",
  visibilityControlAndTransparencyOfYourShipments:
    "Visibilité, contrôle et transparence de vos expéditions.",
  yourRequestHasExpiredMakeANewRecovery: "Votre demande a expiré. Faites une nouvelle récupération",
  pleaseEnterAEmail: "Veuillez entrer un e-mail.",
  resetPassword: "Réinitialiser le mot de passe",
  pleaseCheckYourEmail: "Veuillez vérifier votre e-mail.",
  yourPasswordHasBeenUpdated: "Votre mot de passe a été mis à jour.",
  returnToLogin: "Retour à la connexion",
  backToLogin: "Retour à la connexion",
  didnTReceiveTheEmail: "Vous n'avez pas reçu l'e-mail ? ",
  aPasswordResetMessageWasSentToYourEmailAddress:
    "Un message de réinitialisation du mot de passe a été envoyé à votre adresse e-mail.",
  enterTheEmailAddressAssociatedWithYourAccountAndWeLlSendYouALinkToResetYourPassword:
    "Entrez l'adresse e-mail associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  createAccessOption: "Créer une option d'accès",
  editAccessOption: "Modifier l'option d'accès",
  drivewayLength: "Driveway Longueur",
  carryDistance: "Distance de portage",
  switchTo: "Basculer vers",
  questionFieldsAreRequired: "Les champs de question sont obligatoires.",
  triggerFieldTypeIsRequired: "Le type de champ déclencheur est requis.",
  valueOfEntryIsAlreadyInUsed: "La valeur de l'entrée est déjà utilisée",
  aRoleOfTypeSystemIsSelectedAndCannotBeChanged:
    "Un rôle de type système est sélectionné et ne peut pas être modifié",
  theDateIsWrong: "La date est incorrecte",
  theUserMustBeAtLeast18YearsOldAndUnder100YearsOld:
    "L'utilisateur doit avoir au moins 18 ans et moins de 100 ans",
  approveQuote: "Approuver le devis",
  doYouReallyWantToApproveTheQuote: "Voulez-vous vraiment approuver le devis ?",
  areYouSureYouWantToDeliverThisOrder: "Êtes-vous sûr de vouloir livrer cette commande ?",
  areYouSureYouWantToCancelTheOrder: "Êtes-vous sûr de vouloir annuler la commande",
  yesCancelOrder: "Oui, annuler la commande",
  areYouSureYouWantToCancelTheQuote: "Êtes-vous sûr de vouloir annuler le devis",
  yesCancelQuote: "Oui, annuler le devis",
  oops: "Oups!",
  youShouldCancelTheseTasksInYourAppBeforeContinue:
    "Vous devez annuler ces tâches dans votre application avant de continuer.",
  itLooksLikeSomeTasksOfThisOrderAreInProgress:
    "Il semble que certaines tâches de cette commande sont en cours.",
  declineQuote: "Refuser le devis",
  doYouReallyWantToDeclineTheQuote: "Voulez-vous vraiment refuser le devis ?",
  viewInCalendarMode: "Voir en mode calendrier",
  viewInGridMode: "Voir en mode grille",
  removeAll: "Tout retirer",
  roleNotFound: "Rôle introuvable",
  userNotFound: "Utilisateur introuvable",
  searchForRole: "Rechercher un rôle...",
  searchForUser: "Rechercher un utilisateur...",
  inbound: "Entrant",
  atPort: "Au port",
  atDc: "Au centre de distribution",
  ofTotalContainers: "Du total des conteneurs",
  containerDistributionByDestination: "Répartition des conteneurs par destination",
  shareLink: "Partager le lien",
  cameraOff: "Caméra désactivée",
  video: "Vidéo",
  microphone: "Microphone",
  joinNow: "Rejoindre maintenant",
  youDidnTAddAnyItemsYet: "Vous n'avez encore ajouté aucun article",
  copied: "Copié",
  shareViaApp: "Partager via l'application",
  shareViaLink: "Partager via le lien",
  shareViaSms: "Partager via SMS",
  shareViaWhatsapp: "Partager via Whatsapp",
  openWhatsappToShare: "Ouvrir WhatsApp pour partager",
  shareViaEMail: "Partager via E-mail",
  shareTheVideoSurveyWithTheCustomer: "Partager la visite vidéo avec le client",
  shareTheInventoryWithTheCustomer: "Partager l'inventaire avec le client",
  shareTheEstimateWithTheCustomer: "Partager l'estimation avec le client",
  shareInventory: "Partager l'inventaire",
  shareEstimate: "Partager l'estimation",
  shareVideoSurvey: "Partager la visite vidéo",
  inventoryUpdated: "Inventaire mis à jour",
  youAreAboutToLeaveVideoSurveyAreYouSure: "Vous êtes sur le point de quitter la visite vidéo. Êtes-vous sûr ?",
  theCustomerWillBeForcedToLeaveToo: "Le client sera également obligé de partir.",
  youHaveUnsavedChangesInTheInventory: "Vous avez des modifications non enregistrées dans l'inventaire.",
  audioDeviceTest: "Test du périphérique audio",
  recording: "Enregistrement...",
  playing: "Lecture en cours...",
  leave: "Quitter",
  noIssuesDetected: "Aucun problème détecté",
  inputDevice: "Périphérique d'entrée",
  inputLevel: "Niveau d'entrée",
  speaker: "Haut-parleur",
  outputDevice: "Périphérique de sortie",
  outputLevel: "Niveau de sortie",
  connectivityAndBandwidthTest: "Test de connectivité et bande passante",
  taskTypeIsRequired: "Le type de tâche est requis.",
  orderTypeIsRequired: "Le type de commande est requis.",
  orderTypeStatus: "Statut du type de commande",
  sequence: "Séquence",
  poNumber: "Numéro BC",
  despatchedQuantity: "Quantité expédiée",
  destinationDcCmlDc: "DC destination (CML DC)",
  estimateClearedForPickUp: "Estimation dédouané pour enlèvement",
  estimateUnpackDate: "Date estimée de déballage",
  actualArriveWh: "Arrivée réelle à l'entrepôt",
  bookedFor: "Réservé pour",
  at: "à",
  contactEmailCom: "contact@email.com",
  expectedCallQuality: "Qualité d'appel prévue :",
  deliverOrder: "Livrer la commande",
  generateReport: "Générer un rapport",
  generatePDFreports: "Générer des rapports PDF",
  hideSection: "Masquer la section",
  showSection: "Afficher la section",
  online: "En ligne",
  offline: "Hors ligne",
  collapse: "Réduire",
  allow: "Autoriser",
  notAllow: "Ne pas autoriser",
  allowCustomer: "Autoriser le client",
  screenshotSavedSuccessfully: "Capture d'écran enregistrée avec succès",
  couldNotSaveScreenshot: "Impossible d'enregistrer la capture d'écran",
  couldNotRetrieveScreenshots: "Impossible de récupérer les captures d'écran",
  loadingDespatches: "Chargement des expéditions",
  checklistStatus: "Statut de la liste de contrôle",
  warehouseStatus: "Statut de l'entrepôt",
  branchStatus: "Statut de l'agence",
  someRequiredInformationAreMissing: "Certaines informations requises sont manquantes ",
  addAnExistentContact: "Ajouter un contact existant",
  selectAContact: "Sélectionner un contact",
  hideInput: "Masquer la saisie",
  hideForm: "Masquer le formulaire",
  createNewContact: "Créer un nouveau contact",
  loadingData: "Chargement des données...",
  qty: "Qté",
  isThisMaterialAnItem: "Ce matériau est-il un article ?",
  automationAndControlForIncreasedSupplyChainVisibility:
    "Automatisation et contrôle pour une visibilité accrue de la chaîne d'approvisionnement.",
  youHavenTAddedAnyItemsYet: "Vous n'avez encore ajouté aucun article",
  youHavenTAddedAnyMaterialYet: "Vous n'avez encore ajouté aucun matériau",
  prices: "Prix",
  createNewPrice: "Créer un nouveau prix",
  price: "Prix",
  addNewGroup: "Ajouter un nouveau groupe",
  DimensionFee: "Frais de {dimension}",
  searchAgent: "Rechercher agent",
  preferredUplift: "Majoration préférée",
  accessRuleName: "Nom de la règle d'accès",
  addAccessRule: "Ajouter Règle d'accès",
  groupName: "Nom du groupe",
  newGroup: "Nouveau groupe",
  subTotal: "Sous-total",
  deleteThisLine: "Supprimer cette ligne",
  thereMustBeAtLeastOneServiceInAGroup: "Il doit y avoir au moins un service dans un groupe",
  deleteThisGroup: "Supprimer ce groupe",
  thereMustBeAtLeastOneGroupInAPrice: "Il doit y avoir au moins un groupe dans un prix",
  editGroupName: "Modifier le nom du groupe",
  searchCurrency: "Rechercher currency",
  searchService: "Rechercher service",
  priceCreatedSuccessfully: "Prix créé avec succès",
  groupAddedSuccessfully: "Groupe ajouté avec succès",
  serviceAddedSuccessfully: "Service ajouté avec succès",
  pressToConfirmGroupNameChange: "Appuyez pour confirmer le changement de nom du groupe",
  pressToCancelGroupNameChange: "Appuyez pour annuler le changement de nom du groupe",
  fillNameAndPressSaveOrEnter: "Remplissez le nom et appuyez sur enregistrer ou entrée",
  addNewLine: "Ajouter une nouvelle ligne",
  originCosts: "Coûts d'origine",
  destinationCosts: "Coûts de destination",
  extras: "Suppléments",
  deleteThisPrice: "Supprimer ce prix",
  agentSelected: "Agent sélectionné",
  pricingListUpdatedOn: "Liste de tarifs mise à jour le",
  noneAgentSelected: "Aucun agent sélectionné",
  totalCosts: "Coûts totaux",
  manageNeverBeenEasier: "Gérer n'a jamais été aussi facile",
  visibilityAtItsBest: "La visibilité à son meilleur",
  shipeeziIsTheEssentialToolForCompaniesOfAllSizesToConsolidateAutomateAndUncomplicateInformationAndShipmentFlowAcrossTheGlobe:
    "Shipeezi est l'outil essentiel pour les entreprises de toutes tailles pour consolider, automatiser et simplifier les flux d'informations et d'expéditions à travers le monde.",
  saveTimeAndMoney: "Gagnez du temps et de l'argent",
  withShipeeziVisibilityAndIncreasedControlIsDeliveredSavingMoreThan30InLogisticsCostsAnd60InTimeReporting:
    "Avec Shipeezi, la visibilité et un contrôle accru sont assurés, permettant d'économiser plus de 30 % sur les coûts logistiques et 60 % sur le temps de reporting.",
  createYourAccount: "Créer votre compte",
  youAreJustMomentsAwayOfHavingFullVisibilityAndControlOverYourShipments:
    "Vous êtes à quelques instants d'avoir une visibilité et un contrôle complets sur vos expéditions !",
  confirmPassword: "Confirmer le mot de passe",
  haveAnAccount: "Vous avez un compte?",
  signIn: "Se connecter",
  shipeezi: "© Shipeezi",
  termsOfUse: "Conditions d'Utilisation",
  passwordsDonTMatch: "*Les mots de passe ne correspondent pas",
  companyName: "Nom de l'entreprise",
  companyType: "Type d'entreprise",
  selectCompanyType: "Sélectionner company type",
  spShipper: "SP - Expéditeur",
  fmFreightManager: "FM - Gestionnaire de fret",
  mvMoving: "MV - Déménagement",
  getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime:
    "Recevez des e-mails de Shipeezi sur les mises à jour produit, les actualités du secteur et les événements. Si vous changez d'avis, vous pouvez vous désabonner à tout moment.",
  byContinuingYouReAgreeingToShipeeziS: "En continuant, vous acceptez les conditions de Shipeezi",
  requestAccount: "Demander account",
  ourTeamWillGetInTouchWithYouAsSoonAsPossible:
    "Notre équipe vous contactera dès que possible.",
  thankYouForSignUpYouCanCheckYourEmailToProceed:
    "Merci pour votre inscription. Vous pouvez vérifier votre e-mail pour continuer.",
  youWillReceiveAnEmailTo: "Vous recevrez un e-mail à",
  toConfirmYourSignUp: "pour confirmer votre inscription.",
  thereWasAnErrorCreatingTheAccount: "Une erreur est survenue lors de la création du compte",
  captcha: "Captcha",
  captchaExpired: "Captcha expiré",
  and: "et",
  leaveVideoSurvey: "Quitter la visite vidéo",
  wellDoneOnTheMeetingWith: "Bravo pour la réunion avec",
  donTForgetWhatYouHaveAvailableFromThisMeeting:
    "N'oubliez pas ce que vous avez à disposition suite à cette réunion.",
  didYouLeaveTheMeetingByMistake: "Avez-vous quitté la réunion par erreur ? ",
  rejoinTheMeetingHere: "Rejoindre la réunion ici",
  packingMaterial: "Packing Matériau",
  estimateQuote: "Estimation de devis",
  agents: "Agents",
  editEstimate: "Modifier estimate",
  charge: "Frais",
  quantity: "Quantité",
  rate: "Taux",
  margin: "Marge",
  markUp: "Marquer up",
  discount: "Remise",
  totalCost: "Coût total",
  paymentMethod: "Paiement Method",
  creditCard: "Carte de crédit",
  credit_card: "Carte de crédit",
  account: "Compte",
  cash: "Espèces",
  goBackToApp: "Retour à l'application",
  closeTab: "Fermer tab",
  openCommunication: "Ouvert communication",
  enableMicrophone: "Activer microphone",
  disableMicrophone: "Désactiver microphone",
  enableCamera: "Activer camera",
  disableCamera: "Désactiver camera",
  shareScreen: "Partager screen",
  stopSharingScreen: "Arrêter Sharing Screen",
  cannotShareScreenWhenAnotherUserIsSharing: "Impossible de partager l'écran quand un autre utilisateur partage",
  screenSharingIsNotSupportedWithThisBrowser: "Le partage d'écran n'est pas pris en charge par ce navigateur",
  emailConfirmationTimeHasExpired: "Le délai de confirmation par e-mail a expiré",
  thereWasAnErrorConfirmingTheEmail: "Une erreur est survenue lors de la confirmation de l'e-mail",
  emailSuccessfullyConfirmed: "Email avec succès confirmed",
  backToLoginPage: "Retour à la page de connexion",
  goToShipeeziBlog: "Aller au blog Shipeezi",
  isNowVerified: "est maintenant vérifié !",
  chooseAPassword: "Choisir a password",
  useLettersNumbersAndSymbolsForSafety: "Utilisez des lettres, des chiffres et des symboles pour la sécurité",
  confirmYourPassword: "Confirmez votre mot de passe",
  theSameOneFromAbove: "Le même que ci-dessus",
  youJustNeedToCreateAPasswordForYourAccount:
    "Vous devez simplement créer un mot de passe pour votre compte.",
  predictiveDeparture: "Départ prédictif :",
  departure: "Date de Départ",
  arrival: "Arrivée",
  nextPortArrival: "Suivant port arrival:",
  decimalSeparator: "Séparateur décimal",
  thousandSeparator: "Séparateur des milliers",
  usePoint: "Utiliser le point (.)",
  useComma: "Utiliser la virgule (,)",
  newService: "Nouveau service",
  createANewServiceOrGroup: "Créer un nouveau service ou groupe",
  createNewGroup: "Créer un nouveau groupe",
  inventoryList: "Inventaire list",
  openLegacyVersion: "Ouvert legacy version",
  closeThisScreen: "Fermer cet écran",
  changeGroupStatus: "Changer le statut du groupe",
  noAssociatedService: "Aucun service associé.",
  viewGroups: "Voir groups",
  groups: "Groupes",
  seemsLikeYouDidnTCreateAnyGroup: "Il semble que vous n'avez créé aucun groupe :(",
  searchGroups: "Rechercher groups",
  groupCosting: "Groupe costing",
  totalOfPrice: "Total of Prix ",
  sent: "Envoyé",
  group: "Groupe",
  changeStatusTo: "Changer status to",
  totalOf: "Total de",
  lastUpdated: "Last mis à jour",
  thisServiceCannotBeActivatedBecauseIsUnavailable:
    "Ce service ne peut pas être activé car il est indisponible",
  thisServiceCannotBeEditedBecauseIsUnavailable:
    "Ce service ne peut pas être modifié car il est indisponible",
  loadingPrices: "Chargement des prix",
  updatePrices: "Mettre à jour prices",
  reviewPrices: "Vérifier les prix",
  editFile: "Modifier le fichier",
  uploadCsv: "Téléverser CSV",
  uploadCsvFile: "Téléverser un fichier CSV",
  downloadTemplate: "Télécharger le modèle",
  clickToDownloadThePriceTemplateAndFillPrices:
    "Cliquez pour télécharger le modèle de prix et remplir les prix",
  noFilesUploaded: "Non files uploaded",
  noneDataHasFilled: "Aucune donnée n'a été remplie",
  fee: "Frais",
  thisServiceDoesNotExist: "Ce service n'existe pas",
  thereIsNoRelationshipBetweenThisServiceAndTheGroup:
    "Il n'y a aucune relation entre ce service et le groupe",
  thisGroupDoesNotExist: "Ce groupe n'existe pas",
  thereIsNoRelationshipBetweenThisGroupAndTheService:
    "Il n'y a aucune relation entre ce groupe et le service",
  theValueOfThisFieldIsInvalid: "La valeur de ce champ est invalide",
  thisCurrencyDoesNotExist: "Cette devise n'existe pas",
  nonGrouped: "Non groupé",
  wasEditedSuccessfully: "a été modifié avec succès !",
  thisRecordCannotBeEditedBecauseThereIsAnErrorInTheServiceOrGroup:
    "Cet enregistrement ne peut pas être modifié car il y a une erreur dans le service ou le groupe",
  theseServicesWillNotBeUpdatedIfYouWouldLikeToCorrectThemYouShouldEditFile:
    "Ces services ne seront pas mis à jour. Si vous souhaitez les corriger, vous devez modifier le fichier.",
  thisCanBeCorrectedIfYouClickIn: "Cela peut être corrigé si vous cliquez sur ",
  latestUpload: "Dernier téléversement",
  youCanOnlyContinueAfterAllWarningsHaveBeenResolved:
    "Vous ne pouvez continuer qu'après avoir résolu tous les avertissements",
  timeControl: "Contrôle du temps",
  arrivedAtTheResidence: "Arrivé à la résidence",
  breakFrom: "Pause de",
  to: "À",
  leavingTheResidence: "Quitter la résidence",
  arrivedBackToTheWarehouse: "Retour à l'entrepôt",
  timeSummary: "Heure Résumé",
  transitTime: "Temps de transit",
  breakTime: "Temps de pause",
  workTime: "Temps de travail",
  totalTime: "Temps total",
  extraStaff: "Personnel Supplémentaire",
  deleteSubscriber: "Supprimer subscriber",
  whenYouDeleteANotification:
    "Lorsque vous supprimez une notification, le contact associé ne recevra plus d'alertes.",
  wouldYouLikeToProceed: "Voulez-vous procéder?",
  pricesUpdatedSuccessfully: "Prix mis à jour avec succès",
  weWillUpdateAllPricesDisregardingThoseMarkedWith:
    "Nous mettrons à jour tous les prix, en ignorant ceux marqués avec",
  ifYouWantToUpdateThesePricesYouShouldEditFile:
    "Si vous souhaitez mettre à jour ces prix, vous devez modifier le fichier",
  newMessage: "Nouveau Message!",
  oopsIncorrectCredentials: "Identifiants incorrects.",
  leaveWithoutSave: "Quitter sans enregistrer",
  youHaveUnsavedChangesAreYouSureYouWantToLeave:
    "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?",
  youShouldSaveYourWorkBeforeLeaving: "Vous devez enregistrer votre travail avant de partir.",
  doYouReallyWantToDeleteThisAgent: "Voulez-vous vraiment supprimer cet agent",
  agentDetails: "Détails de l'agent",
  toAllowYourPasswordReset: "pour permettre la réinitialisation de votre mot de passe.",
  sorryTheLinkHasExpired: "Désolé, le lien a expiré.",
  theResetPasswordLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "Le lien de réinitialisation du mot de passe a expiré. Vous pouvez en demander un nouveau en cliquant sur le bouton ci-dessous.",
  resetPasswordLink: "Lien de réinitialisation",
  emailSuccessfullyResent: "E-mail renvoyé avec succès",
  anUnknownErrorHasOccurred: "Une erreur inconnue est survenue",
  emailOrUsernameIsRequired: "L'e-mail ou le nom d'utilisateur est requis",
  passwordIsRequired: "Le mot de passe est requis",
  userLoggedIn: "Utilisateur Connecté",
  thereWasAnErrorCapturingYourEmailToResend: "Une erreur est survenue lors de la capture de votre e-mail pour le renvoi",
  theEmailConfirmationLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "Le lien de confirmation par e-mail a expiré. Vous pouvez en demander un nouveau en cliquant sur le bouton ci-dessous.",
  resendConfirmationLink: "Renvoyer le lien de confirmation",
  thankYouForRequestingAnAccountWithShipeezi: "Merci d'avoir demandé un compte chez Shipeezi.",
  ourTeamWillBeInContactWithYouPriorToActivatingYourAccount:
    "Notre équipe vous contactera avant d'activer votre compte.",
  companyDetails: "Détails de l'Entreprise",
  uploadCentre: "Centre de Téléversement",
  goBackToHomePage: "Retour à l'accueil",
  goBackToLogin: "Retour à la connexion",
  goBackToLoginPage: "Retour à la page de connexion",
  previous: "Précédent",
  skip: "Ignorer",
  downloadOurCsvTemplateHere: "Téléchargez notre modèle CSV ici",
  addAdditionalUsers: "Ajouter des utilisateurs supplémentaires",
  theContactDetailsUsedToRegisterHasBecomeAnAdminUserAlready:
    "Les coordonnées utilisées pour l'inscription correspondent déjà à un utilisateur administrateur.",
  registeredUsers: "Utilisateurs enregistrés",
  addUser: "Ajouter un utilisateur",
  aud: "AUD",
  youCanSelectToUploadYourOwnFilesInformationNowOrLaterIfYouPreferYouCanUseOurDefaultInformationTheseInformationIsInRegardsToYourInventoryItemsServicesFleetStaffAndSoOn:
    "Vous pouvez choisir de téléverser vos propres fichiers (informations) maintenant ou plus tard. Si vous préférez, vous pouvez utiliser nos informations par défaut. Ces informations concernent vos articles d'inventaire, services, flotte, personnel, etc.",
  uploadOwnList: "Téléverser sa propre liste",
  useShipeeziSDefaultList: "Utiliser la liste par défaut de Shipeezi",
  inventoryListIso174511: "Liste d'inventaire certifiée ISO17451-1:2016",
  usingShipeeziSDefault: "Utilisation du défaut Shipeezi",
  itemsRoomsPackagingTypeMethodOfPreparationModeTypeExceptionCodesExceptionLocationCodeItemInstructionsAndItemDestination:
    "Articles, Pièces, Type d'emballage, Méthode de préparation, Type de mode, Codes d'exception, Code de lieu d'exception, Instructions d'article et Destination d'article.",
  checklistForm: "Liste de contrôle et formulaire",
  riskAssessmentTemplate: "Modèle d'évaluation des risques",
  usingShipeeziSSampleData: "Utilisation des données d'exemple Shipeezi",
  listOfMaterials: "List of Matériaux",
  aFewCommonTypesOfPackingMaterialsWillBeLoaded:
    "Quelques types courants de matériaux d'emballage seront chargés",
  services: "Services",
  oneServiceTypeWillBeCreated: "Un type de service sera créé",
  oneStaffWillBeCreated: "Un membre du personnel sera créé",
  oneVehicleWillBeCreated: "Un véhicule sera créé",
  theseInstructionsCanBeUsedInTheSalesAndOperationsAppForUpliftDeliveryOrMoveCoordinator:
    "Ces instructions peuvent être utilisées dans l'application Ventes et Opérations pour l'enlèvement, la livraison ou le coordinateur de déménagement",
  usualAccessQuestionsWillBeCreatedHere: "Les questions d'accès habituelles seront créées ici",
  iso174511CertifiedItems:
    "Certifié ISO17451-1:2016 : Articles, Pièces, Type d'emballage, Méthode de préparation, Type de mode, Codes d'exception, Code de lieu d'exception, Instructions d'article et Destination d'article.",
  csvUploaded: "CSV Téléversé",
  asPerYourSelectionWeAreGoingToUploadTheStandardContentForTheFollowingSections:
    "Selon votre sélection, nous allons téléverser le contenu standard pour les sections suivantes :",
  youCanChooseFromTheListBelowWhichItemsYouWantToUploadAndWhichYouWantToUseShipeeziSDefault:
    "Vous pouvez choisir dans la liste ci-dessous quels éléments vous souhaitez téléverser et lesquels vous souhaitez utiliser par défaut de Shipeezi :",
  weAreLoadingTheUploadedContentPleaseWait: "Nous chargeons le contenu téléversé, veuillez patienter",
  thisMightTakeAWhile: "Cela pourrait prendre un moment",
  ifThisIsTakingTooMuchLonger: "Si cela prend encore plus de temps,",
  tryAgainHere: "réessayez ici",
  thankYouForCompleteThisProcess: "Merci d'avoir terminé le processus de configuration rapide.",
  readyToStartUsingShipeezi: "Prêt à commencer à utiliser Shipeezi ?",
  getStarted: "Commencer",
  confirmationEmailHasBeenSucessfullyResent: "L'e-mail de confirmation a été renvoyé avec succès !",
  confirmationEmailCouldNotBeenResent: "L'e-mail de confirmation n'a pas pu être renvoyé !",
  resetUserPassword: "Réinitialiser le mot de passe de l'utilisateur",
  businessLogo: "Logo Professionnel",
  businessIcon: "Icône Professionnelle",
  addLogo: "Ajouter un Logo",
  choosePicture: "Choisir une image",
  maxSize: "Taille maximale",
  formats: "Formats",
  crop: "Recadrer",
  version: "Version",
  profile: "Profil",
  emailToResetPasswordSent: "E-mail de réinitialisation du mot de passe envoyé",
  "2Mb": "2 MB",
  maxFileSize: "Taille maximale du fichier:",
  fileTypes: "Types de fichiers:",
  accountDetails: "Détails du compte",
  csvTemplateIsInvalid: "Le modèle CSV est invalide",
  line: "Ligne",
  isRequired: "est requis",
  mustBeOneOfTheValidOptions: "doit être l'une des options valides",
  mustBeFilledInWithXOrLeftEmpty: 'must be filled in with "x" or left empty',
  mustBeANumber: "doit être un nombre",
  mustBeADateWithTheFormatDdMmYyyy: "doit être une date au format jj/mm/aaaa",
  errorsFound: "Erreurs trouvées",
  errorsFoundInYourFile: "Erreurs trouvées dans votre fichier",
  on: "Le",
  csvWeHaveFoundSomeErrorsYouShouldAdjustThoseLinesToProceed:
    "csv, nous avons trouvé des erreurs. Vous devez ajuster ces lignes pour continuer :",
  donTKnowWhatSWrong: "Vous ne savez pas ce qui ne va pas ?",
  downloadOurTemplateHere: "Téléchargez notre modèle ici",
  downloadOurTemplate: "Télécharger notre modèle",
  logout: "Déconnexion",
  logOut: "Se déconnecter",
  userProfile: "Profil utilisateur",
  helpCenter: "Centre d'aide",
  dispatchFilters: "Filtres de répartition",
  allTasks: "Toutes les tâches",
  allTeams: "Toutes les équipes",
  unpublishedTasks: "Tâches non publiées",
  publishedTasks: "Tâches publiées",
  teamsWithUnpublishedTasks: "Équipes avec des tâches non publiées",
  teamsWithPublishedTasks: "Équipes avec des tâches publiées",
  someChangesMayTakeSomeTimeToBeAppliedOnThisScreen:
    "Certaines modifications peuvent prendre du temps avant d'être appliquées sur cet écran",
  thisFleetIsUnavailableOnThisDate: "Cette flotte est indisponible à cette date",
  thisMemberIsUnavailableOnThisDate: "Ce membre est indisponible à cette date",
  theFilteredDataAffectsWhatYouSeeOnDispatch:
    "Les données filtrées affectent ce que vous voyez dans « Expédition »",
  termsAndConditions: "Termes et Conditions",
  currentlyViewing: "Consultation actuelle",
  changeTo: "Changer pour",
  switchingAccounts: "Changement de compte.",
  unknown: "Inconnu",
  messageHasBeenSentSuccessfully: "Le message a été envoyé avec succès !",
  avatar: "Avatar",
  approvingCompany: "Approbation de l'entreprise...",
  theCompanyHasBeenApproved: "L'entreprise a été approuvée !",
  nowIsReadyToRockAndRoll: "est maintenant prêt à fonctionner.",
  quoteType: "Type de Devis",
  allProjects: "Tous les Projets",
  typeMobile: "Type mobile",
  searchForTimezone: "Rechercher un fuseau horaire",
  inviteUser: "Inviter un utilisateur",
  userEmail: "E-mail de l'utilisateur",
  userAddedSuccessfully: "Utilisateur ajouté avec succès",
  unableToRegisterAdditionalUser: "Impossible d'inscrire un utilisateur supplémentaire",
  inviteSentSuccessfully: "Invitation envoyée avec succès!",
  saveAndInvite: "Enregistrer et inviter",
  createAndInvite: "Créer et inviter",
  anEmailWasSentToUsernameWithYourRequest: "Un e-mail a été envoyé à *username* avec votre demande",
  companyInvitation: "Invitation d'entreprise",
  inviteDeclined: "Invitation refusée",
  youHaveBeenInvitedToBePartOf: "Vous avez été invité à faire partie de ",
  youHaveBeenInvitedToBePartOfCompany: "Vous avez été invité à faire partie de l'entreprise",
  youCanAcceptOrDeclineTheInvitationAndWeWillNotifyTheCompanyAdministrator:
    "Vous pouvez accepter ou refuser l'invitation et nous notifierons l'administrateur de l'entreprise.",
  weWillNotifyTheAdministrator: "Nous informerons l'administrateur.",
  weWillNotifyTheAdministratorFor: "Nous informerons l'administrateur pour",
  youCanCloseThisWindow: "Vous pouvez fermer cette fenêtre",
  ifYouRejectedThisInvitationByMistakePleaseRequestANewInvite:
    "Si vous avez rejeté cette invitation par erreur, veuillez demander une nouvelle invitation",
  here: "ici",
  yourInvitationExpired: "Votre invitation a expiré",
  companyUpdatedSuccessfully: "Entreprise mise à jour avec succès",
  termsAcceptedSuccessfully: "Conditions acceptées avec succès",
  by: "par",
  entityName: "Nom de l'entité",
  sorryTheLinkIsBroken: "Désolé, le lien est cassé",
  theInviteLinkIsBroken: "Le lien d'invitation est cassé.",
  theInviteLinkIsBrokenYouCanRequestANewOneByClickingOnTheButtonBelow:
    "Le lien d'invitation est cassé. Vous pouvez en demander un nouveau en cliquant sur le bouton ci-dessous.",
  resendInviteLink: "Renvoyer le lien d'invitation",
  goBack: "Retour",
  theInviteLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow:
    "Le lien d'invitation a expiré. Vous pouvez en demander un nouveau en cliquant sur le bouton ci-dessous.",
  thisFieldIsAnInvalidUrl: "Ce champ est une URL invalide",
  thisFieldShouldHaveDigitsOnly: "Ce champ ne doit contenir que des chiffres",
  validFormats: "Valide Formats",
  typeOfInstruction: "Type d'instruction",
  inputYourInstruction: "Saisir votre instruction",
  asYouAddedAnItemThatDoesNotBelongToTheIso174511:
    "Comme vous avez ajouté un article qui n'appartient pas à la norme ISO17451-1:2016, votre liste d'inventaire n'est pas conforme.",
  requestingNewInvite: "Demande d'une nouvelle invitation",
  youHaveAlreadyAcceptedThisInvitation: "Vous avez déjà accepté cette invitation !",
  loadingInvitation: "Chargement de l'invitation...",
  userHasNotBeenInvited: "L'utilisateur n'a pas été invité",
  navigation: "Navigation",
  someOfTheseEmailsProvidedIsInvalid: "Certains des e-mails fournis sont invalides",
  isThisAnItemDestination: "Est-ce une destination d'article ?",
  ssccQty: "Qté SSCC",
  etdAtOrigin: "ETD à l'origine",
  etaAtDestination: "ETA à destination",
  subjects: "Sujets",
  favorites: "Favoris",
  reports: "Rapports",
  company: "Entreprise",
  itFeelsEmptyRightNow: "C'est vide pour le moment.",
  status: "Status",
  filter: "Filtrer",
  reference: "Référence",
  referenceNumber: "Numéro de référence",
  customer: "Client",
  pdf: "PDF",
  csv: "CSV",
  exportAs: "Exporter en",
  tags: "Étiquettes",
  nothingToShowHereYet: "Rien à afficher pour le moment.",
  thisWarehouseDoesNotAllowStorageOfLooseItemsSelectAStorageBoxInstead:
    "Cet entrepôt ne permet pas le stockage d'articles en vrac. Sélectionnez une boîte de stockage à la place.",
  iConfirmThatAllTheDetailsAboveAreTrue: "Je confirme que tous les détails ci-dessus sont exacts",
  notInformed: "Non renseigné",
  signHere: "Signez ici",
  expandAllTasks: "Développer toutes les tâches",
  hideAllTasks: "Masquer toutes les tâches",
  checkIfAnyOfTheTasksEligibleForReportGenerationUpliftDeliveryLocalHasBeenCompletedAndHasADate:
    "Vérifiez si l'une des tâches éligibles à la génération de rapports (Enlèvement, Livraison, Local) a été complétée et a une date",
  asn: "ASN",
  containerSize: "Taille du conteneur",
  selectOne: "Sélectionner un",
  seal: "Scellé",
  consignee: "Destinataire",
  consigneeCode: "Code destinataire",
  deliverToWarehouse: "Livrer à l'entrepôt",
  serviceType: "Type de service",
  shipTerms: "Conditions d'expédition",
  mbl: "MBL",
  hbl: "HBL",
  loadingPort: "Port de chargement",
  destinationPort: "Port de destination",
  dischargePort: "Port de déchargement",
  searchAddress: "Rechercher une adresse",
  shipperOriginAirport: "Aéroport d'origine de l'expéditeur",
  receiverDestinationAirport: "Aéroport de destination du destinataire",
  airports: "Aéroports",
  ports: "Ports",
  roads: "Routes",
  scannedDate: "Date de scan",
  pickUpFromOrigin: "Enlèvement à l'origine",
  ataAtOrigin: "ATA à l'origine",
  ataAtDestination: "ATA à destination",
  actualDeliveryDate: "Date de livraison réelle",
  senderOriginRoad: "Route d'origine de l'expéditeur",
  receiverDestinationRoad: "Route de destination du destinataire",
  roadName: "Nom de la route",
  estimatedDeliveryDate: "Date de livraison estimée",
  noReportsAddedToFavorites: "Aucun rapport ajouté aux favoris",
  go: "Aller",
  itemInstructions: "Instructions de l'article",
  chooseAnItemInstruction: "Choisir une instruction d'article",
  notHaveDatesYet: "Pas encore de dates",
  videoSurveyRecordDeleted: "Enregistrement de visite vidéo supprimé",
  theVideoRecordedForThisSurveyWasDeletedAsTheStatusHasChangedTo:
    "La vidéo enregistrée pour cette visite a été supprimée car le statut a changé en",
  youDoNotHaveAccessToThisRecordAnymore: "Vous n'avez plus accès à cet enregistrement.",
  diary: "Journal",
  day: "Jour",
  days: "Jours",
  see: "Voir",
  moreTasks: "plus de tâches",
  sequenceMustBeAValidNumber: "*La séquence doit être un nombre valide",
  sequenceMustBeAIntegerNumber: "*La séquence doit être un nombre entier",
  sequenceMustBeGreaterThan0: "*La séquence doit être supérieure à 0",
  sequenceMustBeSmallerThan1000: "*La séquence doit être inférieure à 1000",
  noTasksRegisteredForTheDay: "Aucune tâche enregistrée pour la journée",
  startsAt: "Commence à : ",
  search: "Rechercher",
  seeTaskOnOrder: "Voir la tâche sur la commande",
  taskDetails: "Détails de la tâche",
  storageBoxes: "Boîtes de stockage",
  storageBoxTypes: "Types de boîtes de stockage",
  prepayment: "Acompte",
  noneInformationToShow: "Aucune information à afficher",
  tasks: "Tâches",
  assignTask: "Attribuer une tâche",
  printJob: "Imprimer le travail",
  cancelTask: "Annuler la tâche",
  yesCancelTask: "Oui, annuler la tâche",
  areYouSureYouWantToCancelThisTask: "Êtes-vous sûr de vouloir annuler cette tâche ?",
  searchByFleet: "Rechercher par flotte",
  searchByStaff: "Rechercher par personnel",
  searchByLeader: "Rechercher par responsable",
  searchByStorageBox: "Rechercher par boîte de stockage",
  orderReference: "Référence de Commande",
  taskStartsAt: "La tâche commence à",
  languageName: "Nom de la langue",
  australianEnglishSystem: "Anglais australien (Système)",
  thisIsTheName: "C'est le nom",
  term: "Terme",
  createdBy: "Créé par",
  lengthM: "Longueur(m)",
  taskList: "Liste des Tâches",
  exception: "Codes d'exception",
  cancelled: "Annulé",
  labelTooltipRecording: "Enregistrement",
  labelTooltipNotRecording: "Pas d'enregistrement",
  youAreNotAllowedToEditThisQuote: "Vous n'êtes pas autorisé à modifier ce devis",
  youAreNotAllowedToEditThisOrder: "Vous n'êtes pas autorisé à modifier cette commande",
  fileDownloadComplete: "Téléchargement du fichier terminé",
  scheduleNow: "Planifier maintenant",
  videoSurveyUnavailable: "Visite vidéo indisponible",
  thisVideoSurveyHasBeenClosed: "Cette visite vidéo a été fermée",
  pleaseScheduleAnotherSurveyToContinue: "Veuillez planifier une autre visite pour continuer",
  youCanScheduleAnotherVideoSurveyNowOrLater: "Vous pouvez planifier une autre visite vidéo maintenant ou plus tard",
  theCustomerHasRemovedTheCallRecordingPermission:
    "Le client a retiré l'autorisation d'enregistrement de l'appel",
  theCustomerAllowedTheRecordThisCallIsBeingRecordedFromNowOn:
    "Le client a autorisé l'enregistrement. Cet appel est enregistré à partir de maintenant.",
  recordingVS: "Enregistrement",
  notRecording: "Pas d'enregistrement",
  readyToShip: "Prêt à expédier",
  port: "Port",
  deliverTo: "Livrer à",
  plane: "Avion",
  journey: "Trajet",
  airwayBill: "Lettre de transport aérien",
  cfs: "CFS",
  addNewContainer: "Ajouter un nouveau conteneur",
  acmeClothing: "Acme vêtements",
  purchasingOrganisation: "Organisation d'achat",
  orderNumber: "Commande Numéro",
  amosToken: "Token AMOS",
  token: "Token",
  australia: "Australie",
  sistrs: "SISTRS",
  pleaseEnterAValidToken: "Veuillez entrer un token valide",
  revokeConnection: "Révoquer la connexion",
  areYouSureYouWantToRevokeTheConnection: "Êtes-vous sûr de vouloir révoquer la connexion ?",
  amos: "AMOS",
  copyKey: "Copier key",
  inviteSISTR: "Inviter SISTR",
  editSISTR: "Modifier SISTR",
  SISTRemail: "E-mail SISTR",
  emailAlreadyExists: "L'e-mail existe déjà",
  waybills: "Lettres de transport",
  moreOrders: "Plus orders",
  etd: "ETD",
  print: "Imprimer",
  seeReport: "Voir le rapport",
  reportType: "Type de rapport",
  uploaded: "Téléversé",
  uploadFile: "Téléverser un fichier",
  documentsUploaded: "Documents téléversés",
  dragOrClickToUploadYourFile: "Faites glisser ou cliquez pour téléverser votre fichier",
  waybill: "Lettre de transport",
  estimateDates: "Dates estimées",
  aircraftDestination: "Destination de l'avion",
  aircraftOrigin: "Origine de l'avion",
  aircraft: "Aéronef",
  unpackDate: "Date de Déballage",
  pickDate: "Date Pick",
  arrivalOfDestination: "Date de Livraison",
  deleteShipment: "Supprimer l'Expédition",
  image: "Image",
  billOfLanding: "Connaissement",
  enterBillOfLanding: "Entrer le connaissement",
  billOfLandingMustBeAtLeast7CharactersLong: "Le connaissement doit comporter au moins 7 caractères",
  billOfLandingMustBeAtMax20CharactersLong: "Le connaissement doit comporter au maximum 20 caractères",
  tradingName: "Nom commercial",
  youCanGetStartedTrackingShipmentsFromHereRegardlessOfHowManyForwardersOrRoutes:
    "Vous pouvez commencer à suivre les expéditions ici, quel que soit le nombre de transitaires ou d'itinéraires.",
  eitherUploadACsvFileUsingTheTemplateOrClickNextToEnterAContainerNumber:
    "Téléversez un fichier CSV en utilisant le modèle ou cliquez sur suivant pour entrer un numéro de conteneur.",
  uploadYourShipmentDetails: "Téléversez les détails de votre expédition",
  due: "Dû",
  notDefined: "Non défini",
  viewFile: "Voir le fichier",
  thisFileIsRequired: "Ce fichier est requis",
  tryAgain: "Réessayer",
  tryAgain2: "Réessayer",
  ifThisIsTakingTooLong: "Si cela prend trop de temps,",
  uploadMade: "Téléverser made",
  theFileMustBeLessThan2mbInSize: "Le fichier doit faire moins de 2 Mo",
  invite: "Inviter",
  inviteSupplier: "Inviter le fournisseur",
  inviteSuppliers: "Inviter les fournisseurs",
  doYouWantToInvite: "Voulez-vous inviter",
  toShipeezi: "à Shipeezi ?",
  anInvitationWillBeSendTo: "Une invitation sera envoyée à",
  activeContainers: "Conteneurs Actifs",
  avgContainerPerWeek: "Moy. conteneurs par semaine",
  containersDelayed: "Conteneurs Retardé",
  containersWaitingAtGate: "Conteneurs en attente au portail",
  totalContainers: "Total des Conteneurs",
  containersTracked: "Conteneurs Tracked",
  averageDelay: "Retard moyen",
  shipmentsTracked: "Expéditions Suivies",
  currentVesselsWithShipmentsBeingTracked: "Navires actuels avec des expéditions suivies",
  ctaDate: "Date CTA",
  teu: "TEU",
  atd: "ATD",
  actualTimeOfDeparture: "Réel Heure of Departure",
  etaDate: "Date ETA",
  arrivalDate: "Date d'arrivée",
  via: "Via",
  customerEmail: "E-mail du client",
  estimatedDate: "Date estimée",
  estimatedTimeOfPortArrival: "Heure estimée d'arrivée au port",
  estimatedTimeOfAirportArrival: "Heure estimée d'arrivée à l'aéroport",
  companyLogo: "Logo de l'Entreprise",
  yourShipmentIsExpectedToArriveAt: "Votre expédition devrait arriver à",
  poweredBy: "Propulsé par",
  localTime: "Heure locale",
  booked: "Réservé",
  collectedFromShipper: "Collecté chez l'expéditeur",
  notArrivedAtPortOfLoad: "Pas encore arrivé au port de chargement",
  waitingAtPortOfLoad: "En attente au port de chargement",
  shippedOnBoard: "Embarqué à bord",
  underway: "En route",
  underwayToATranshipmentPort: "En route vers un port de transbordement",
  arrivalAtTranshipmentPort: "Arrivée au port de transbordement",
  waitingAtTranshipmentPort: "En attente au port de transbordement",
  shippedOnBoardAtTranshipmentPort: "Embarqué à bord au port de transbordement",
  arrivedAtPortOrDischarge: "Arrivé au port ou au déchargement",
  waitingAtDestinationPort: "En attente au port de destination",
  leftTheDestinationPort: "A quitté le port de destination",
  shipmentCompleted: "Expédition terminée",
  maerskCode: "Maersk Code",
  maerskBeCode: "Maersk BE Code",
  clientCode: "Code client",
  addressCode: "Adresse Code",
  divisionCode: "Code division",
  divisionDescription: "Description de la division",
  departmentCode: "Code département",
  departmentDescription: "Description du département",
  sscc: "SSCC",
  ssccQuantity: "Quantité SSCC",
  quantityUnit: "Unité de quantité",
  purchasePrice: "Purchase Prix",
  style: "Style",
  colour: "Couleur",
  size: "Taille",
  expand: "Développer",
  deleteThisSsccAndYourProducts: "Supprimer ce SSCC et vos produits",
  purchaseOrders: "Bons de Commande",
  addNewOrder: "Ajouter une nouvelle commande",
  orderDate: "Date de commande",
  shipper: "Expéditeur",
  readyForBooking: "Prêt pour la réservation",
  selectOrdersBelowToAddThem: "Sélectionnez les commandes ci-dessous pour les ajouter",
  expectedStartDate: "Prévu Démarrer Date",
  expectedEndDate: "Prévu End Date",
  assigned: "Attribué",
  bookByDate: "Réserver par date",
  createBooking: "Créer une Réservation",
  confirmed: "Confirmé",
  underReview: "En Révision",
  received: "Reçu",
  pending: "En attente",
  loadingBookings: "Chargement des Réservations",
  scanned: "Scanné",
  noThanks: "Non, thanks",
  cancelBooking: "Annuler la réservation",
  areYouSureYouWantToCancelTheBooking: "Êtes-vous sûr de vouloir annuler la réservation",
  scannedItems: "Articles scannés",
  thisOrderIsCancelled: "Cette commande est annulée",
  packingType: "Type d'Emballage",
  conditionAtOrigin: "Condition à l'Origine",
  conditionAtDestination: "Condition à la Destination",
  conditionsAtOrigin: "Conditions à l'origine",
  conditionsAtDestination: "Conditions à destination",
  conditionAt: "Condition à",
  upgradeVersionToDoThis: "Mettez à niveau la version pour effectuer cela",
  viewProduct: "Voir le Produit",
  hscode: "HSCODE",
  unitPrice: "Prix Unitaire",
  totalPrice: "Prix Total",
  shipDate: "Date Ship",
  fobPrice: "FOB Prix",
  createSSCC: "Créer SSCC",
  newSSCCwasCreated: "Un nouveau SSCC a été créé !",
  finish: "Terminer",
  closeSSCC: "Fermer SSCC",
  noInformations: "Aucune information",
  itsCurrentlyLocatedAt: "est actuellement situé à",
  atPosition: "à la position",
  asReportedByMarineTrafficTerrestrialAutomaticIdentificationSystem:
    "tel que rapporté par le système d'identification automatique terrestre MarineTraffic le",
  theVesselIsCurrentlyAtPort: "Le navire est actuellement au port",
  afterAVoyageOriginatingFromPort: "après un voyage partant du port",
  currentLocation: "Localisation actuelle",
  delayTime: "Temps de retard",
  newETA: "Nouveau ETA",
  sendTrackingLinkToACustomer: "Envoyer le lien de suivi à un client ou quelqu'un d'autre",
  areYouSureYouWantToCloseThisSSCC: "Êtes-vous sûr de vouloir fermer ce SSCC ?",
  thisActionCannotBeUndoneAndIfYouWantToModifyThisSSCCYouMustDeleteItAndCreateANewOne:
    "Cette action est irréversible et si vous souhaitez modifier ce SSCC, vous devez le supprimer et en créer un nouveau",
  selectProductsBelowToAddThemToSSCC: "Sélectionnez les produits ci-dessous pour les ajouter au SSCC",
  printLabel: "Imprimer l'étiquette",
  allSelectedSsccMustBeClosedToBePrinted: "Tous les SSCC sélectionnés doivent être fermés pour être imprimés",
  moreContainers: "Plus containers",
  portOfOrigin: "Port de chargement (PoL)",
  consignmentInfo: "Info Consignment",
  originAgent: "Agent d'Origine",
  destinationAgent: "Agent de Destination",
  estimateTimeOfDeparture: "Heure of Departure",
  estimateTimeOfArrival: "Heure of Arrival",
  atDepartureDock: "Au quai de départ",
  inactivateWaybill: "Désactiver le connaissement",
  inactiveWaybill: "Inactif Waybill",
  pleaseAddAValidContainerNumber: "Veuillez ajouter un numéro de conteneur valide",
  waitingForUpdate: "En attente de mise à jour",
  generated: "Généré",
  containerNumberIsInvalid: "Le numéro de conteneur est invalide",
  itemConditions: "Conditions de l'article",
  addAPhoto: "Ajouter une photo",
  conditionsAdded: "Conditions ajoutées",
  noConditions: "Aucune condition",
  noPhotosAdded: "Aucune photo ajoutée",
  itemDescription: "Description de l'article",
  pleaseSelectADescriptiveSymbol: "Veuillez sélectionner un symbole descriptif",
  cbm: "CBM",
  submitted: "Soumis",
  rejected: "Rejeté",
  partiallyDelivered: "Partially Livré",
  bookingMustBeConfirmed: "La réservation doit être confirmée",
  notificationCentre: "Centre de Notifications",
  notificationCenter: "Centre de Notifications",
  addEmailTemplate: "Ajouter Email Modèle",
  from: "De",
  subject: "Sujet",
  bcc: "Cci",
  createNewTemplate: "Créer un nouveau modèle",
  templateName: "Nom du modèle",
  newTemplate: "Nouveau modèle",
  emailDetails: "Détails de l'E-mail",
  emailContent: "Contenu de l'E-mail",
  editEmailTemplate: "Modifier Email Modèle",
  viewEmailTemplate: "Voir Email Modèle",
  smsDetails: "Détails du SMS",
  smsContent: "Contenu du SMS",
  pushNotificationDetails: "Push Notification Détails",
  pushNotificationContent: "Contenu de notification push",
  use178CharactersOrLessForBestDisplay: "Utilisez 178 caractères ou moins pour un affichage optimal",
  smsCharacterLimitHint: "Les SMS de plus de 168 caractères seront divisés en plusieurs messages.",
  selectATemplate: "Sélectionner un Modèle",
  addSMSTemplate: "Ajouter SMS Modèle",
  editSMSTemplate: "Modifier SMS Modèle",
  viewSMSTemplate: "Voir SMS Modèle",
  quoteCreation: "Création de Devis",
  quoteApproval: "Approbation de Devis",
  quoteDecline: "Devis Decline",
  ordersCreation: "Commandes Creation",
  orderDelivered: "Commande Livrée",
  orderCancelled: "Commande Annulée",
  createNewDocument: "Créer un nouveau document",
  documentGenerated: "Document généré",
  resendInvite: "Resend Inviter",
  downloadBookingFile: "Télécharger le fichier de réservation",
  createAndBook: "Créer and book",
  saveAndBook: "Enregistrer and book",
  editBooking: "Modifier la Réservation",
  viewBooking: "Voir la Réservation",
  liveAnimalsAndFish: "Animaux vivants et poissons",
  cerealGrains: "Céréales",
  otherAgriculturalProducts: "Autres produits agricoles",
  feedAndProductsOfAnimalOrigin: "Aliments et produits d'origine animale",
  meatAndSeafood: "Viande et fruits de mer",
  milledGrainProducts: "Produits céréaliers moulus",
  otherPreparedFoodstuffs: "Autre prepared foodstuffs",
  alcoholicBeverages: "Boissons alcoolisées",
  tobaccoProducts: "Produits du tabac",
  buildingStone: "Pierre de construction",
  naturalSands: "Sables naturels",
  gravelAndCrushedStone: "Gravier et pierre concassée",
  otherNonmetallicMinerals: "Autre nonmetallic minerals",
  metallicOres: "Minerais métalliques",
  coal: "Charbon",
  crudePetroleum: "Pétrole brut",
  gasolineKeroseneAndEthanol: "Essence, kérosène et éthanol",
  dieselAndOtherFuelOils: "Diesel et autres carburants",
  otherFossilFuelProducts: "Autres produits de combustibles fossiles",
  basicChemicals: "Produits chimiques de base",
  pharmaceuticalProducts: "Produits pharmaceutiques",
  fertilizers: "Engrais",
  chemicalProductsAndPreparations: "Produits et préparations chimiques",
  plasticsAndRubber: "Plastiques et caoutchouc",
  logsAndWoodInTheRough: "Bois et bois brut",
  woodProducts: "Produits en bois",
  pulpPaperAndPaperboard: "Pâte, papier et carton",
  paperOrPaperboardArticles: "Articles en papier ou carton",
  printedProducts: "Produits imprimés",
  textilesAndLeather: "Textiles et cuir",
  nonmetallicMineralProducts: "Produits minéraux non métalliques",
  metalInBasicShapes: "Métal sous formes de base",
  articlesOfMetal: "Articles en métal",
  machinery: "Machines",
  electronics: "Électronique",
  motorizedAndOtherVehicles: "Véhicules motorisés et autres",
  otherTransportationEquipment: "Autre transportation equipment",
  precisionInstruments: "Instruments de précision",
  furniture: "Mobilier",
  miscellaneousManufacturedProducts: "Produits manufacturés divers",
  wasteAndScrap: "Déchets et rebuts",
  mixedFreight: "Fret mixte",
  commodity: "Marchandise",
  fillThisFieldBeforeAddingAnotherContainer: "Remplissez ce champ avant d'ajouter un autre conteneur",
  youShouldHaveAtLeastOneProductInsideAnSSCCToCloseIt:
    "Vous devez avoir au moins un produit dans un SSCC pour le fermer",
  thisSupplierIsPartOfShipeezi: "Ce fournisseur fait partie de Shipeezi",
  supplierNotFound: "Fournisseur introuvable",
  thisSupplierNotHaveNameToSendInvitation: "Ce fournisseur n'a pas de nom pour envoyer l'invitation",
  thisSupplierDoesNotHaveAnEmailToSendInvitation:
    "Ce fournisseur n'a pas d'adresse e-mail pour envoyer l'invitation",
  emails: "e-mails",
  youCannotInviteInactiveSuppliers: "Vous ne pouvez pas inviter des fournisseurs inactifs",
  financials: "Finances",
  communicationCentre: "Centre de Communication",
  communication_centre: "Centre de Communication",
  notificationTemplates: "Modèles de Notification",
  communicationCentreDescription:
    "Gérez vos modèles de communication, notifications et paramètres en un seul endroit.",
  templateCreatedSuccessfully: "Modèle créé avec succès",
  templateUpdatedSuccessfully: "Modèle mis à jour avec succès",
  templateDuplicatedSuccessfully: "Modèle duplicated avec succès",
  errorCreatingTemplate: "Erreur lors de la création du modèle",
  duplicateTemplate: "Dupliquer le Modèle",
  editTemplate: "Modifier le Modèle",
  preFilled: "Pré-rempli",
  emailTemplates: "Modèles d'E-mail",
  emailTemplate: "Modèle d'e-mail",
  manageEmailTemplatesDescription:
    "Créez et gérez des modèles d'e-mails pour divers besoins de communication.",
  smsTemplates: "Modèles SMS",
  smsTemplate: "Modèle de SMS",
  pushContentCannotExceed: "Le contenu de la notification push ne peut pas dépasser 178 caractères",
  smsContentCannotExceed: "Le contenu du SMS ne peut pas dépasser 168 caractères",
  manageSmsTemplatesDescription: "Créer et gérer des modèles de SMS pour des notifications rapides.",
  manageNotificationsDescription: "Configurer les préférences et paramètres de notification.",
  communicationSettings: "Paramètres de Communication",
  configureCommunicationSettingsDescription:
    "Configurez les préférences de communication et les options de livraison.",
  clickToManage: "Cliquer pour gérer",
  searchTemplates: "Rechercher templates...",
  noTemplatesFound: "Aucun modèle trouvé",
  content: "Contenu",
  availableIn: "Disponible in",
  areYouSureYouWantToChangeTheStatus: "Êtes-vous sûr de vouloir changer le statut ?",
  beneficiaryDetails: "Détails du bénéficiaire",
  beneficiaryBank: "Banque bénéficiaire",
  accountNumber: "Numéro de compte",
  invoiceNumber: "Numéro de facture",
  invoiceNo: "Facture Non",
  ciDate: "Date CI",
  financialsUpdatedSuccessfully: "Finances mises à jour avec succès",
  yourShipmentInformationIsLoading: "Vos informations d'expédition se chargent",
  conditionAddedSuccessfully: "Condition ajoutée avec succès",
  atDestination: "À destination",
  someSelectedSupplierHasNoName: "Certains fournisseurs sélectionnés n'ont pas de nom",
  someSelectedSupplierDoesNotHaveAnEmail: "Certains fournisseurs sélectionnés n'ont pas d'e-mail",
  allSelectedSuppliersMustHaveNameEmailAndNotYetBelongToShipeezi:
    "Tous les fournisseurs sélectionnés doivent avoir un nom, un e-mail et ne pas encore appartenir à Shipeezi",
  photoAddedSuccessfully: "Photo ajoutée avec succès",
  generalSettings: "Paramètres Généraux",
  invalidTag: "Invalide tag",
  removeOrder: "Supprimer la commande",
  houseAirWaybill: "Lettre de transport aérien interne",
  removeSelected: "Retirer Sélectionné",
  createWarehouse: "Créer un Entrepôt",
  noWarehousesToShow: "Aucun entrepôt à afficher",
  statusUpdatedSuccessfully: "Statut mis à jour avec succès",
  supplierPortal: "Portail Fournisseur",
  youreReadyToGo: "Vous êtes prêt !",
  goToLoginPage: "Aller à la page de connexion",
  onUploadedCsvWeHaveFoundSomeErrors: "Dans le CSV téléversé, nous avons trouvé des erreurs",
  youShouldAdjustThoseLinesToproceed: "Vous devez ajuster ces lignes pour continuer",
  youreNowPartOfOurPortal: "Vous faites maintenant partie de notre portail !",
  ssccGeneration: "Génération SSCC",
  mustHave: "Doit avoir",
  digit: "chiffre",
  digits: "chiffres",
  extensionDigit: "Chiffre d'extension",
  gs1CompanyCode: "GS1 Entreprise Code",
  checkDigit: "Vérifier Digit",
  columnMustBeFilled: "la colonne doit être remplie",
  notFound: "non trouvé",
  isNotValid: "n'est pas valide",
  carton: "Carton",
  alreadyHasTheLimitOfProductsInside: "a déjà atteint la limite de produits à l'intérieur",
  thereAreNoRecordsInThisFile: "Il n'y a aucun enregistrement dans ce fichier",
  importance: "Importance",
  important: "Important",
  notImportant: "Pas important",
  markAsUnread: "Marquer comme non lu",
  markAsRead: "Marquer comme lu",
  markAsImportant: "Marquer comme important",
  unmarkAsImportant: "Retirer l'importance",
  importantNotifications: "Notifications importantes",
  markAllAsRead: "Tout marquer comme lu",
  seeAllNotifications: "Voir toutes les notifications",
  ssccOpen: "SSCC ouvert",
  contactVia: "Contacter via",
  orderedQuantity: "Quantité commandée",
  percentage: "Pourcentage",
  areYouSureYouWantToConfirmThisBooking: "Êtes-vous sûr de vouloir confirmer cette réservation",
  onceConfirmedThisWillBeSentTo: "Une fois confirmé, cela sera envoyé à",
  youAreNotAbleToMakeAnyAdditionalChanges: "vous ne pouvez plus effectuer de modifications supplémentaires",
  valueShouldBeBetween: "La valeur doit être entre",
  valueShouldBe: "La valeur doit être",
  someQuantitiesFulilledAreWrongPleaseReviewAndChangeValues:
    "Certaines quantités remplies sont incorrectes. Veuillez vérifier et modifier les valeurs.",
  areYouSureYouWantToDeleteThisShipment: "Êtes-vous sûr de vouloir supprimer cette expédition",
  yesDeleteShipment: "Oui, supprimer cette expédition",
  editWaybill: "Modifier la Lettre de Transport",
  createWaybill: "Créer une Lettre de Transport",
  youCannotAddTheSameAgent: "Vous ne pouvez pas ajouter le même agent",
  saveAndSubscribe: "Enregistrer et s'abonner",
  theProductsMustBelongToTheSameOrder: "Les produits doivent appartenir à la même commande",
  youShouldSelectTheProducts: "Vous devez sélectionner les produits",
  haveProductsFromMultipleOrders: "Contient les produits de plusieurs commandes",
  portOfLoading: "Port de Chargement",
  portOfDischarge: "Port de Déchargement",
  placeOfReceipt: "Lieu de réception",
  shipperDischargeAirport: "Aéroport de déchargement de l'expéditeur",
  shipperReceiptAirport: "Aéroport de réception de l'expéditeur",
  cargoReadyDate: "Date Marchandise Prête",
  hasAlreadyBeenAssigned: "a déjà été attribué",
  isMissingShipByDate: "la date d'expédition est manquante",
  shipByDateIsToEarlyForBooking: "La date d'expédition est trop tôt pour la réservation",
  shipByDateIsToLateForBooking: "La date d'expédition est trop tard pour la réservation",
  office: "Bureau",
  offices: "Bureaux",
  notifyParty: "Partie Notifiée",
  youMustSelectABookingModeFirst: "Vous devez d'abord sélectionner un mode de réservation",
  isDifferentFromBooking: "est différent de la réservation",
  youMustSelectABookingLoadingPortFirst: "Vous devez d'abord sélectionner un port de chargement de réservation",
  youMustSelectABookingDestinationPortFirst: "Vous devez d'abord sélectionner un port de destination de réservation",
  orderAssociated: "Commande associée",
  selectOrder: "Sélectionner la commande",
  youMustSelectABookingDischargePortFirst: "Vous devez d'abord sélectionner un port de déchargement de réservation",
  youMustSelectedABookingCargoReadyDateFirst: "Vous devez d'abord sélectionner une date de cargaison prête pour la réservation",
  mustHaveFourteenDifferenceAtMaxFromCargoReadyDate:
    "doit avoir un écart de 14 jours maximum par rapport à la date de marchandise prête",
  theLimitOfProductsInsideACartonIs: "La limite de produits dans un carton est",
  tolerancePercentage: "Pourcentage de tolérance",
  activatingThisWillControlTheTolerancePercentageOfProductsInsideABookingToTheDefinedValue:
    "L'activation de cette option contrôlera le pourcentage de tolérance des produits dans une réservation à la valeur définie.",
  theInputValueWillBeConvertedIntoAPercentage:
    "La valeur saisie sera convertie en pourcentage",
  youNeedToMatchTheToleranceOfTheRequestedQuantities:
    "Vous devez respecter la tolérance des quantités demandées",
  atLeastOneCartonIsRequiredToCarryOutTheBooking:
    "Au moins un carton est nécessaire pour effectuer la réservation",
  allCartonsMustContainAtLeastOneProduct: "Tous les cartons doivent contenir au moins un produit",
  valueMustBeGreaterThanZero: "*La valeur doit être supérieure à zéro",
  allSelectedProductsMustMeetTheCriteria: "Tous les produits sélectionnés doivent répondre aux critères",
  thisValueMustBeAnInteger: "*Cette valeur doit être un entier",
  shipByDate: "Expédier par date",
  bookedVolume: "Volume réservé",
  receivedVolume: "Volume reçu",
  bookedWeight: "Poids réservé",
  receivedWeight: "Reçu Poids",
  ssccQuantityBooked: "Quantité SSCC réservée",
  ssccQuantityReceived: "Quantité SSCC reçue",
  theValuesWereTheSame: "Les valeurs étaient identiques",
  lessThanBooked: "moins que réservé",
  moreThanBooked: "plus que réservé",
  volumeAndWeight: "Volume & Poids",
  insertTotalValue: "Insérer la valeur totale",
  insertValuesOf: "Insérer les valeurs de",
  defineTotalValueOfSSCCs: "Définir la valeur totale des SSCC",
  defineValuesOfOneSSCC: "Définir les valeurs d'un SSCC",
  SSCCCBM: "CBM SSCC",
  SSCCWeight: "Poids SSCC",
  valueMustBeWithin10OfSupplierValue: "* Attention ! La valeur doit être dans les -/+ 10% de la valeur fournisseur.",
  notReceived: "Non reçu",
  receiveSSCC: "Recevoir SSCC",
  changeIt: "Le changer",
  theBookingWillBeSentBackToTheSupplier: "La réservation sera renvoyée au fournisseur",
  areYouSureYouWantToChangeThisBookingStatusTo:
    "Êtes-vous sûr de vouloir changer le statut de cette réservation en",
  receiveAllSSCC: "Recevoir tous les SSCC",
  closeIt: "Le fermer",
  areYouSureYouWantToMarkThisSSCCAsReceived: "Êtes-vous sûr de vouloir marquer ce SSCC comme reçu",
  youAreAboutMarkAllSSCCAsReceived: "Vous êtes sur le point de marquer tous les SSCC comme reçus",
  areYouSure: "Êtes-vous sûr",
  thisActionCannotbeUndone: "Cette action ne peut pas être annulée",
  yesReceiveAll: "Oui, tout recevoir",
  yesReceiveSSCC: "Oui, recevoir le SSCC",
  allCartonsHaveAlreadyBeenMarkedAsReceived: "Tous les cartons ont déjà été marqués comme reçus",
  bookingSummary: "Résumé de la réservation",
  downloadBookingData: "Télécharger les données de réservation",
  downloadReport: "Télécharger le rapport",
  manageSSCC: "Gérer SSCC",
  closeSSCCs: "Fermer SSCCs",
  areYouSureYouWantToClosethese: "Êtes-vous sûr de vouloir fermer ceux-ci",
  thisActionCannotBeUndoneAndIfYouWantToModifyTheseSSCCsYouMustDeleteItAndCreateNewOnes:
    "Cette action est irréversible et si vous souhaitez modifier ces SSCC, vous devez les supprimer et en créer de nouveaux",
  allSSCCsMustBeReceived: "Tous les SSCC doivent être reçus",
  planned: "Planifié",
  allCartonsShouldBeClosedToCarryOutTheBooking:
    "Tous les cartons doivent être fermés pour effectuer la réservation",
  unavailableNotification: "Notification indisponible",
  shipeeziPredicts: "Prédictions Shipeezi",
  carrierShipeeziPredicts: "Prédictions transporteur Shipeezi",
  allSSCCMustHaveProductsInsideThemToBeClosed:
    "Tous les SSCC doivent contenir des produits pour être fermés",
  photosOf: "Photos de ",
  generalComments: "Commentaires généraux",
  valueMustBeEqualToTheSupplierValue: "La valeur doit être égale à la valeur du fournisseur",
  beCode: "Code BE",
  pleaseEnteraValidBecode: "Veuillez entrer un code BE valide",
  sendTaskToSistrs: "Envoyer la tâche à SISTRS",
  beCodeSupplierExample: "AUDASHING3 VDR",
  beCodeCustomerExample: " AUTHECOTT4 HQ",
  totalSSCC: "Total SSCC",
  markBookingAs: "Marquer la réservation comme",
  selectATriggerFirst: "Sélectionnez d'abord un déclencheur",
  default: "Par défaut",
  commercialInvoice: "Facture commerciale",
  beneficiaryName: "Nom du bénéficiaire",
  beneficiaryAddress: "Adresse du bénéficiaire",
  vatNumber: "Numéro de TVA",
  eori: "EORI -",
  fiscalAgentDetails: "Détails de l'agent fiscal",
  salesContractNumber: "Numéro de contrat de vente",
  salesContractDate: "Date du contrat de vente",
  expNumber: "Numéro EXP",
  bankName: "Nom de la Banque",
  bankAddress: "Adresse de la Banque",
  swiftCode: "Code SWIFT",
  paymentTerms: "Conditions de Paiement",
  termsOfDelivery: "Conditions de Livraison",
  udNumber: "Numéro UD",
  ercNumber: "Numéro ERC",
  rexNumber: "REX Numéro",
  commercialInvoiceDetails: "Détails de la Facture Commerciale",
  cfsReview: "Révision CFS",
  receivedByCFS: "Reçu par CFS",
  lining: "Doublure",
  construction: "Construction",
  category: "Catégorie",
  fabric: "Tissu",
  styleCode: "Code de style",
  brand: "Marque",
  manufacturerDetails: "Manufacturer Détails",
  composition: "Composition",
  downloadAllFiles: "Télécharger tous les fichiers",
  areYouSureYouWantToRemoveThe: "Êtes-vous sûr de vouloir retirer le/la",
  fromThisBooking: "de cette réservation",
  removePurchaseOrder: "Retirer le bon de commande",
  allSSCCsInsideThePurchaseOrderWillAlsoBeRemoved:
    "Tous les SSCC dans le bon de commande seront également supprimés",
  yesRemoveIt: "Oui, remove it",
  markAndNumbers: "Marquer and Numbers",
  limited: "Limité",
  characters: "caractères",
  saveEdit: "Enregistrer la modification",
  cancelEdit: "Annuler la modification",
  purchaseOrderNumber: "PurchaseOrder Numéro",
  cartonName: "Carton Nom",
  quotesStatus: "Statut des Devis",
  someInformationOfThisSkuAreMissing: "Certaines informations de ce SKU sont manquantes",
  writeHere: "Écrire ici",
  createNewRow: "Créer une nouvelle ligne",
  noRowsCreatedYet: "Aucune ligne créée",
  noData: "Aucune donnée",
  estimatedQuote: "Devis estimé",
  yourEstimateQuoteInformationIsLoading: "Vos informations de devis estimé se chargent...",
  youAreAboutToApproveThisEstimateAreYouSure:
    "Vous êtes sur le point d'approuver cette estimation. Êtes-vous sûr ?",
  reasonForDeclining: "Raison du refus",
  reasonForReview: "Raison de la révision",
  estimateQuoteHasBeenApproved: "L'estimation de devis a été approuvée",
  thankYouSoMuchForApprovingTheEstimateWithUs:
    "Merci beaucoup d'avoir approuvé l'estimation avec nous",
  cantDeliverOrderWithBookedStatus: "Impossible de livrer les commandes avec le statut Réservé",
  selectedPrice: "Sélectionné price: ",
  estimateQuoteHasBeenDeclined: "L'estimation de devis a été refusée",
  thisEstimateQuoteHasBeenSentToReview: "Ce devis estimé a été envoyé pour révision",
  weAreVerySorryThatTheQuoteWasNotAsExpectedWeHopeYouCanTryAgainAndEverythingGoesWell:
    "Nous sommes vraiment désolés que l'estimation ne corresponde pas à vos attentes. Nous espérons que vous pourrez réessayer et que tout se passera bien.",
  shipeeziWillAlwaysBeHereWithYou: "Shipeezi sera toujours là pour vous",
  weHaveAlreadyNotifiedTheResponsibleCompanyThatThereAreRevisionsToBeMadeAndIfEverythingGoesCorrectlyYouWillReceiveAReturnShortly:
    "Nous avons déjà informé l'entreprise responsable qu'il y a des révisions à effectuer et si tout se passe correctement, vous recevrez un retour prochainement.",
  saveAndSendToCustomer: "Enregistrer et envoyer au client",
  youHaveToChooseAPriceInTheQuoteTab: "Vous devez choisir un prix dans l'onglet Devis",
  youHaveToChooseAPaymentMethodInTheQuoteTab:
    "Vous devez choisir un mode de paiement dans l'onglet Devis",
  noItems: "Non items",
  theFieldIsEmpty: "Le champ est vide",
  addNewMaterial: "Ajouter un nouveau matériau",
  destinations: "Destinations",
  show: "Afficher",
  taskAdded: "Tâche Ajoutée",
  documentCreatedSuccessfully: "Document créé avec succès",
  documentsUploadedSuccessfully: "Documents uploaded avec succès",
  noCommunicationOptionSelected: "Aucune option de communication sélectionnée",
  notificationSent: "Notification envoyée",
  searchForLocation: "Rechercher un emplacement",
  noNotificationsForNow: "Aucune notification pour l'instant",
  notificationsWillAppearHereWhenThereAreAnyUpdatesToTheTasksYouAreInvolvedIn:
    "Les notifications apparaîtront ici lorsqu'il y aura des mises à jour sur les tâches auxquelles vous participez.",
  markAndNumbersShouldHaveAtLeastOneFilledLine:
    "Marques et numéros doivent avoir au moins une ligne remplie",
  theEstimatedQuoteWasSuccessfullyShared: "Le devis estimé a été partagé avec succès",
  noItemsInQuotedInventory: "Aucun article dans l'inventaire devisé",
  of: "de",
  reportsTo: "Rapporte à",
  changeStatusesTo: "Changer statuses to",
  onlyBookingsWithReceivedByCFSCanChangeToReceivedStatus:
    "Seules les réservations avec le statut « Reçu par CFS » peuvent passer au statut « Reçu »",
  theLinkHasExpired: "Le lien a expiré",
  theEstimatedQuoteLinkHasExpired: "Le lien du devis estimé a expiré.",
  youCanRequestANewOneByClickingOnTheButtonBellow:
    "Vous pouvez en demander un nouveau en cliquant sur le bouton ci-dessous.",
  requestNewLink: "Demander un nouveau lien",
  requestedNewLinkSuccessfully: "Nouveau lien demandé avec succès",
  whatDoYouWantToSendToCustomer: "Que voulez-vous envoyer au client ?",
  shareViaVideoSurveyInvite: "Partager via l'invitation de visite vidéo",
  sendANewInvitationToTheScheduledVideoSurvey:
    "Envoyer une nouvelle invitation à la visite vidéo planifiée",
  shareViaEstimatedQuoteLink: "Partager via le lien du devis estimé",
  sendTheExternalLinkOfEstimatedQuote: "Envoyer le lien externe du devis estimé",
  thisQuoteDoesNotHaveAValidVideoSurveyTask: "Ce devis n'a pas de tâche de visite vidéo valide",
  thisQuoteDoesNotHaveAnEstimate: "Ce devis n'a pas d'estimation",
  createNewOffice: "Créer un nouveau bureau",
  editOffice: "Modifier le Bureau",
  officeStatus: "Statut du bureau",
  selectAtLeastOnePort: "Sélectionnez au moins un port",
  city: "Ville",
  viewPort: "Voir le Port",
  siteCode: "Code du Site",
  locationName: "Nom du lieu",
  portStatus: "Statut du Port",
  site: "Site",
  cityCode: "Code de la Ville",
  bookings: "Réservations",
  theInvitationWasSuccessfullySent: "L'invitation a été envoyée avec succès",
  youMustBeLoggedInToSeeTheInvitation: "Vous devez être connecté pour voir l'invitation !",
  youHaveReachedTheEndOfNotifications: "Vous avez atteint la fin des notifications",
  youHaventAddedAnyPriceYet: "Vous n'avez encore ajouté aucun prix.",
  automaticallyApprove: "Approuver Automatiquement",
  addSignatureForEveryPage: "Ajouter une signature pour chaque page",
  addSignatureForOwnerAndLeaderForEveryPageOfReportsInsteadOfTheLastOne:
    "Ajouter la signature du propriétaire et du responsable sur chaque page des rapports, au lieu de la dernière uniquement",
  whenTheUserApprovesHisQuoteThisWillAutomaticallyUpdateTheQuoteOnTheSystem:
    "Lorsque l'utilisateur approuve son devis, cela mettra automatiquement à jour le devis dans le système.",
  salesAndOPS: "Ventes et OPS",
  sales: "Ventes",
  ops: "OPS",
  onFieldStaff: "Personnel sur le Terrain",
  theCartonCanOnlyContainProductsOfTheSameTypeAndColor:
    "Le carton ne peut contenir que des produits du même type et de la même couleur",
  yourCompanyLogoAndIconRepresentYourBrandIdentityAndValuesThisWillBeUsedInAllCommunicationsAndDocumentsSoItWouldBeGoodToUpload:
    "Le logo et l'icône de votre entreprise représentent l'identité et les valeurs de votre marque. Ils seront utilisés dans toutes les communications et documents, il serait donc bon de les téléverser.",
  downloadOurCsvTemplate: "Télécharger notre modèle CSV",
  csvActions: "Actions CSV",
  leavingOnboarding: "Quitter l'intégration",
  youAreAboutToExitTheOnboardingProcessAreYouSureYouWantToDoThis:
    "Vous êtes sur le point de quitter le processus d'intégration. Êtes-vous sûr de vouloir faire cela ?",
  rememberThatYouWillOnlyBeAbleToUseTheSystemAfterCompletingThisProcess:
    "N'oubliez pas que vous ne pourrez utiliser le système qu'après avoir terminé ce processus.",
  branchName: "Nom de l'agence",
  branchAddedSuccessfully: "Agence ajoutée avec succès!",
  viewBranches: "Voir les Agences",
  inShipeeziYouCanManageBranchesPhysicalLocationsOfYourBusinessAMinimumOf:
    "Dans Shipeezi, vous pouvez gérer les agences (emplacements physiques de votre entreprise). Un minimum de",
  oneBranch: "1 agence",
  mustBeRecorded: "doit être enregistré.",
  resubmitToMODS: "Resoumettre à MODS",
  cantSubmitCancelledBookings: "Impossible de soumettre les réservations annulées",
  cantDownloadCancelledBookings: "Impossible de télécharger les réservations annulées",
  bookingsSubmittedSuccessfully: "Réservation(s) submitted avec succès",
  areYouSureYouWantToReSubmitTheSelectedBookings:
    "Êtes-vous sûr de vouloir soumettre à nouveau la/les réservation(s) sélectionnée(s) ?",
  theBookingFileWillBeSentWithAUpdateStatus: "Le fichier de réservation sera envoyé avec un statut de mise à jour",
  submit: "Soumettre",
  addShipment: "Ajouter une expédition",
  noShipmentAssociatedYet: "Aucune expédition associée pour l'instant",
  addShipmentToOrder: "Ajouter une expédition à la commande",
  removed: "Retiré",
  thisProductWasRemovedFromTheOrder: "Ce produit a été retiré de la commande",
  networkVisible: "Réseau visible",
  partner: "Partenaire",
  uploadImage: "Téléverser une image",
  thisImageWillBeUsedWhenGeneratingCommercialInvoiceAndPackingListDocumentsBeingUsedAsAnEsignature:
    "Cette image sera utilisée lors de la génération de la « Facture commerciale » et des « Documents de liste de colisage », en tant que signature électronique.",
  hereYouCanChooseWheterToSeeTheNetworkAndHaveTheOptionToSelectAndAgent:
    "Ici, vous pouvez choisir de voir le réseau et avoir la possibilité de sélectionner un agent comme partenaire sur une expédition. Si un agent est sélectionné, nous n'enverrons aucune communication au client.",
  doYouHaveAgentShipeeziNetworkKey: "Avez-vous la clé réseau Shipeezi de l'agent ?",
  agentShipeeziNetworkToken: "Token réseau Shipeezi de l'agent",
  thisShipmentHasAPartner: "Cette expédition a un partenaire",
  myAccount: "Mon compte",
  orderCancelledSuccessfully: "Commande annulée avec succès",
  prime: "Prime",
  managePlan: "Gérer le plan",
  lastInvoice: "Dernière facture",
  seeInvoiceHistory: "Voir l'historique des factures",
  invoiceAmount: "Montant de la facture",
  amountOwing: "Montant dû",
  billingDate: "Date de facturation",
  manage: "Gérer",
  userType: "Type d'utilisateur",
  deductibleQty: "Qté déductible",
  extraQty: "Qté supplémentaire",
  quantityUsed: "Quantité utilisée",
  costPerExtraUnit: "Coût par unité supplémentaire",
  totalValue: "Valeur totale",
  addons: "Modules complémentaires",
  addOn: "Extension",
  dueDate: "Date d'échéance",
  amount: "Montant",
  currentAccountAmountOwing: "Actuel Compte Montant Owing",
  nextBillingDate: "Prochaine date de facturation",
  billingCountry: "Pays de facturation",
  needToCancelYourSubscription: "Vous devez annuler votre abonnement?",
  cancelSubscription: "Annuler l'abonnement",
  pleaseNotThatOurPricesAreGSTExclusiveGSTWillBeBilledToAustraliaCustomers:
    "Veuillez noter que nos prix sont hors GST. La GST sera facturée aux clients australiens sauf si un numéro d'entreprise australien (ABN) enregistré GST valide est fourni",
  weKnowCircumstancesCanStometimesChange: "Nous savons que les circonstances peuvent parfois changer",
  butBeforeYouGoHaveYouTriedOur: "Mais avant de partir, avez-vous essayé notre",
  forTechnicalFAQ: "pour les FAQ techniques",
  knowledgeBase: "Base de connaissances",
  invoiceHistory: "Historique des factures",
  invoiceID: "ID de Facture",
  seeInvoice: "Voir la facture",
  noKeepSubscription: "Non, keep subscription",
  areYouSureYouWantToCancelYourSubscription: "Êtes-vous sûr de vouloir annuler votre abonnement",
  ifYouAreInDoubtWeOfferOtherPlansAsWell:
    "En cas de doute, nous proposons également d'autres plans, explorez les plans pour voir nos fonctionnalités.",
  byChoosingToCancelARequestWillBeSentToTeamAndThe:
    "En choisissant d'annuler, une demande sera envoyée à l'équipe et le processus de désinscription commencera.",
  weAreSorryToSeeYouGo: "Nous sommes désolés de vous voir partir !",
  aCancellationRequestHasBeenSentToTheTeamAndWeWillContactYouShortlyToContinueTheOffBoardProcedure:
    "Une demande d'annulation a été envoyée à l'équipe et nous vous contacterons prochainement pour poursuivre la procédure de désinscription.",
  youCanLogoutNow: "Vous pouvez vous déconnecter maintenant",
  paid: "Payé",
  uncollectible: "Irrécupérable",
  waitingForPayment: "En attente de paiement",
  planSummary: "Résumé du plan",
  wantToChangeYourPlan: "Voulez-vous changer votre plan",
  contactSales: "contacter les ventes",
  contactSupport: "Contacter le Support",
  ifYouWantToUpgradeOrDowngradeYourPlanPlease:
    "Si vous souhaitez mettre à niveau ou rétrograder votre plan, veuillez",
  youDontHaveAnyInvoicesYetWhenAnInvoiceIsGeneratedYoullSeeItHere:
    "Vous n'avez pas encore de factures. Lorsqu'une facture est générée, elle apparaîtra ici.",
  thisShipmentHasAnAgent: "Cette expédition a un agent",
  containerSizeType: "Taille et type de conteneur",
  addOrderToShipment: "Ajouter une commande à l'expédition",
  uploadYourFile: "Téléverser votre fichier",
  maxImageSize: "Taille maximale de l'image",
  changePicture: "Changer l'image",
  ExporterInformationIsDifferentFromTheVendor: "Les informations de l'exportateur diffèrent du fournisseur",
  exporterName: "Nom de l'exportateur",
  exporterContactDetails: "Coordonnées de l'exportateur",
  canBeJust: "peut être juste ",
  or: "ou",
  companies: "Entreprises",
  ThisProcessIsRecommendedForCompaniesThatHave10OrMoreUsersButOnlyAdminAndGeneralRolesAreAvailableInThisStep:
    "Ce processus est recommandé pour les entreprises ayant 10 utilisateurs ou plus, mais seuls les rôles administrateur et général sont disponibles à cette étape.",
  introduction: "Introduction",
  welcomeToShipeezi: "Bienvenue sur Shipeezi!",
  unleashThePowerOfYourNewSoftware: "Libérez la puissance de votre nouveau logiciel - À quelques étapes !",
  wereConfidentThatYoullFindOurPlatformToBeAnInvaluableTool:
    "Nous sommes convaincus que vous trouverez notre plateforme indispensable pour mettre fin à la fragmentation et offrir une visibilité de bout en bout sur vos opérations. Commençons.",
  firstlyLetsAddYourCompanyDetailsToYourAccountIncludingBusinessAddress:
    "Tout d'abord, ajoutons les détails de votre entreprise à votre compte, y compris l'adresse professionnelle, le numéro de téléphone, le contact principal et les informations d'adresse e-mail.",
  nextWellSetUpYourCompanyUsersAndDefineTheirPermissionsAndAccessLevels:
    "Ensuite, nous configurerons les utilisateurs de votre entreprise et définirons leurs autorisations et niveaux d'accès.",
  finallyWellAskYouToUploadPreliminaryInformationToAssistOurTeamWithConnectingYourDataStreams:
    "Enfin, nous vous demanderons de téléverser des informations préliminaires pour aider notre équipe à connecter vos flux de données.",
  deleteComment: "Supprimer le commentaire",
  areYouSureYouWantToDeleteThisComment: "Êtes-vous sûr de vouloir supprimer ce commentaire ?",
  itLooksLikeTheresNoCommentsYet: "Il semble qu'il n'y ait pas encore de commentaires",
  feelFreeToAddAnyCommentsYouFeelNecessary: "N'hésitez pas à ajouter tout commentaire que vous jugez nécessaire",
  typeHereYourNote: "Saisissez votre note ici...",
  notifyPartyStatus: "Statut de la Partie Notifiée",
  editNotifyParty: "Modifier la Partie Notifiée",
  viewNotifyParty: "Voir la Partie Notifiée",
  createNotifyParty: "Créer une Partie Notifiée",
  searchForAgent: "Rechercher un agent",
  bodyOfEmail: "Corps de l'e-mail",
  bodyOfSMS: "Corps du SMS",
  cartons: "Cartons",
  custom: "Personnalisé",
  customTime: "Heure personnalisée",
  shipeeziBilling: "Facturation Shipeezi",
  theExtraQuantityIsTheDifferenceBetweenTheQuantityUsedAndDeductibleQty:
    'The extra quantity is the difference between the "Quantity used" and "Deductible qty”',
  templateDetails: "Modèle details",
  youCannotCreateATemplateWithABrokenTag: "Vous ne pouvez pas créer un modèle avec une balise cassée",
  receiveUsingCSV: "Recevoir via CSV",
  couldNotFoundSSCC: "SSCC introuvable",
  searchForAContact: "Rechercher un contact",
  setTemplateAsDefault: "Définir le modèle par défaut",
  ssccNotFound: "SSCC introuvable",
  ssccFound: "SSCC trouvé",
  setAsDefault: "Définir par défaut",
  yesChangeIt: "Oui, changer",
  changeDefault: "Changer le défaut",
  doYouWantToMakeTheSelectedTemplateTheDefault:
    "Souhaitez-vous définir le modèle sélectionné comme modèle par défaut ?",
  theCurrentDefaultForThisTypeWillBeReplaced: "Le défaut actuel pour ce type sera remplacé.",
  youCanChangeItBackLaterIfYouWant: "Vous pourrez le changer plus tard si vous le souhaitez.",
  cartonStatus: "Statut du carton",
  weightAndCBMOfThisBookingMustBeConfirmedBeforeThisCanBeDone:
    "Le poids et le CBM de cette réservation doivent être confirmés avant cela, vous pouvez ajuster les valeurs dans l'onglet CBM et Poids",
  allSSCCMustBeReceived: "Tous les SSCC doivent être reçus",
  confirmAndReceive: "Confirmer et recevoir",
  allSSCCsFromCsvWereMarkedAsReceived: "Tous les SSCC du CSV ont été marqués comme reçus",
  boxesCouldntBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain:
    "boîtes n'ont pas pu être marquées comme reçues. Veuillez vérifier toutes les erreurs dans le document Données de scan d'entrepôt et réessayer",
  NoneSSCCsCouldBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain:
    "Aucun SSCC n'a pu être marqué comme reçu. Veuillez vérifier toutes les erreurs dans le document Données de scan d'entrepôt et réessayer",
  attention: "Attention",
  containerNumberIsRequired: "Le numéro de conteneur est obligatoire",
  youShouldAddAtLeastOneOrderToTheShipment: "Vous devez ajouter au moins une commande à l'expédition",
  thisFieldMustBeGreaterThanOrEqualTo0: "*Ce champ doit être supérieur ou égal à 0",
  dcCode: "Code DC",
  thisIsADeliveryLocation: "C'est un lieu de livraison",
  stayLoggedIn: "Rester connecté",
  aSubscribedShipmentWasUnselectedAndCannotBeRemoved:
    "Une expédition abonnée a été désélectionnée et ne peut pas être supprimée !",
  saveAsDraft: "Enregistrer comme brouillon",
  tracking: "Suivi",
  thereWasAProblemTryingToImportTheFilePleaseRefreshThePage:
    "Un problème est survenu lors de l'importation du fichier. Veuillez actualiser la page et réessayer.",
  theFileWasSentToImport: "Le fichier a été envoyé pour import",
  vesselPositionUpdateDailyAt5pmUTC: "Les positions des navires se mettent à jour quotidiennement à 17h UTC",
  locationIndicatedAboveIsMoreAccurateIfItDiffersFromMapDisplay:
    "L'emplacement indiqué ci-dessus est plus précis s'il diffère de l'affichage de la carte",
  unableToExportCSVFile: "Impossible d'exporter le fichier CSV",
  analytics: "Analytique",
  uploadDateAndTime: "Date et heure de téléversement",
  exporter: "Exportateur",
  shipmentNumber: "Expédition Numéro",
  postCode: "Code postal",
  itemType: "Article type",
  consignmentNumber: "Numéro d'envoi",
  pieces: "Pièces",
  stocksToDespatch: "Stocks à expédier",
  palletsToDespatch: "Palettes to despatch",
  deliveryWindowOpen: "Livraison Window Ouvert",
  deliveryWindowClose: "Livraison Window Fermer",
  shippingItems: "Shipping Articles",
  truck: "Camion",
  addExistingAddress: "Ajouter Existing Adresse",
  newAddress: "Nouveau Adresse",
  noDeliveryAddressAddedYet: "Aucune adresse de livraison ajoutée",
  noPickupAddressAddedYet: "Aucune adresse d'enlèvement ajoutée",
  addresses: "Adresses",
  createDespatch: "Créer Despatch",
  editDespatch: "Modifier Despatch",
  staged: "Mis en scène",
  inTransit: "En transit",
  newPickUpAddress: "Nouveau Pick up Adresse",
  newDeliveryAddress: "Nouveau Livraison Adresse",
  editPickUpAddress: "Modifier Pick up Adresse",
  editDeliveryAddress: "Modifier Livraison Adresse",
  labelAddress: "Adresse de l'étiquette",
  pickUpAddress: "Pick up Adresse",
  addAddresses: "Ajouter addresses",
  palletsPerTrucks: "Palettes par Camion",
  newShippingItem: "Nouveau Shipping Article",
  editShippingItem: "Modifier Shipping Article",
  itLooksLikeThereSNoDataYet: "Il semble qu'il n'y ait pas encore de données",
  youWillBeAbleToSeeAllTheInformationAboutThe:
    "Vous pourrez voir toutes les informations sur le/la",
  associatedWithTheDespatchWhenYouAddThem: "associés à l'expédition lorsque vous les ajoutez",
  addShippingItems: "Ajouter Shipping Articles",
  editTruck: "Modifier Camion",
  newTruck: "Nouveau Camion",
  quantityOnHand: "Quantité en stock",
  allDespatched: "Tous Despatched",
  available: "Disponible",
  youCanStartByCreatingANew: "Vous pouvez commencer par créer un nouveau",
  passwordsDoNotMatch: "Les mots de passe ne correspondent pas.",
  theresNoEstimatesAvailableToView: "Il n'y a pas d'estimations disponibles à consulter",
  userHasAccessTo: "L'utilisateur a accès à...",
  poConfirmedVsPOReceived: "PO Confirmé vs PO Reçu",
  poPastShipByDate: "BC date d'expédition dépassée",
  pastShipByDate: "Date d'expédition dépassée",
  pendingPurchaseOrders: "En attente Purchase Commandes",
  printReport: "Imprimer le rapport",
  addTruck: "Ajouter Camion",
  maxValueAccepted: "Valeur maximale acceptée",
  averageMonthlyCost: "Average Monthly Coût",
  averageOverTheLast12MonthsExcludingTaxes: "Moyenne sur les 12 derniers mois hors taxes",
  templates: "Modèles",
  youShouldAddAtLeastOnePickUpAddress: "Vous devez ajouter au moins une adresse d'enlèvement",
  youShouldAddAtLeastOneDeliveryAddress: "Vous devez ajouter au moins une adresse de livraison",
  youShouldAddAtLeastOneProduct: "Vous devez ajouter au moins un produit",
  ayrtonSenna: "Ayrton Senna",
  positionInManufacturingCompany: "Poste dans l'entreprise de fabrication",
  nameOfManufacturingCompany: "Nom de l'entreprise de fabrication",
  egSupplier: "Ex. fournisseur",
  egShipeezi: "Ex. shipeezi",
  searchByCountry: "Rechercher par pays",
  vendorId: "ID Vendor",
  countryOfOrigin: "Pays d'origine",
  accessIntructions: "Instructions d'accès",
  generateInvoice: "Générer invoice",
  schedule: "Planifier",
  associatedWithTheInvoicesWhenYouAddThem: "associés aux factures lorsque vous les ajoutez",
  loadingInvoices: "Loading Factures",
  consol: "Groupage",
  etaMonth: "Mois ETA",
  actualDelivery: "Réel Livraison",
  commInvNo: "Comm Inv Non",
  commInvDate: "Date Comm Inv",
  partNumber: "Part Numéro",
  receivedLinePrice: "Prix de ligne reçu",
  invoiceExchangeRate: "Facture Exchange Rate",
  audValue: "AUD Valeur",
  duty: "droit de douane",
  lineDutyAmount: "Montant des droits de ligne",
  kewill: "Kewill",
  cblNo: "N° CBL",
  mawbNo: "N° MAWB",
  originCharges: "Frais d'origine",
  internationalFreight: "Fret international",
  destinationCharges: "Frais de destination",
  totalFreightAUD: "Total fret AUD",
  unitFob: "Unité FOB",
  freightCPU: "Fret CPU",
  freightasFOB: "Fret en FOB",
  deleteInvoice: "Supprimer Facture",
  areYouSureYouWantToDeleteTheInvoice: "Êtes-vous sûr de vouloir supprimer la facture",
  invoiceQuantity: "Quantité de la facture",
  houseBill: "Connaissement interne",
  masterBill: "Connaissement principal",
  hblCountMode: "Mode de comptage HBL",
  chargeCode: "Code de frais",
  overseasAmount: "Montant à l'étranger",
  exchangeRateCurrency: "Devise du taux de change",
  exchangeRate: "Taux de change",
  invoicedLocalAmount: "Montant local facturé",
  gstAmount: "GST Montant",
  invoiceDate: "Date de facture",
  invoiceDueDate: "Date d'échéance de facture",
  autoRate: "Taux automatique",
  cottonOnAdultsApportionment: "Cotton On Adults Apportionment",
  cottonOnAdultsLocalAmount: "Montant local Cotton On Adults",
  ceresLifeApportionment: "Ceres Life Apportionment",
  ceresLifeLocalAmount: "Montant local Ceres Life",
  bodyApportionment: "Répartition du corps",
  bodyLocalAmount: "Montant local Body",
  factorieApportionment: "Factorie Apportionment",
  factorieLocalAmount: "Factorie Local Montant",
  kidsApportionment: "Kids Apportionment",
  kidsLocalAmount: "Kids Local Montant",
  rubiApportionment: "Rubi Apportionment",
  rubiLocalAmount: "Rubi Local Montant",
  foundationApportionment: "Foundation Apportionment",
  foundationLocalAmount: "Foundation Local Montant",
  typoApportionment: "Typo Apportionment",
  typoLocalAmount: "Typo Local Montant",
  gamedayApportionment: "Gameday Apportionment",
  gamedayLocalAmount: "Gameday Local Montant",
  supreApportionment: "Supre Apportionment",
  supreLocalAmount: "Supre Local Montant",
  fixturesApportionment: "Fixtures Apportionment",
  fixturesLocalAmount: "Fixtures Local Montant",
  consumablesApportionment: "Répartition des consommables",
  consumablesLocalAmount: "Montant local consommables",
  otherApportionment: "Autre répartition",
  otherLocalAmount: "Autre montant local",
  dateType: "Type de date",
  searchBy: "Rechercher par",
  sendReportByEmail: "Envoyer le rapport par e-mail",
  originCountry: "Pays d'origine",
  part: "Pièce",
  id: "Id",
  createSendRecurrence: "Créer une récurrence d'envoi",
  daily: "Quotidien",
  weekly: "Hebdomadaire",
  monthly: "Mensuel",
  frequency: "Fréquence",
  isNotAValidEmail: "n'est pas un e-mail valide",
  emailScheduled: "E-mail programmé",
  emailSent: "E-mail envoyé",
  storageStatus: "Statut de stockage",
  newStorageBox: "Nouvelle boîte de stockage",
  editStorageBox: "Modifier la boîte de stockage",
  newStorageBoxType: "Nouveau type de boîte de stockage",
  editStorageBoxType: "Modifier le type de boîte de stockage",
  typeNumber: "Numéro de type",
  depth: "Profondeur",
  deleteStorageBox: "Supprimer la boîte de stockage",
  deleteStorageBoxType: "Supprimer le type de boîte de stockage",
  areYouSureYouWantToDeleteThisStorageBox: "Êtes-vous sûr de vouloir supprimer cette boîte de stockage",
  areYouSureYouWantToDeleteThisStorageBoxType:
    "Êtes-vous sûr de vouloir supprimer ce type de boîte de stockage",
  createSmsTemplate: "Créer un modèle SMS",
  notBeingUsed: "Non utilisé",
  inUse: "En cours d'utilisation",
  template: "Modèle",
  hideCc: "Masquer CC",
  hideBcc: "Masquer BCC",
  showCc: "Afficher CC",
  showBcc: "Afficher BCC",
  sendEstimateToCustomer: "Envoyer l'estimation au client",
  writeYourOwnOrChooseFromPreSetTemplates: "Écrivez le vôtre ou choisissez parmi des modèles prédéfinis",
  storageBoxesAndUnits: "Boîtes et unités de stockage",
  writeYourOwnOrChooseFromTemplates: "Écrivez le vôtre ou choisissez parmi les modèles",
  movement: "Mouvement",
  movements: "Mouvements",
  objectToMove: "Objet à déplacer",
  storageBox: "Boîte de stockage",
  looseItem: "Article en vrac",
  typeOfObject: "Type d'objet",
  seeObjectActivity: "Voir l'activité de l'objet",
  moveTo: "Déplacer vers",
  object: "Objet",
  moveToLocation: "Déplacer vers l'emplacement",
  move: "Déplacer",
  someObjectDetailsWillBeDisplayedWhenYouSelectIt:
    "Certains détails de l'objet seront affichés ici lorsque vous le sélectionnerez",
  noObjectSelected: "Aucun objet sélectionné",
  insideAStorageBox: "Dans une boîte de stockage",
  seeFullDetails: "Voir tous les détails",
  section: "Section",
  storageBoxDetails: "Détails de la boîte de stockage",
  dateIntoStorage: "Date de mise en stockage",
  lastMoved: "Dernier déplacement",
  isLocatedInTheCellYouAreGoingToMoveDoYouWantToContinue:
    "se trouve dans la cellule que vous allez déplacer, voulez-vous continuer ?",
  isPlacedInThisLocationRightNowWouldYouLikeToMoveItToAnUnknowLocationForNow:
    "est placé à cet emplacement actuellement, souhaitez-vous le déplacer vers un emplacement « inconnu » pour le moment ?",
  the: "Le",
  locationIsFull: "L'emplacement est plein",
  accessTo: "Accès à",
  rows: "Lignes",
  columns: "Colonnes",
  levels: "Niveaux",
  createMap: "Créer Map",
  editMap: "Modifier Map",
  input: "Entrée",
  columnsQuantity: "Nombre de colonnes",
  characterUsed: "Caractère utilisé",
  initial: "Initial",
  suffix: "Suffixe",
  rowsQuantity: "Nombre de lignes",
  levelsQuantity: "Nombre de niveaux",
  buildMap: "Construire la carte",
  numbers: "Nombres",
  alphabetical: "Alphabétique",
  ascendant: "Ascendant",
  descendant: "Descendant",
  deleteMap: "Supprimer Map",
  viewMap: "Voir Map",
  areYouSureYouWantToDeleteThisMap: "Êtes-vous sûr de vouloir supprimer cette carte",
  thisFieldMustBeGreaterThanZero: "Ce champ doit être supérieur à zéro",
  mapGenerated: "Carte générée",
  topView: "Vue de dessus",
  applySearch: "Appliquer la recherche",
  cartonCondition: "État du carton",
  eventDate: "Date Event",
  deliveryStore: "Livraison Store",
  storeNumber: "Store Numéro",
  estimateArriveWH: "ETA arrivée entrepôt",
  arrivalFinalPort: "Arrivée port final",
  meChecklist: "Liste de contrôle M&E",
  haveYouDoneTheMEChecklistOnThisItem: "Avez-vous fait la vérification M&E sur cet article ?",
  meChecklistDone: "Liste de contrôle M&E effectuée",
  unsetAsDefault: "Retirer comme défaut",
  storageAccounts: "Comptes de stockage",
  period: "Période",
  nextBilling: "Suivant billing",
  createNew: "Créer new",
  settlement: "Règlement",
  createNewStorageAccount: "Créer un nouveau compte de stockage",
  storageAccountOrder: "Commande du compte de stockage",
  pickedUp: "Enlevé",
  assignLocation: "Attribuer location",
  assignStorageBox: "Attribuer une boîte de stockage",
  storageSpace: "Espace de stockage",
  unit: "Unité",
  assignStorageBoxLocation: "Attribuer l'emplacement de la boîte de stockage",
  typeStorage: "Type de stockage",
  storageFrom: "Stockage depuis",
  gracePeriodEnd: "Fin de la période de grâce",
  storageEnd: "Fin de stockage",
  selectAPaymentMethod: "Sélectionner un mode de paiement",
  plan: "Plan",
  totalGSTIncluded: "Total (TTC)",
  extraServices: "Services supplémentaires",
  grandTotal: "Total général",
  etaUnpackDate: "Date Eta Unpack",
  finalPortArrival: "Arrivée au port final",
  all: "Tous",
  estimateArrivalWH: "ETA arrivée entrepôt",
  selectAtLeastOneProject: "Sélectionnez au moins un projet",
  expectedQty: "Prévu Qty",
  quantityReceived: "Quantité reçue",
  dateReceived: "Date Reçu",
  selectBranch: "Sélectionner branch",
  selectGroup: "Sélectionner group",
  sections: "Sections",
  createNewSection: "Créer une nouvelle section",
  contains: "contient",
  storageBoxType: "Type de boîte de stockage",
  selectAtLeastOneWarehouseOrSku: "Sélectionnez au moins un entrepôt ou SKU",
  locationPreviewStatus: "Emplacement preview status",
  selectNewLocation: "Sélectionner un nouvel emplacement",
  noMapSelected: "Aucune carte sélectionnée",
  aLittleMapPreviewWillAppearHereWhenYouSelectTheSectionInTheObjectThatShouldBeMoved:
    "Un petit aperçu de la carte apparaîtra ici lorsque vous sélectionnerez la section de l'objet à déplacer",
  unload: "Décharger",
  uploadDate: "Téléverser date",
  viewInWarehouseMap: "Voir sur la carte de l'entrepôt",
  changeLocation: "Changer location",
  funcionalityUnderDevelopment: "Fonctionnalité en cours de développement",
  selectWhichOrderToUnload: "Sélectionnez quelle commande décharger",
  pleasePayAttention: "Attention, s'il vous plaît !",
  onceTheOrderIsUnloadedItCannotChangeStatusAgain:
    "Une fois la commande déchargée, elle ne peut plus changer de statut.",
  full: "Complet",
  unusable: "Inutilisable",
  couldNotFound: "Introuvable",
  selectAtLeastOneContainer: "Sélectionnez au moins un conteneur",
  receivedExpected: "Reçu - Prévu",
  receivedUnexpected: "Reçu - Unexpected",
  notReceivedExpected: "Non reçu - Prévu",
  clear: "Effacer",
  clearFields: "Effacer fields",
  palletDimensions: "Dimensions de la palette",
  cartonDimensions: "Dimensions du carton",
  minimumValue: "Valeur minimale",
  newMap: "Nouveau map",
  theFollowingStorageBoxesAreLoadedAndCanNotChangeStatus:
    "Les boîtes de stockage suivantes sont chargées et ne peuvent pas changer de statut :",
  theFollowingMapsHaveLoadedLocationsAndCanNotChangeStatus:
    "Les cartes suivantes ont des emplacements chargés et ne peuvent pas changer de statut :",
  theFollowingWarehousesHaveSectionsWithMapsInUseAndCanNotChangeStatus:
    "Les entrepôts suivants ont des sections avec des cartes en cours d'utilisation et ne peuvent pas changer de statut :",
  selectAStartDate: "Sélectionner une date de début",
  enterAtLeast: "Entrer at least",
  ordersHaveDifferent: "Les commandes ont un(e) différent(e)",
  jobNumber: "Job Numéro",
  commercialInvoiceNumber: "Commercial Facture Numéro",
  commercialInvoiceDate: "Commercial Facture Date",
  lineDutyPercent: "Pourcentage de droits de ligne",
  nonAUEntryFees: "Frais d'entrée non AU",
  totalUnitCosts: "Coûts unitaires totaux",
  freightAUD: "Fret AUD",
  freightFob: "Fret FOB",
  new: "Nouveau",
  shareable: "Partageable",
  routePlanner: "Itinéraire planner",
  mapSettings: "Paramètres de la carte",
  clearLocation: "Effacer Emplacement",
  routing: "Routage",
  sharedWith: "Partagé avec",
  belongsTo: "Appartient à",
  hasNoWarehouses: "n'a pas d'entrepôts",
  belongsToWarehouse: "Appartient à l'entrepôt",
  sharedWarehouses: "Shared Entrepôts",
  isNotShareable: "Non partageable",
  cartonsPerPallet: "Cartons per Palette",
  allIncluded: "tout inclus",
  exampleOfTiHi: "Exemple de Ti-Hi",
  manufacture: "Fabrication",
  deleteProduct: "Supprimer product",
  unitsInTransit: "Unités en transit",
  originShipments: "Expéditions d'origine",
  cartonsToDespatch: "Cartons à expédier",
  companyCurrentStock: "Entreprise current stock",
  mainSupplier: "Fournisseur principal",
  stock: "Stock",
  cartonWeight: "Poids du carton",
  createProduct: "Créer product",
  byWho: "Par qui",
  objectNumber: "Numéro d'objet",
  newMovement: "Nouveau movement",
  none: "Aucun",
  ordersQuantity: "Quantité de commandes",
  itemsInsideThisStorageBox: "Articles dans cette boîte de stockage",
  bookingNumber: "Réservation number",
  noLocation: "Non location",
  typeInLocation: "Saisissez un emplacement",
  startWarehouse: "Démarrer Entrepôt",
  endWarehouse: "End Entrepôt",
  rta: "RTA",
  addToRoutePlanner: "Ajouter to Planificateur d'itinéraire",
  removingFromRoutePlanner: "Retrait du planificateur d'itinéraire",
  removeFromRoutePlanner: "Retirer du planificateur d'itinéraire",
  removedFromRoutePlanner: "Retiré du planificateur d'itinéraire",
  addingToRoutePlanner: "Adding to Planificateur d'itinéraire",
  addedToRoutePlanner: "Ajouté to Planificateur d'itinéraire",
  couldNotAddToRoutePlanner: "Impossible d'ajouter au planificateur d'itinéraire",
  couldNotRemoveFromRoutePlanner: "Impossible de retirer du planificateur d'itinéraire",
  updatingInRoutePlanner: "Updating in Planificateur d'itinéraire",
  updatedInRoutePlanner: "Mis à jour in Planificateur d'itinéraire",
  couldNotUpdateInRoutePlanner: "Mis à jour in Planificateur d'itinéraire",
  addToRoutePlannerQuestionMark: "Ajouter to Planificateur d'itinéraire ?",
  addAShift: "Ajouter a shift",
  shiftTime: "Heure du quart",
  shiftTimes: "Horaires des quarts",
  addASecondShiftDuration: "Ajouter une deuxième durée de quart",
  scacCode: "Code SCAC",
  carrierName: "Transporteur Nom",
  carrierNameAbbreviation: "Transporteur Nom (Abbr.)",
  editCarrier: "Modifier Transporteur",
  createNewCarrier: "Créer Nouveau Transporteur",
  trackableBy: "Traçable par",
  areYouSureYouWantToDeleteThisCarrier: "Êtes-vous sûr de vouloir supprimer ce transporteur",
  deleteCarrier: "Supprimer Transporteur",
  transshipment: "Transbordement",
  dueDateBy: "Date d'échéance par",
  requestedBy: "Demandé par",
  assignedTo: "Attribué to",
  newTransshipment: "Nouveau transbordement",
  showTodaysTransshipments: "Afficher today’s transshipments",
  generalDetails: "Général details",
  whatToDo: "Que faire",
  team: "Équipe",
  saveAndPublish: "Enregistrer and Publier",
  markItemsYouWantToMove: "Marquez les articles que vous souhaitez déplacer",
  perItem: "Par article",
  bingoSheet: "Feuille de bingo",
  transshiping: "En cours de transbordement",
  thisFieldShouldHaveAlphaNumericCharactersOnly:
    "Ce champ ne doit contenir que des caractères alphanumériques",
  bookingReference: "Réservation Reference",
  showAllStorageBoxes: "Afficher toutes les boîtes de stockage",
  addStorageBox: "Ajouter une boîte de stockage",
  createASingleUseBox: "Créer une boîte à usage unique",
  storageBoxNumber: "Numéro de boîte de stockage",
  volumeAvailable: "Volume disponible",
  theStorageBoxHasBeenAddedSuccessfully: "La boîte de stockage a été ajoutée avec succès",
  itLooksLikeTheresNoDataYet: "Il semble qu'il n'y ait pas encore de données",
  startSearchingForAStorageBoxOrCreateASingleUseBox:
    "Commencez à rechercher une boîte de stockage ou créez une boîte à usage unique.",
  system: "Système",
  editTransshipment: "Modifier le transbordement",
  any: "Tout",
  pickUpTime: "Pick up Heure",
  deliveryTime: "Livraison Heure",
  addDespatchesToRoute: "Ajouter des expéditions à l'itinéraire",
  removeDespatchesToRoute: "Retirer les expéditions de l'itinéraire",
  added: "Ajouté",
  searchForStorageBox: "Rechercher une boîte de stockage",
  noItemsToAddToTransshipment: "Aucun article à ajouter au transbordement",
  showTodayTransshipments: "Afficher les transbordements du jour",
  showing: "Affichage",
  theOrderHasAlreadyBeenAdded: "La commande a déjà été ajoutée",
  publish: "Publier",
  editProject: "Modifier Projet",
  newProject: "Nouveau Projet",
  fileName: "Fichier name",
  dateUploaded: "Date de téléversement",
  ofRows: "de lignes",
  addFile: "Ajouter Fichier",
  whenYouAddThem: "lorsque vous les ajoutez",
  youWillBeAbleToSeeAllThe: "Vous pourrez voir tous les",
  detailsHereWhenYouUploadAtLeastOne: "détails ici lorsque vous téléversez au moins un",
  createProject: "Créer project",
  uploadAFile: "Téléverser un fichier",
  willBeRemoveAllOfTheItemsWillUnloadFromIt:
    "Elle sera supprimée. Tous les articles en seront déchargés.",
  areYouSureYouWantToContinue: "Êtes-vous sûr de vouloir continuer ?",
  removeStorageBox: "Retirer la boîte de stockage",
  cellInUse: "Cellule en cours d'utilisation",
  allWarehouses: "Tous Entrepôts",
  yourStorageBoxesAreBeingUploaded: "Vos boîtes de stockage sont en cours de téléversement",
  automate: "Automatiser",
  sentToEmail: "Envoyé to e-mail",
  editAutomation: "Modifier Automation",
  deletedSuccessfully: "Supprimé avec succès",
  deleteAutomation: "Supprimer automation",
  doYouReallyWantToDeleteTheAutomation: "Voulez-vous vraiment supprimer l'automatisation",
  createOrder: "Créer Commande",
  addNewproducts: "Ajouter de nouveaux produits",
  manual: "Manuel",
  paragraph: "Paragraphe",
  options: "Options",
  addOption: "Ajouter option",
  youNeedToLogOutAndLogBackInForSomeChangesToBeApplied:
    "Vous devez vous déconnecter et vous reconnecter pour que certaines modifications soient appliquées.",
  someChangesWereNotApplied: "Certaines modifications n'ont pas été appliquées",
  enableAsAStorageBox: "Activer comme boîte de stockage",
  enablingThisAllowsTheUserToChooseTheVehicleForStorageMovementOrTransshipmentAndIndicateWhenItemsArePlacedInsideLikeAStorageBox:
    "Activer cette option permet à l'utilisateur de choisir le véhicule pour le mouvement de stockage ou le transbordement et d'indiquer quand les articles sont placés à l'intérieur, comme une boîte de stockage.",
  projectUpdatedWithSuccess: "Projet mis à jour avec succès",
  deleteBrandName: "Supprimer le nom de marque",
  deleteBrandNames: "Supprimer brand names",
  areYouSureYouWantToDeleteTheBrandName: "Êtes-vous sûr de vouloir supprimer le nom de marque",
  areYouSureYouWantToDeleteThese: "Êtes-vous sûr de vouloir supprimer ceux-ci",
  brandName: "Nom de marque",
  brandNames: "Noms de marque",
  brandCode: "Code marque",
  addNewBrandName: "Ajouter un nouveau nom de marque",
  youCanStartByAddingANewBrandName: "Vous pouvez commencer par ajouter un nouveau nom de marque",
  loadingBrands: "Chargement des marques",
  newBrand: "Nouveau brand",
  logo: "Logo",
  editBrand: "Modifier brand",
  viewBrand: "Voir brand",
  deleteBrands: "Supprimer Brands",
  previewOnSSCCLabel: "Aperçu sur l'étiquette SSCC",
  noPdfFileSpecified: "Aucun fichier PDF spécifié",
  loadType: "Type de Load",
  groupageVanline: "Groupage/Vanline",
  otherEnterDims: "Autre (entrer les dimensions)",
  parties: "Parties",
  rail: "Rail",
  itemIsAHardwareBox: "L'article est une boîte de matériel",
  youCanSeeTheReportsAfterSelectingTheFollowingFilters:
    "Vous pouvez voir les rapports après avoir sélectionné les filtres suivants",
  selectAProject: "Sélectionner a project",
  selectAWarehouse: "Sélectionner un entrepôt",
  selectASKU: "Sélectionner a SKU",
  selectAContainer: "Sélectionner a Conteneur",
  brands: "Marques",
  repeat: "Répéter",
  weAreCheckingIfALinkIsAvailable: "Nous vérifions si un lien est disponible",
  pleaseSelectAOrderType: "Veuillez sélectionner un type de commande",
  etaDestination: "ETA destination",
  etaDespatch: "ETA expédition",
  trackable: "Traçable",
  downloadShipmentInformations: "Télécharger Expédition Informations",
  boxContents: "Contenu de la boîte",
  packedInto: "Emballé dans",
  indicateLiftvanOrSectionTheItemCanBeFound: "Indiquez le liftvan ou la section où l'article se trouve",
  values: "Valeurs",
  automaticallyCreateOneHardwareBoxInEveryInventory:
    "Créer automatiquement une boîte matériel dans chaque inventaire",
  needsAtLeastOneActiveHardwareBoxItemToBeEnabled:
    "Nécessite au moins un article de boîte matériel actif pour être activé.",
  carrierScac: "Transporteur scac",
  fieldsAreRequired: "Le numéro de conteneur, la référence de réservation ou le connaissement sont requis.",
  theFleetNameIsUsedAsTheSystemDefault: "Le nom de la flotte est utilisé comme défaut du système",
  isBox: "Est une boîte",
  isBoxInterrogation: "Est une boîte ?",
  isThisTypeOfPackagingABox: "Ce type d'emballage est-il une boîte ?",
  hardwareBox: "Boîte de matériel",
  itemIsHighRiskOrHighValue: "Article à haut risque/haute valeur",
  thisCarrierAllowsShipmentTrackingBy: "Ce transporteur permet le suivi d'expédition par",
  meChecklistIsmandatoryForThisItemPleaseAnswerIt:
    "La liste de contrôle M&E est obligatoire pour cet article, veuillez y répondre",
  enableEstimateEditing: "Activer estimate editing",
  enable: "Activer",
  areYouSureYouWantToEnableEditingEstimateForThisQuote:
    "Êtes-vous sûr de vouloir activer la modification de l'estimation pour ce devis ?",
  changesMadeToThisQuoteMayAlsoAffectOrder: "Les modifications de ce devis peuvent aussi affecter la commande.",
  measurementPreview: "Aperçu des mesures",
  me: "M&E",
  highRiskHighValue: "Élevé Risk / Élevé Valeur",
  proGear: "Pro-Gear",
  itemIsAME: "L'article est un M&E",
  youCanSeeTheReportsAfterSelectingAtLeast: "Vous pourrez voir les rapports après avoir sélectionné au moins",
  warehouseCodeAlreadyExistsPleaseAssignANewCode:
    "Le code entrepôt existe déjà. Veuillez attribuer un nouveau code.",
  enterTheBoxNumberToSearch: "Entrez le numéro de boîte pour rechercher.",
  enterTheOrderToSearch: "Entrez la commande à rechercher.",
  noResults: "Non results",
  etdOrigin: "ETD origine",
  etaPlanned: "ETA planifié",
  addNewShipment: "Ajouter une nouvelle expédition",
  basedOnABooking: "Basé sur une réservation",
  box: "Boîte",
  case: "Caisse",
  pallet: "Palette",
  ftl: "FTL",
  ltl: "LTL",
  fcl: "FCL",
  lcl: "LCL",
  groupage: "Groupage",
  roro: "RORO",
  bulk: "En vrac",
  commodityHSCode: "Code SH marchandise",
  enterTheLocationToSearch: "Entrez l'emplacement à rechercher.",
  productPhoto: "Photo du produit",
  masterbillOfLanding: "Connaissement principal",
  housebillOfLanding: "Connaissement interne",
  shipmentDetails: "Expédition details",
  placeOfOrigin: "Lieu d'origine",
  shipperCode: "Code expéditeur",
  addAnotherContainer: "Ajouter another Conteneur",
  volumetricWeight: "Poids volumétrique",
  grossVolume: "Volume brut",
  tareWeight: "Poids à vide",
  netWeight: "Poids net",
  verifiedGrossWeight: "Verified Gross Poids",
  selectABooking: "Sélectionner une réservation",
  noSubscriberAdded: "Aucun abonné ajouté",
  selectABookingBellowToStartAShipmentBasedOnIt:
    "Sélectionnez une réservation ci-dessous pour démarrer une expédition basée dessus",
  selectJustOneBookingPerShipment: "Sélectionnez une seule réservation par expédition",
  startByAddingASubscribertoShipment: "Commencez par ajouter un abonné à l'expédition",
  youMustSelectAShipmentLoadingPortFirst: "Vous devez d'abord sélectionner un port de chargement d'expédition",
  youMustSelectAShipmentDestinationFirst: "Vous devez d'abord sélectionner une destination d'expédition",
  youMustSelectAShipmentOriginFirst: "Vous devez d'abord sélectionner une origine d'expédition",
  youMustSelectAShipmentDischargePortFirst: "Vous devez d'abord sélectionner un port de déchargement d'expédition",
  youMustSelectAShipmentModeFirst: "Vous devez d'abord sélectionner un mode d'expédition",
  youMustSelectAShipmentIncotermFirst: "Vous devez d'abord sélectionner un incoterm d'expédition",
  variance: "Écart",
  youCanStartByAddingAnOrder: "Vous pouvez commencer par ajouter une commande",
  editSubscriber: "Modifier subscriber",
  fromThisShipment: "de cette expédition",
  regularCargo: "Cargaison standard",
  hazardousCargo: "Cargaison dangereuse",
  foodGradeCargo: "Cargaison de qualité alimentaire",
  rareCargo: "Cargaison rare",
  reeferCargoRefrigerated: "Cargaison réfrigérée",
  addInAContainer: "Ajouter dans un conteneur",
  chooseAContainerToAddTheSsccInto: "Choisir un conteneur pour y ajouter le SSCC",
  choose: "Choisir",
  distanceTravelled: "Distance parcourue",
  distanceToGo: "Distance restante",
  route: "Itinéraire",
  shipeeziPredictsETA: "ETA prédictif Shipeezi",
  plannedETA: "ETA planifié",
  theCarrierProvidesDateTimesBelowAndMayNotMatchObservationsAndPredictionsInOtherSections:
    "Le transporteur fournit les dates-heures ci-dessous et elles peuvent ne pas correspondre aux observations et prédictions dans les autres sections.",
  events: "Événements",
  notEventsToShowAtTheMoment: "Aucun événement à afficher pour le moment",
  dayDelay: "Jour de retard",
  daysDelay: "Jours de retard",
  invalidNumber: "Numéro invalide",
  trackingNotFound: "Suivi introuvable",
  shipmentCreated: "Expédition créée",
  checkTheInformationYouHaveFilledInUpdateItAndSaveItWellValidateItAgainInAFewMinutes:
    "Vérifiez les informations que vous avez saisies, mettez-les à jour et enregistrez-les. Nous les validerons à nouveau dans quelques minutes.",
  weReStillValidatingInformationToSeeIfThisShipmentIsTrackableRefreshThisPageInAFewMinutes:
    "Nous validons encore les informations pour voir si cette expédition est traçable. Actualisez cette page dans quelques minutes.",
  thereIsNoTrackingAvailableForThisShipment: "Il n'y a pas de suivi disponible pour cette expédition.",
  yourShipmentWasSuccesfullyCreatedAndWereNowValidatingTheInformationToSeeIfItsTrackable:
    "Votre expédition a été créée avec succès et nous validons maintenant les informations pour voir si elle est traçable.",
  inAFewMinutesYouCanConsultTheTrackingInfoByClickingTheViewOrEditIconButtonInTheActionsColumnOnTheGrid:
    "Dans quelques minutes, vous pourrez consulter les informations de suivi en cliquant sur le bouton Voir ou Modifier dans la colonne actions de la grille.",
  whatDoYouWantToSend: "Que voulez-vous envoyer ?",
  sendTrackingViaSMSOrEmail: "Envoyer le suivi par SMS ou e-mail",
  sendShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse:
    "Envoyer le suivi d'expédition par SMS ou e-mail au client ou à quelqu'un d'autre",
  writeAnEmailOrUseATemplate: "Rédigez un e-mail ou utilisez un modèle",
  writeASMSOrUseATemplate: "Rédigez un SMS ou utilisez un modèle",
  writeAPushNotificationOrUseATemplate: "Rédigez une notification push ou utilisez un modèle",
  sendJSONFile: "Envoyer le fichier JSON",
  sendOnlyTheJSONFileToCustomer: "Envoyer uniquement le fichier JSON au client",
  trackingNotAvailable: "Suivi non disponible",
  doYouAlsoWantToCancelTheLinkedOrder: "Voulez-vous aussi annuler la commande liée",
  areYouSureYouWantToDeleteThisProduct: "Êtes-vous sûr de vouloir supprimer ce produit",
  createSingleUseBox: "Créer une boîte à usage unique",
  newSingleUseBox: "Nouvelle boîte de stockage à usage unique",
  createAnotherSingleUseBox: "Créer une autre boîte à usage unique",
  searchByContactNameMobilePhoneOrEmailAddress:
    "Rechercher par nom de contact, téléphone mobile ou adresse e-mail",
  searchOrAddAContact: "Rechercher ou ajouter un contact",
  howMany: "Combien ?",
  autoNumberThem: "Numéroter automatiquement",
  typePrefix: "Préfixe de type",
  singleUse: "Usage unique",
  noWarehouses: "Aucun entrepôt",
  byWhom: "Par qui",
  enterTheObjectToSearch: "Entrez l'objet à rechercher.",
  orderOrCustomer: "Commande ou client",
  salutation: "Civilité",
  allowance: "Allocation",
  secondReference: "2ème Référence",
  editLiftvans: "Modifier Liftvans",
  addLiftvans: "Ajouter Liftvans",
  areYouSureYouWantToCancelTheTransshipment: "Êtes-vous sûr de vouloir annuler le transbordement",
  yesCancelTransshipment: "Oui, annuler le transbordement",
  cancelTransshipment: "Annuler le transbordement",
  sendTheShipmentTrackingViaSMSToTheCustomerOrAnotherPerson:
    "Envoyer le suivi d'expédition par SMS au client ou à une autre personne",
  sendTrackingViaSMS: "Envoyer le suivi par SMS",
  createdOn: "Créé le",
  sendTheShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse:
    "Envoyer le suivi d'expédition par SMS ou e-mail au client ou à quelqu'un d'autre",
  sendTrackingViaSMSorEmail: "Envoyer le suivi par SMS ou e-mail",
  weightAndMeasurements: "Poids et mesures",
  storageBoxAdded: "Boîte de stockage ajoutée",
  storageBoxRemoved: "Boîte de stockage supprimée",
  generateCsv: "Générer CSV",
  revokeInvite: "Révoquer l'Invitation",
  yesRevoke: "Oui, révoquer",
  revokeInvitation: "Révoquer l'invitation",
  doYouWantToRevokeTheInvitationSentTheUserWillNoLonge:
    "Voulez-vous révoquer l'invitation envoyée ? L'utilisateur ne pourra plus accepter l'invitation",
  youCanAlwaysInviteThemAgain: "Vous pouvez toujours les réinviter.",
  cancelInvite: "Annuler l'invitation",
  thisInviteWasRevoked: "Cette invitation a été révoquée",
  oopsItLooksLikeThisInvitationHasBeenRevoked:
    "Oups, il semble que cette invitation a été révoquée et n'est plus disponible.",
  ifYouThinkThisIsAnErrorPleaseContactTheCompanyResponsibleToBetter:
    "Si vous pensez qu'il s'agit d'une erreur, veuillez contacter l'entreprise responsable pour mieux comprendre ce qui s'est passé.",
  unlinkInventory: "Dissocier l'Inventaire",
  yesUnlink: "Oui, dissocier",
  doYouWantToUnlinkTheInventory: "Voulez-vous dissocier l'inventaire",
  inventoryLinked: "Inventaire associé",
  inventoryUnlinked: "Inventaire dissocié",
  inventoryLinkedSuccessfully: "Inventaire associé avec succès",
  inventoryUnlinkedSuccessfully: "Inventaire dissocié avec succès",
  relinkInventory: "Réassocier l'Inventaire",
  yesRelink: "Oui, réassocier",
  doYouWantToRelink: "Voulez-vous relier",
  thisActionWillReplaceTheValuesYouveSetWithTheValuesFromYourActualInventory:
    "Cette action remplacera les valeurs que vous avez définies par les valeurs de votre inventaire réel.",
  whenYouUnlinkTheInventoryYouCanEditTheTotalValuesThisMeansThatAnyFutureChangesYouMakeToTheInventoryWillNotBeReflectedInTheseMeasurements:
    "Lorsque vous dissociez l'inventaire, vous pouvez modifier les valeurs totales. Cela signifie que toute modification future de l'inventaire ne sera pas reflétée dans ces mesures.",
  inventoriesSummary: "Résumé des inventaires",
  itemIsProGear: "Article Pro-Gear",
  apps: "Applications",
  thisStorageBoxTypeIsCurrentlyInUseAndItsStatusCantBeChanged:
    "Ce type de boîte de stockage est actuellement utilisé et son statut ne peut pas être modifié",
  allowItemPhotosToBeUploadedFromTheDevicesImageGallery:
    "Autoriser le téléversement des photos d'articles depuis la galerie d'images de l'appareil",
  thisSettingsEnablesMobileAppUsersToUploadImagesFromTheirDevicesGallery:
    "Ce paramètre permet aux utilisateurs de l'application mobile de téléverser des images depuis la galerie de leur appareil",
  thisMayCauseADataSecurityRiskAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices:
    "Cela peut causer un risque de sécurité des données, car cela peut encourager le stockage de photos d'articles clients sur des appareils personnels",
  allowUseOfDeviceGallery: "Autoriser l'utilisation de la galerie de l'appareil",
  galleryUsePermission: "Permission d'utilisation de la galerie",
  enablesUsersToUploadItemImagesFromTheirDevicesGallery:
    "Permet aux utilisateurs de téléverser des images d'articles depuis la galerie de leur appareil",
  note: "Note",
  thisMayCauseAPersonalInformationSecurityRisksAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices:
    "Cela peut causer des risques de sécurité des informations personnelles car cela peut encourager le stockage de photos d'articles clients sur des appareils personnels",
  typeHere: "Tapez ici...",
  hideCC: "Masquer CC",
  hideBCC: "Masquer BCC",
  cc: "Cc",
  linkedTo: "Lié à",
  linkedMaterials: "Matériaux Liés",
  selectAMaterial: "Sélectionner un matériau",
  addAnExistingGroup: "Ajouter un groupe existant",
  newBlankGroup: "Nouveau groupe vide",
  selectOneOrMoreGroups: "Sélectionnez un ou plusieurs groupes",
  addGroup: "Ajouter un groupe",
  showCC: "Afficher CC",
  showBCC: "Afficher BCC",
  asTheShipmentIdentificationIsUniqueYouCannotChangeItAfterCreation:
    "L'identification de l'expédition étant unique, vous ne pouvez pas la modifier après la création",
  generatePDFReport: "Générer un rapport PDF",
  reportLanguage: "Langue du rapport",
  taskReportType: "Type de rapport de tâche",
  addedToContainer: "Ajouté to Conteneur",
  ssccs: "SSCCs",
  typeAComment: "Taper un commentaire",
  addAComment: "Ajouter un commentaire",
  commentsHistory: "Historique des commentaires",
  addedOn: "Ajouté le",
  youCanStartByCreatingASscc: "Vous pouvez commencer par créer un SSCC",
  hereIsYourShipmentInfo: "Voici les informations de votre expédition",
  yourShipmentHasArrivedAt: "Votre expédition est arrivée à",
  commentSpecialInstruction: "Commentaire/Special instruction",
  hsCode: "Code SH",
  typeInAConsignee: "Saisissez un destinataire",
  typeInACustomer: "Saisissez un client",
  typeInOtherParty: "Saisissez une autre partie",
  otherAdditionalParty: "Autre/Additional party",
  byFillingInOneOrMoreOfTheseFieldsYourShipmentWillBeTracked:
    "En remplissant un ou plusieurs de ces champs, votre expédition sera suivie.",
  moreContainerType: "Plus Conteneur Type",
  sendCustomerPortalLink: "Envoyer le lien du portail client",
  typeInToSearch: "Saisissez pour rechercher",
  flight: "Vol",
  generatedBySystem: "Généré par le système",
  mandatory: "Obligatoire",
  newDocument: "Nouveau document",
  clearFile: "Effacer le fichier",
  areYouSureYouWantToDelete: "Êtes-vous sûr de vouloir supprimer",
  deleteDocument: "Supprimer le document",
  notAvailableYet: "Pas encore disponible",
  documentsForThisShipment: "Documents pour cette expédition",
  shipmentMustBeConfirmed: "L'expédition doit être confirmée",
  clearingFile: "Effacement du fichier",
  generatingFile: "Génération du fichier",
  openingFile: "Ouverture du fichier",
  shareCustomerPortalLink: "Partager le lien du portail client",
  sendTheCustomerPortalLinkWithAccessToTheOrderOnline:
    "Envoyer le lien du portail client avec accès à la commande en ligne",
  loading: "Chargement",
  escalation: "Escalade",
  escalationContactRaised: "Escalade/Contact créé",
  removeEscalationRequest: "Retirer escalation request",
  noKeepIt: "Non, le garder",
  ohNoSomethingWentWrongPleaseTryAgain: "Oh non ! Quelque chose s'est mal passé. Veuillez réessayer.",
  escalationRequestHasBeenRemoved: "La demande d'escalade a été supprimée",
  removingThisEscalationChangeRequestWillClearAnyPendingRequests:
    "La suppression de cette demande d'escalade/modification effacera toutes les demandes en attente",
  areYouSureYouWishToProceed: "Êtes-vous sûr de vouloir continuer",
  yourEscalationRequestHasBeenSentSuccessfully:
    "Votre demande d'escalade a été envoyée avec succès",
  inputComment: "Saisir un commentaire",
  sendTo: "Envoyer à",
  selectedPerson: "Personne sélectionnée",
  selectWhoToNotify: "Sélectionnez qui notifier",
  theFollowingEmail: "L'e-mail suivant",
  notify: "Notifier",
  contactUs: "Nous contacter",
  packingItems: "Articles d'emballage",
  closingTheBoxes: "Fermeture des boîtes",
  listeningToBubbleWrapConfessions: "En train d'écouter les confessions du papier bulle",
  parkingTheShip: "Stationnement du navire",
  talkingToTheFish: "Discussion avec les poissons",
  cartonContents: "Contenu du carton",
  ata: "ATA",
  thereIsNoTrackingInformationAvailableForThisShipment:
    "Il n'y a aucune information de suivi disponible pour cette expédition",
  thisTabWillShowSomeTrackingInformationIfAvailableAfterYouCreateTheShipment:
    "Cet onglet affichera des informations de suivi, si disponibles, après la création de l'expédition",
  theresNoTrackingInformationYet: "Il n'y a pas encore d'informations de suivi",
  livePosition: "Position en temps réel",
  containerCase: "Conteneur / Case",
  containerCaseSize: "Taille du conteneur / caisse",
  sealMarkings: "Numéro maritime / Marquages",
  selectALoadType: "Sélectionner un type de chargement",
  selectAContainerCaseSize: "Sélectionner une taille de conteneur ou de caisse",
  typeAContainerCaseSize: "Saisissez une taille de conteneur ou de caisse",
  dContainer: "D-Conteneur",
  eContainer: "E-Conteneur",
  ldnContainer: "LDN Conteneur",
  liftvan: "Liftvan",
  liftvans: "Liftvans",
  eur1Iso1Pallet: "Palette EUR1/ISO1",
  eur2Iso2Pallet: "Palette EUR2/ISO2",
  itLooksLikeThereNoDataYet: "Il semble qu'il n'y ait pas encore de données",
  startByAddingAnOrderToShipment: "Commencez par ajouter une commande à l'expédition",
  thisValueShouldBeAPositiveNumber: "Cette valeur doit être un nombre positif",
  selectTheLoadTypeFirst: "Sélectionnez d'abord le type de chargement",
  hsCommodityCode: "Code SH / marchandise",
  searchForAnAgent: "Rechercher un agent",
  enterAValueGraterThanNetWeight: "Entrez une valeur supérieure au poids net",
  enterAValueLowerThanGrossWeight: "Entrez une valeur inférieure au poids brut",
  youShouldAddAtLeastOneContainerToTheShipment:
    "Vous devez ajouter au moins un conteneur à l'expédition",
  thisRepresentsTheInitialEstimatedTimeOfArrivalProvidedByTheCarrier:
    "Cela représente l'heure d'arrivée estimée initiale fournie par le transporteur",
  thisIsYourShipmentInformation: "Voici les informations de votre expédition",
  today: "Aujourd'hui",
  configure: "Configurer",
  last15Days: "15 derniers jours",
  lastMonth: "Mois dernier",
  monthToDate: "Mois en cours",
  lastYear: "Année dernière",
  customDate: "Date personnalisée",
  customPeriod: "Période personnalisée",
  configureOverview: "Configurer l'aperçu",
  adjustWidgetsAndViewAsYouWish: "Ajustez les widgets et la vue comme vous le souhaitez",
  purchaseOrdersWidgets: "Purchase Commandes Widgets",
  poStatuses: "Statuts BC",
  lastReceivedOrders: "Dernières commandes reçues",
  poConfirmedVSPoReceived: "PO Confirmé vs PO Reçu",
  productsOrigin: "Produits Origin",
  mostRequestedProducts: "Most Requested Produits",
  productsRunningOutOfStock: "Produits Running Rupture de stock",
  containersByArrivalDate: "Conteneurs par date d'arrivée",
  shipmentsPerTime: "Expéditions Per Heure",
  shipmentStatuses: "Expédition Statuses",
  resetToDefault: "Réinitialiser",
  ofTotal: "Du total",
  inboundAtPortAtDC: "En route, Au port et Au DC",
  containersStatuses: "Conteneurs Statuses",
  amountOfSSCC: "Montant of SSCC",
  apply: "Appliquer",
  searchForAConsultant: "Rechercher un consultant",
  enableQuoteEditing: "Activer la modification des devis",
  areYouSureYouWantToEnableEditingForThisQuote:
    "Êtes-vous sûr de vouloir activer la modification pour ce devis ?",
  trackYourShipmentByFillingInEitherOrBothFields:
    " Suivez votre expédition en saisissant le connaissement (BOL), l'identifiant de réservation, ou les deux.",
  pleaseFillInAtLeastOnField: "Veuillez remplir au moins un champ.",
  dimensionalWeight: "Poids Dimensionnel",
  airportOfOrigin: "Port de Déchargement (PoD)",
  airportOfDestination: "Aéroport de Destination",
  arrivalAOfDestination: "Date de Livraison",
  accounts: "Comptes",
  ofUsers: "d'utilisateurs",
  newAccount: "Nouveau compte",
  companyAddress: "Adresse de l'entreprise",
  accountLogo: "Compte logo",
  notEnoughData: "Données insuffisantes",
  thereIsInsufficientDataToGenerateGraphicsForTheSelectedPeriod:
    "Il n'y a pas suffisamment de données pour générer des graphiques pour la période sélectionnée.",
  atDC: "Au centre de distribution",
  incoterms: "Incoterms",
  uldContainers: "ULD Conteneurs",
  uldPallets: "ULD Palettes",
  thisActionWillAlsoRemoveAnyFilesYouHaveUploadedInIt:
    "Cette action supprimera également tous les fichiers que vous y avez téléversés.",
  actualInventory: "Inventaire réel",
  checkAllSteps: "Vérifier toutes les étapes",
  milestones: "Jalons",
  checkYourMoveFileOnline: "Vérifier votre dossier de déménagement en ligne",
  logedInAs: "Connecté en tant que",
  english: "Anglais",
  yourOrder: "Votre Commande",
  theTokenProvidedIsIncorrect: "Le token fourni est incorrect",
  nextStep: "Étape suivante",
  survey: "Visite",
  typeYourCommentsHere: "Saisissez vos commentaires ici",
  agentContactDetails: "Agent Contact Détails",
  distanceToNextPort: "Distance jusqu'au prochain port",
  kg: "Kg",
  eventsUnavailable: "Événements indisponibles",
  routeUnavailable: "Itinéraire indisponible",
  trackingInformationUnavailable: "Informations de suivi indisponibles pour le moment.",
  nauticalMiles: "Milles Nautiques",
  closeAllSSCCs: "Fermer tous les SSCCs",
  areYouSureYouWantToCloseAllSSCCs: "Êtes-vous sûr de vouloir fermer tous les SSCC",
  isItByDefaultAMilestone: "Est-ce, par défaut, un jalon ?",
  newTask: "Nouvelle tâche",
  addTask: "Ajouter une tâche",
  tasksAndMilestones: "Tâches et jalons",
  milestonesFunctionallity: "Fonctionnalité des jalons",
  aMilestoneIsAKeyDateThatShowsOnTheCustomerPortalMilestonesAreDisplayedAsAMoveFlowInAscendingOrderTasksAreSetByDefaultToBeConsideredAMilestoneOrNot:
    "Un jalon est une date clé affichée sur le portail client. Les jalons sont affichés comme un flux de déménagement dans l'ordre croissant. Les tâches sont définies par défaut pour être considérées comme un jalon ou non.",
  youCanEditTheseDefaultsInSystemSettings: "Vous pouvez modifier ces valeurs par défaut dans les paramètres du système.",
  youCanAlsoChooseToChangeThemAsNeededForThisFileOnly:
    "Vous pouvez également choisir de les modifier selon vos besoins pour ce fichier uniquement.",
  setAsMilestone: "Définir comme jalon",
  removeAsMilestone: "Retirer comme jalon",
  youCanChooseFromTheListBelowWhichItemsYouWantToUpload:
    "Vous pouvez choisir dans la liste ci-dessous quels éléments vous souhaitez téléverser",
  downloadCSVTemplate: "Télécharger le modèle CSV",
  theFilesWereUploadedAndUpdatedSuccesfully: "Les fichiers ont été téléversés et mis à jour avec succès",
  anErrorOccurredLoadingUploadCentreTryAgain: "Une erreur est survenue lors du chargement du centre de téléversement, réessayez",
  weHaveFoundSomeErros: "nous avons trouvé quelques erreurs",
  branchCode: "Code d'agence",
  warehouseCode: "Code d'entrepôt",
  branchCodeNotFound: "Code d'agence introuvable",
  warehouseCodeNotFound: "Code d'entrepôt introuvable",
  thisBranchIsNotRelatedToInformedWarehouse: "Cette agence n'est pas liée à l'entrepôt indiqué",
  serviceCodeAlreadyExistsPleaseAssignANewCode:
    "Le code de service existe déjà. Veuillez attribuer un nouveau code.",
  materialCodeAlreadyExistsPleaseAssignANewCode:
    "Le code de matériau existe déjà. Veuillez attribuer un nouveau code.",
  codeAlreadyExistsPleaseAssignANewCode: "Le code existe déjà. Veuillez attribuer un nouveau code.",
  codeIsDuplicated: "Le code est dupliqué",
  codeNotFound: "Code non trouvé",
  anErrorOccurredOnTryAgain: "Une erreur est survenue, veuillez réessayer",
  looseItems: "Articles en Vrac",
  thisFieldMustHaveAtLeastOneItem: "Ce champ doit contenir au moins un article",
  theOrderAlreadyIsInATransshipment: "La commande est déjà dans un transbordement",
  publishTask: "Publier la tâche",
  unpublishTask: "Dépublier la tâche",
  noCommentsAdded: "Aucun commentaire ajouté",
  actualAtDepartureDock: "Arrivée au point de livraison",
  actualArrivalOfDestination: "Date de Livraison",
  noRecord: "Aucun enregistrement",
  hwab: "HWAB",
  selectAPeriod: "Sélectionner une période",
  storageBoxSingleUseSelected: "Boîte de stockage usage unique sélectionnée",
  youCanAddOnlyOneOrderToAStorageBoxSingleUse:
    "Vous ne pouvez ajouter qu'une seule commande à une boîte de stockage à usage unique",
  createsANomenclatureBasedOnTheTransshipmentNumberAndTheQuantityOfLiftvans:
    "Crée une nomenclature basée sur le numéro de transbordement et la quantité de liftvans.",
  result: "Résultat",
  results: "Résultats",
  youCanOnlyUseOneStorageBoxSingleUsePerOrder:
    "Vous ne pouvez utiliser qu'une seule boîte de stockage à usage unique par commande",
  youCanOnlyUseStorageBoxSingleUseForJustOneOrder:
    "Vous ne pouvez utiliser une boîte de stockage à usage unique que pour une seule commande.",
  completed: "Terminé",
  initialRequest: "Demande initiale",
  noStepsInformed: "Non steps informed",
  noTrackingAvailable: "Aucun suivi disponible",
  dateNotInformed: "Date non informée",
  invoiceTotal: "Total de la Facture",
  receivedDate: "Date de Réception",
  error: "Erreur",
  waitingUpdate: "En attente de mise à jour",
  shipeeziDefault: "Par défaut de Shipeezi",
  theFileToUploadMustBeInCSVFormat: "Le fichier à téléverser doit être au format .csv",
  pleaseFillInTheRequiredFieldsBeforeSaving: "Veuillez remplir les champs obligatoires avant d'enregistrer.",
  changeAssignee: "Changer l'assigné",
  selectAPerson: "Sélectionner une personne",
  theAssignedPersonHasBeenChangedSuccessfully: "La personne assignée a été modifiée avec succès",
  shipmentsPerDate: "Expéditions Per Date",
  for: "pour",
  chapter: "Chapitre",
  heading: "Rubrique",
  subHeading: "Sous-rubrique",
  statisticalClassification: "Classification statistique",
  applicableTo: "Applicable à",
  inactivatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeInactivatedAsWell:
    "En désactivant une section, un chapitre ou un titre, tous les codes HS / marchandises qui y sont liés seront également désactivés.",
  doYouWantToInactivateAllOfThemAsWell: "Voulez-vous aussi tous les désactiver ?",
  activatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeActivatedAsWell:
    "En activant une section, un chapitre ou un titre, tous les codes HS / marchandises qui y sont liés seront également activés.",
  doYouWantToActivateAllOfThemAsWell: "Voulez-vous aussi tous les activer ?",
  inactivateCode: "Désactiver le code",
  activateCode: "Activer le code",
  typeInTheFirst6Digits: "Saisissez les 6 premiers chiffres",
  typeInTheLast2To4Digits: "Saisissez les 2 à 4 derniers chiffres",
  typeInTheCommodityCodeDescription: "Saisissez la description du code marchandise",
  typeInCountryOrRegion: "Saisissez un pays ou une région",
  commodityCode: "Code marchandise",
  doYouReallyWantToDeleteThisCommodityCode: "Voulez-vous vraiment supprimer ce code marchandise",
  deleteCommodityCode: "Supprimer le Code Marchandise",
  clone: "Cloner",
  adjustTheDataAsDesiredToCreateTheNewCode: "Ajustez les données comme souhaité pour créer le nouveau code.",
  insertAValidCode: "*Insérez un code valide",
  youMustFillInTheFieldsInRed: "Vous devez remplir les champs en rouge",
  importCSV: "Importer CSV",
  importCSVFile: "Importer un fichier CSV",
  weHaveFoundSomeErrors: "nous avons trouvé quelques erreurs",
  regions: "Régions",
  defineWheterTheStorageBoxTypeCanApperInAllWarehouses:
    "Définir si le type de boîte de stockage peut apparaître dans tous les entrepôts",
  defineIfTheStorageBoxTypeCanBeUsedInTransitInsideTheWarehouseOrBoth:
    "Définir si le type de boîte de stockage peut être utilisé en transit, à l'intérieur de l'entrepôt ou les deux",
  pleaseSelectAtLeastOne: "Veuillez sélectionner au moins un",
  originAirport: "Aéroport d'Origine",
  finalDestinationAirport: "Aéroport de Destination Final",
  plannedETD: "ETD Planifié",
  departureFrom: "Départ de",
  departedFrom: "Parti de",
  theAirplanePositionIsUpdatedFrom15To15Minutes:
    "La position de l'avion est mise à jour toutes les 15 minutes.",
  inviteCustomer: "Inviter un client",
  inviteCustomers: "Inviter des clients",
  supplyChain: "Chaîne d'Approvisionnement",
  allSelectedCustomersMustHaveNameEmailAndNotYetBelongToShipeezi:
    "Tous les clients sélectionnés doivent avoir un nom, un e-mail et ne pas encore appartenir à Shipeezi",
  theBranch: "L'agence",
  warehouseNotFound: "Entrepôt introuvable",
  isNotRelatedToInformedWarehouse: "n'est pas lié à l'entrepôt indiqué",
  writeACommentInSKU: "Écrire un commentaire dans SKU",
  loadMore: "Charger plus",
  commentHistory: "Historique des commentaires",
  readMore: "Lire plus",
  return: "Retour",
  toAdd: "à ajouter",
  shiftReturn: "Maj + Entrée",
  toBreakLine: "pour retour à la ligne",
  now: "Maintenant",
  inMoment: "Dans un instant",
  justNow: "À l'instant",
  in: "dans",
  years: "ans",
  yearAgo: "il y a un an",
  yearsAgo: "il y a des années",
  months: "mois",
  monthAgo: "il y a un mois",
  monthsAgo: "il y a des mois",
  weeks: "semaines",
  weekAgo: "il y a une semaine",
  weeksAgo: "il y a des semaines",
  tomorrow: "Demain",
  yesterday: "Hier",
  daysAgo: "il y a des jours",
  hour: "heure",
  hours: "heures",
  hourAgo: "il y a une heure",
  hoursAgo: "il y a des heures",
  minute: "minute",
  minutes: "minutes",
  minuteAgo: "il y a une minute",
  minutesAgo: "il y a des minutes",
  pleaseTypeLessThanCharacters: "Veuillez saisir moins de {{maxLength}} caractères",
  emailConfiguration: "Configuration E-mail",
  selectAll: "Tout Sélectionner",
  "common.clearAll": "Tout Effacer",
  youCantRemoveColumsTheMinimumIs: "Vous ne pouvez pas supprimer de colonnes. Le minimum est",
  allTime: "Tout le temps",
  lastWeek: "Semaine dernière",
  allTypes: "Tous les types",
  editions: "Éditions",
  loads: "Chargements",
  unloads: "Déchargements",
  member: "Membre",
  spouse: "Conjoint",
  whoDoesThisItemBelongTo: "À qui appartient cet article?",
  searchOrAddAnItem: "Rechercher ou ajouter un article",
  writeYourMessageHere: "Écrivez votre message ici",
  message: "Message",
  youAreNotifying: "Vous informez",
  perDestination: "Par destination",
  asQuoted: "Selon le devis",
  noItemsHaveBeenRegisteredYet: "Aucun article n'a encore été enregistré",
  onceItemsAreAddedToInventoryYouWillBeAbleToSeeTheirDetails:
    "Une fois les articles ajoutés à l'inventaire, vous pourrez voir leurs détails",
  goodMorning: "Bonjour",
  goodAfternoon: "Bon après-midi",
  goodNight: "Bonne nuit",
  youDontHaveAnyMovesWithUsYet: "Vous n'avez pas encore de déplacements avec nous.",
  youHaveNotYetRequestedAQuoteFromUs: "Vous n'avez pas encore demandé de devis chez nous.",
  itSeemsLikeEverythingIsFineAroudHere: "Il semble que tout va bien ici",
  weAreHereToHelpYourMoveToBeAsSmoothlyAsPossible:
    "Nous sommes là pour que votre déménagement se passe le plus facilement possible",
  weAreHereToHelpYourQuoteToBeAsSmoothlyAsPossible:
    "Nous sommes là pour que votre devis se déroule le plus facilement possible",
  yourMoves: "Vos déplacements",
  yourQuotes: "Vos devis",
  scheduled: "Planifié",
  needsYourAttention: "Nécessite votre attention",
  yourScheduleIsSqueakyCleanNoUpcomingAppointmentsToWorryAbout:
    "Votre planning est vide ! Aucun rendez-vous à venir.",
  ifWeNeedYouForAnythingHereItIsThePlaceToTakeAction:
    "Si nous avons besoin de vous, c'est ici que vous pouvez agir.",
  actualMilestone: "Réel milestone",
  trackingAvailable: "Suivi available",
  howAboutHavingACoffe: "Et si vous preniez un café ?",
  everythingIsUpToDate: "Tout est à jour",
  youWillSeeAllTheCommunicationBetweenYourselfAndUsHere:
    "Vous verrez ici toute la communication entre vous et nous.",
  transshipped: "Transbordé",
  weDidNotFindAnyMovesRelatedTo: "Nous n'avons trouvé aucun déplacement lié à",
  noResultsFound: "Aucun résultat trouvé",
  nothingScheduledForNow: "Rien de planifié pour le moment",
  timeline: "Chronologie",
  home: "Accueil",
  checkAllMilestones: "Vérifier tous les jalons",
  yourMoveProgress: "Progression de votre déménagement",
  showMore: "Afficher plus",
  transport: "Transport",
  originContacts: "Contacts d'origine",
  destinationContacts: "Contacts de destination",
  checkMyInventories: "Vérifier mes inventaires",
  messageSentThankYouForContactingUsWellGetBackToYouSoon:
    "Message envoyé ! Merci de nous avoir contactés. Nous vous répondrons bientôt.",
  contactHistory: "Historique des contacts",
  youContacted: "Vous avez contacté",
  yourMoveDocumentStatus: "Statut du document de déplacement",
  pleaseFillInEitherTheMobileNumberOrPhoneNumberField:
    "Veuillez remplir le champ du numéro de mobile ou du numéro de téléphone",
  pleaseFillAtLeastOne: "Veuillez remplir au moins un",
  allItemsPacked: "Tous les articles emballés",
  allYourItemsHaveBeenPackedAndEverythingIsFine:
    "Tous vos articles ont été emballés et tout est en ordre.",
  couldNotFoundWithUsernamePassword:
    "Nous n'avons pas trouvé de compte avec ces identifiants. Pour des raisons de sécurité, après <strong>{{numberOfAttempts}} tentatives échouées</strong> de connexion, vous devez attendre <strong>{{lockoutDuration}}</strong> avant de réessayer. <HiddenText> Avez-vous besoin de <Link>réinitialiser votre mot de passe</Link> ? </HiddenText>",
  members: "Membres",
  teams: "Équipes",
  newTeam: "Nouvelle équipe",
  equipments: "Équipements",
  leaderUser: "Responsable (utilisateur)",
  inviteMember: "Inviter un membre",
  newMember: "Nouveau membre",
  chooseTheTypeOfMember: "Choisir le type de membre",
  theMemberCanHaveAccessToSystemOrNot: "Le membre peut avoir accès au système ou non",
  personalDetails: "Détails Personnels",
  generalInformationAboutTheMember: "Informations générales sur le membre",
  howThePersonAccessesAndInteractsWithTheSystem:
    "Comment la personne accède et interagit avec le système",
  additional: "Supplémentaire",
  hasAccessToShipeeziSystemWithALoginAndPassword:
    "A accès au système Shipeezi, avec un identifiant et un mot de passe",
  thisMemberBelongsToASubcontractor: "Ce membre appartient à un sous-traitant",
  subcontractor: "Sous-traitant",
  nickname: "Surnom",
  startEmploymentDate: "Date de début d'emploi",
  endEmploymentDate: "Date de fin d'emploi",
  citizenship: "Citoyenneté",
  license: "Licence",
  jobTitle: "Intitulé du poste",
  editPhoto: "Modifier la photo",
  specificDetailsAboutTheStaffPerson: "Détails spécifiques sur le membre du personnel",
  staffInformation: "Informations du personnel",
  typerOfUser: "Type d'utilisateur",
  notApproved: "Non approuvé",
  review: "Réviser",
  expiry: "Expiration",
  certification: "Certification",
  certifications: "Certifications",
  newCertification: "Nouvelle certification",
  uploadANewFile: "Téléverser un nouveau fichier",
  confirmThisCertificationIsValidated: "Confirmer que cette certification est validée",
  expire: "Expirer",
  preferNotToSay: "Préfère ne pas dire",
  nonBinary: "Non-binaire",
  searchForCitizenship: "Rechercher une nationalité",
  serchForCountry: "Rechercher un pays",
  thisUserIsAlsoALeader: "Cet utilisateur est aussi un responsable",
  pleaseCompleteAllRequiredFields: "Veuillez compléter tous les champs obligatoires",
  createMember: "Créer un membre",
  associatedWithThisMemberWhenYouAddThem: "associés à ce membre lorsque vous les ajoutez",
  associatedWithThisEquipmentWhenTheyAreAdded: "associés à cet équipement lorsqu'ils sont ajoutés",
  newAbsence: "Nouvelle absence",
  absences: "Absence",
  absence: "Absence",
  allDayAbsence: "Absence toute la journée",
  availability: "Disponibilité",
  convertStaffIntoUser: "Convertir le personnel en utilisateur",
  convertUserIntoStaff: "Convertir l'utilisateur en personnel",
  configureAsSubcontractor: "Configurer comme sous-traitant",
  doYouWantToConvertThisUserIntoStaff: "Voulez-vous convertir cet utilisateur en personnel ?",
  doYouWantToConvertThisStaffIntoUser: "Voulez-vous convertir ce personnel en utilisateur ?",
  youWillNeedToFillInTheMissigInformation: "Vous devrez remplir les informations manquantes",
  thisMemberIsA: "Ce membre est un",
  andIsDefinedAsA: "et est défini comme",
  subconttractorFor: "sous-traitant pour",
  own: "Propre",
  convertInto: "Convertir en",
  subcontractorFor: "sous-traitant pour",
  timesheet: "Feuille de temps",
  timesheets: "Feuilles de temps",
  typeOfMember: "Type de membre",
  ifTheTeamAlreadyHasALeaderTheMemberWillBeAddedAsStaff:
    "Si l'équipe a déjà un responsable, le membre sera ajouté en tant que personnel",
  emergencyEmail: "E-mail d'urgence",
  newTime: "Nouvel horaire",
  editTeam: "Modifier l'équipe",
  addMember: "Ajouter un membre",
  addTeam: "Ajouter une équipe",
  nameL: "Nom",
  equipmentPhoto: "Équipement photo",
  maxSize2mb: "Taille max 2 Mo",
  formatsJpgGifPng: "Formats : JPG, GIF, PNG",
  equipmentIcon: "Icône de l'équipement",
  rental: "Location",
  leased: "Loué",
  noMembersAssociatedToThisEquipment: "Aucun membre associé à cet équipement",
  youCanStartByAddingAMember: "Vous pouvez commencer par ajouter un membre",
  newUnavailabilityTime: "Nouvelle période d'indisponibilité",
  allDayUnavailable: "Indisponible toute la journée",
  rolesecurity: "Rôle (sécurité)",
  loaction: "Emplacement",
  addMembers: "Ajouter des membres",
  youwillbeabletoseealltheinformationabouttheavailabilityofthismemberwhenyouaddthem:
    " Vous pourrez voir toutes les informations sur la disponibilité de ce membre lorsque vous l'ajouterez",
  addUnavailability: "  Ajouter une indisponibilité",
  addTeams: "Ajouter Équipes",
  enableThisFleetAsAStrorageBox: "Activer cette flotte comme boîte de stockage",
  dates: "Dates",
  selectAnOptionToSeeTheForm: "Sélectionnez une option pour voir le formulaire",
  typeInToSearchAMebmer: "Saisissez pour rechercher un membre",
  pantech: "Pantech",
  nickName: "Surnom",
  EuroNorm: "EUROnorm",
  driverLicense: "Permis de conduire",
  manufacturer: "Fabricant",
  branch1: "Agence 1",
  warehouse1: "Entrepôt 1",
  enableThisFleetAsAStorageBox: "Activer cette flotte comme boîte de stockage",
  writeADescription: "Écrire une description",
  chooseAvehicleTypeOfEquipmentLikeAForkliftOrATruck:
    "Choisissez un type de véhicule d'équipement, comme un chariot élévateur ou un camion",
  chooseAVehicleTypeOfEquipmentLikeAForkliftOrATruck:
    "Choisissez un type de véhicule d'équipement, comme un chariot élévateur ou un camion",
  createMoreGeneralizedEquipmentWithAFewDetails:
    "Créez un équipement plus général, avec quelques détails",
  whoOwnsThisEquipment: "À qui appartient cet équipement ?",
  businessphone: "Téléphone professionnel",
  vatcode: "Code TVA",
  iban: "IBAN",
  bic: "BIC",
  usesameasgeneraladdress: "Utiliser la même adresse générale",
  addaequipment: "Ajouter a equipment",
  quickcreationequipment: "Création rapide d'équipement",
  addequipment: "Ajouter de l'équipement",
  addAMember: "Ajouter un membre",
  addATeam: "Ajouter a team",
  createnew: "Créer Nouveau",
  businessdetails: "Détails professionnels",
  businessinformationaboutthesubcontractor: "Informations commerciales sur le sous-traitant",
  generalinformationabouttheowner: "Informations générales sur le propriétaire",
  bankingdetails: "Détails bancaires",
  nomembersassociatedtothisequipment: "Aucun membre associé à cet équipement",
  youcanstartbyaddingamember: "Vous pouvez commencer par ajouter un membre",
  createnewmember: "Créer un nouveau membre",
  addanexistentmember: "Ajouter un membre existant",
  quickcreation: "Création rapide",
  equipment: "Équipement",
  quicklycreateanewequipmentwithessentialdetailsaddmoreinformationanytimeinsettings:
    "Créez rapidement un nouvel équipement avec les détails essentiels. Ajoutez plus d'informations à tout moment dans les paramètres.",
  createmoregeneralizedequipmentwithafewdetails:
    "Créez un équipement plus général, avec quelques détails",
  personaldetails: "Détails Personnels",
  platenumber: "Numéro de Plaque",
  subcontractors: "Sous-traitants",
  newSubcontractor: "Nouveau sous-traitant",
  qtyMembers: "Qté de membres",
  qtyEquipments: "Qté d'équipements",
  businessDetails: "Détails professionnels",
  businessInformationAboutTheSubcontractor: "Informations commerciales sur le sous-traitant",
  businessPhone: "Téléphone professionnel",
  generalInformationAboutTheOwner: "Informations générales sur le propriétaire",
  addNumberHere: "Ajouter le numéro ici",
  bankingDetails: "Détails bancaires",
  vatCode: "Code TVA",
  useSameAsGeneralAddress: "Utiliser la même adresse générale",
  contactEmail: "E-mail de contact",
  noMembersAssociatedToThisSubcontractor: "Aucun membre associé à ce sous-traitant",
  createNewMember: "Créer un nouveau membre",
  addAnExistentMember: "Ajouter un membre existant",
  noMembersToShow: "Aucun membre à afficher",
  noTeamsToShow: "Aucune équipe à afficher",
  typeInToSearchAMember: "Saisissez pour rechercher un membre",
  addWorkTimeToMember: "Ajouter du temps de travail au membre",
  howDoYouWantToAddAnewTime: "Comment voulez-vous ajouter un nouvel horaire",
  createMockTask: "Créer une tâche factice",
  createAMimicTaskToRecordHoursForThisMember:
    "Créez une tâche fictive pour enregistrer les heures de ce membre.",
  selectExistentTask: "Sélectionner une tâche existante",
  selectAnExistingTaskInTHeOrderToLogWorkTime:
    "Sélectionnez une tâche existante dans la commande pour enregistrer le temps de travail",
  addTime: "Ajouter du temps",
  backFromBreak: "De retour de pause",
  itLooksLikeNoOrderWasSelectYet: "Il semble qu'aucune commande n'ait encore été sélectionnée",
  startSearchingForAnOrderToBeAbleToCreateANewTask:
    "Commencez à rechercher une commande pour pouvoir créer une nouvelle tâche",
  searchOrderBy: "Rechercher une commande par",
  cancelAvailability: "Annuler la disponibilité",
  doYouReallyWantToCancelThisAbsence: "Voulez-vous vraiment annuler cette absence pour",
  yesCancel: "Oui, annuler",
  thisActionCannotBeUndone: "Cette action ne peut pas être annulée",
  viewTime: "Voir le Temps",
  editTime: "Modifier le temps",
  noLeaderAvailable: "Aucun responsable disponible",
  noStaffAvailable: "Aucun personnel disponible",
  noTasks: "Aucune tâche",
  m3: "m³",
  unavailableUntil: "Indisponible until",
  lv: "LV",
  noEquipmentToShow: "Aucun équipement à afficher",
  addEquipment: "Ajouter de l'équipement",
  addAnExistentEquipment: "Ajouter un équipement existant",
  addEquipments: "Ajouter de l'équipement",
  addAEquipment: "Ajouter a equipment",
  newEquipment: "Nouvel équipement",
  chooseTheTypeOfEquipment: "Choisir le type d'équipement",
  purchaseDate: "Date d'achat",
  soldDate: "Date de vente",
  euronorm: "EUROnorm",
  lastInspectionDate: "Date de dernière inspection",
  nextInspectionDate: "Date de prochaine inspection",
  pleaseSelectAnLaterDate: "Veuillez sélectionner une date ultérieure",
  pleaseSelectAnEarlierDate: "Veuillez sélectionner une date antérieure",
  workedTime: "Temps travaillé",
  breaks: "Pauses",
  waitingApproval: "En attente d'approbation",
  noSubcontractorAvailable: "Aucun sous-traitant disponible",
  noLeaderAdded: "Aucun responsable ajouté",
  noStaffAdded: "Aucun personnel ajouté",
  noEquipmentAdded: "Aucun équipement ajouté",
  noStorageBoxAdded: "Aucune boîte de stockage ajoutée",
  noOrders: "Aucune commande ajoutée",
  openOrder: "Commande ouverte",
  accessDetails: "Détails d'accès",
  membersAndTeams: "Membres et équipes",
  membersAndEquipments: "Membres & equipments",
  extraMembersAndTeams: "Extra Membres & Équipes",
  addTeamToBoard: "Ajouter une équipe au tableau",
  timeMustBeAfter: "L'heure doit être après",
  addALeader: "Ajouter un responsable",
  addStaffs: "Ajouter staffs",
  addStorageBoxes: "Ajouter des boîtes de stockage",
  timeClock: "Pointeuse",
  removeTaskFromTeam: "Supprimer la tâche de l'équipe",
  youCannotPublishATaskWithoutALeader: "Vous ne pouvez pas publier une tâche sans responsable",
  thisChangeWillBeProcessedShortly: "Ce changement sera traité prochainement",
  noLanguageAvailable: "Aucune langue disponible",
  noJobTitleAvailable: "Aucun titre de poste disponible",
  equipmentDetails: "Détails de l'équipement",
  removeThisTeamFromTheBoard: "Retirer cette équipe du tableau",
  areYouSureyouWantToCancelTheTask: "Êtes-vous sûr de vouloir annuler la tâche",
  forOrder: "Pour la commande",
  createCrew: "Créer une équipe",
  noTeamsAddedYet: "Aucune équipe ajoutée",
  allCaughtUpWhatAboutACoffee: "Tout est à jour ! Et si vous preniez un café ?",
  weAreDoingOneLastSearchWhatAboutACoffee: "Nous effectuons une dernière recherche... Et si vous preniez un café ?",
  viewOptions: "Options d'affichage",
  showItemsUnavailable: "Afficher les articles indisponibles",
  showEmptyOrdersTasks: "Afficher les tâches des commandes vides",
  showEmptyTeams: "Afficher empty teams",
  collapseOrdersTasks: "Réduire les tâches des commandes",
  collapseTeams: "Réduire les équipes",
  expandOrdersTasks: "Développer les tâches des commandes",
  expandTeams: "Développer les équipes",
  organization: "Organisation",
  organiseByTask: "Organiser par tâche",
  organiseByOrder: "Organiser par commande",
  organiseByTeam: "Organiser par équipe",
  youCannotPublishThisTask: "Vous ne pouvez pas publier cette tâche",
  typeHereAndPressEnter: "Saisissez ici et appuyez sur Entrée",
  noMemberFound: "Aucun membre trouvé",
  noTeamFound: "Aucune équipe trouvée",
  noOrderFound: "Aucune commande trouvée",
  noInformationToShow: "Aucune information à afficher",
  noEquipmentFound: "Aucun équipement trouvé",
  noStorageBoxFound: "Aucune boîte de stockage trouvée",
  pressToSearch: "Appuyer pour rechercher",
  noOrderAvailable: "Aucune commande disponible",
  youHaveToUnpublishFirst: "Vous devez d'abord retirer la publication",
  thisTaskAlreadyStartedByTheLeader: "Cette tâche a déjà été démarrée par le responsable",
  thisTaskAlreadyFinished: "Cette tâche est déjà terminée",
  thisTaskAlreadyCancelled: "Cette tâche a déjà été annulée",
  youHaveToAddATaskBeforeCreateASingleUse: "Vous devez ajouter une tâche avant de créer un usage unique",
  youCannotAddASingleUseForDifferentOrders: "Vous ne pouvez pas ajouter un usage unique pour des commandes différentes",
  createAStorageBoxSingleUse: "Créer une boîte de stockage à usage unique",
  thisTaskCannotBeCancelled: "Cette tâche ne peut pas être annulée",
  thereIsNoNeed: "Ce n'est pas nécessaire",
  vipMode: "Mode VIP",
  bluebarkMove: "Déménagement Bluebark",
  satefyMove: "Déplacement sécurisé",
  dispatch: "Expédition",
  youHaveUnpublishedTasks: "Vous avez des tâches non publiées!",
  thisTeamHasTasksAlreadyPublishedForThisLeader:
    "Cette équipe a déjà des tâches publiées pour ce responsable",
  anOperationalMemberUsedJustForRegisterPurposes:
    "Un membre opérationnel, utilisé uniquement à des fins d'enregistrement",
  boardDisplay: "Affichage du tableau",
  createATemporaryTeamoForTodaysTasks: "Créer une équipe temporaire pour les tâches du jour",
  registredAddress: "Adresse enregistrée",
  noResultMatchYourSearch: "Aucun résultat ne correspond à votre recherche",
  searchAndSelectOrder: "Rechercher et sélectionner une commande",
  itLooksLikeNoOrderWasSelectedYet: " Il semble qu'aucune commande n'ait encore été sélectionnée",
  startSearchingForAnOrderYoBeAbleToCreateANewTask:
    "Commencez à rechercher une commande pour pouvoir créer une nouvelle tâche",
  newTaskFor: "Nouvelle tâche pour",
  timeFor: "Heure for",
  notifyTheClientAboutTheStartOfTheTask30MinutesInAdvance:
    "Notifier le client du début de la tâche 30 minutes à l'avance",
  breakFromBreak: "De retour de pause",
  albertFloresMarvinMcKinneyJeromeBell: " Albert Flores, Marvin McKinney, Jerome Bell",
  extraMembers: "Extra Membres & Équipes",
  devonLane: "Devon Lane",
  readLess: "Lire moins",
  writeACommentIn: "Écrire un commentaire dans",
  shift: "Quart",
  teamRemovalIsBlockedDueToThePresenceOfTasks:
    "La suppression de l'équipe est bloquée en raison de la présence de tâches.",
  vipTreatment: "Traitement VIP",
  personalAddress: "Adresse personnelle",
  pleaseSelectAStartDate: "Veuillez sélectionner une date de début",
  morning: "Matin",
  afternoon: "Après-midi",
  evening: "Soir",
  night: "Nuit",
  registeredAddress: "Adresse enregistrée",
  noTaskYest: "Pas encore de tâche",
  writeAComment: "Écrire un commentaire",
  allowBookingSearch: "Autoriser la recherche de réservation",
  securityLoginAttempts:
    "Pour des raisons de sécurité, après <strong>{{numberOfAttempts}} tentatives échouées</strong> de connexion, vous devez attendre <strong>{{lockoutDuration}}</strong> avant de réessayer.",
  weakPassword: "Mot de passe faible",
  avaragePassword: "Mot de passe moyen",
  goodPassword: "Bon mot de passe",
  strongPassword: "Mot de passe fort",
  passwordMustHave: "Votre mot de passe doit contenir :",
  UpperAndLowercaseLetters: "Lettres majuscules et minuscules",
  aSpecialCharacter: "Un caractère spécial (#$&@)",
  atLeastOneNumber: "Au moins un chiffre",
  minLength: "12 caractères ou plus",
  pleaseEnterANewPassword: "Veuillez entrer un nouveau mot de passe",
  pleaseConfirmPassword: "Veuillez confirmer le mot de passe",
  autoTerminateSessionExpire:
    "Pour des raisons de sécurité, votre connexion expire après 8 heures d'activité. Veuillez enregistrer votre travail et vous déconnecter. Si vous préférez rester connecté, dans <strong>15 minutes</strong> nous vous demanderons de ressaisir vos identifiants.",
  yourSessionIsAboutToExpire: "Votre session est sur le point d'expirer",
  terminatedSession: "Cette session a été terminée.",
  reEnterCreds: "Veuillez <strong> ressaisir </strong> vos identifiants.",
  weWillSendALinkToResetYourPasswordToTheEmailAddressAssociatedWithYourAccount:
    "Nous enverrons un lien pour réinitialiser votre mot de passe à l'adresse e-mail associée à votre compte.",
  sortReportBy: "Trier le rapport par",
  sortedByInventory: "Trié par inventaire",
  sortedAndGroupedByStorageBox: "Trié et groupé par boîte de stockage",
  loadOrder: "Charger la commande",
  areYouSureYouWantToLoadThisOrder: "Êtes-vous sûr de vouloir charger cette commande ?",
  changeOrderStatusModalDescription: "Le nouveau statut de la commande sera '{{status}}'.",
  noKeepItAsItIs: "Non, garder tel quel",
  noKeepItAsStatus: "Non, garder comme {{status}}",
  yesLoad: "Oui, load",
  yesDeliver: "Oui, deliver",
  noPhotosHaveBeenAddedYet: "Aucune photo n'a encore été ajoutée",
  transportationType: "Type de transport",
  assistance: "Assistance",
  doorToDoor: "Porte à Porte",
  doorToPort: "Porte au Port",
  doorToWarehouse: "Porte à l'Entrepôt",
  fotWarehouse: "FOT Entrepôt",
  portToDoor: "Port à Porte",
  portToPort: "Port à Port",
  portToWarehouse: "Port à l'Entrepôt",
  warehouseToDoor: "Entrepôt à Porte",
  warehouseToPort: "Entrepôt au Port",
  warehouseToWarehouse: "Entrepôt à Entrepôt",
  accountType: "Type de compte",
  accountContact: "Contact du compte",
  bookingAgent: "Réservation agent",
  personalPropertyProgram: "Programme de biens personnels",
  searchForAnOption: "Rechercher une option",
  memberWillChangeFromSubcontractorToOwnAfterSaving:
    'Member will change from "subcontractor" to "own" after saving',
  memberWillChangeFromOwnToSubcontractorAfterSaving:
    'Member will change from "own" to "subcontractor" after saving',
  memberWillChangeFromUserToStaffAfterSaving:
    'Member will change from "user" to "staff" after saving',
  memberWillChangeFromStaffToUserAfterSaving:
    'Member will change from "staff" to "user" after saving',
  noTaskYet: "Aucune tâche encore",
  workHours: "Heures de travail",
  breakHours: "Heures de pause",
  mostCommonTask: "Tâche la plus courante",
  theCompanyDoesNotHaveARegisteredAddress: "L'entreprise n'a pas d'adresse enregistrée",
  noPhotoAdded: "Aucune photo ajoutée",
  exampleAyrton: "Exemple : Ayrton",
  exampleSenna: "Exemple : Senna",
  mailmailcom: "mail@mail.com",
  newUnavailability: "Nouvelle Indisponibilité",
  editTask: "Modifier la tâche",
  notAllocated: "Non attribué",
  vipTasksWithAssign: "Tâches VIP avec attribution",
  tasksWithNoAssign: "Tâches sans attribution",
  normalTasksWithAssign: "Tâches normales avec attribution",
  noCrewAssigned: "Aucune équipe attribuée",
  certificationType: "Type de Certification",
  defineWheterTheStorageBoxTypeRequiresPhotosSealNumberOrBoth:
    "Définir si le type de boîte de stockage nécessite des photos, un numéro de scellé ou les deux",
  checklist: "Liste de contrôle",
  sealsNumber: "Numéro de scellés",
  ifNoRuleIsAddedToAnOrderTypeTheRequiredSealNumberWillBeEqualTo1:
    "Si aucune règle n'est ajoutée à un type de commande, le numéro de scellé requis sera égal à 1",
  checklistRules: "Règles de liste de contrôle",
  itLooksLikeThereIsNoRulesAdded: "Il semble qu'aucune règle n'ait été ajoutée",
  youCanStartByAddingANewRuleByClickingTheButtonBellow:
    "Vous pouvez commencer par ajouter une nouvelle règle en cliquant sur le bouton ci-dessous",
  addARule: "Ajouter une règle",
  sealNumbersNeeded: "Numéros de sceau nécessaires",
  numberOfSealsRequired: "Nombre de sceaux requis",
  whenOrderTypeIs: "Quand le type de commande est",
  addAnotherRule: "Ajouter une autre règle",
  sealsValueMustBeGreaterThan0: "La valeur des scellés doit être supérieure à 0",
  pleaseFillInTheCustomerInformationFirst: "Veuillez d'abord remplir les informations du client.",
  isAllocated: "Est attribué",
  clearSelection: "Effacer la sélection",
  typeIn: "Taper",
  newPlaceholderTask: "Nouvelle tâche fictive",
  taskName: "Nom de la tâche",
  typeHereAComment: "Saisissez un commentaire ici",
  deleteTask: "Supprimer la tâche",
  yesDelete: "Oui, supprimer",
  areYouSureyouWantToDeleteTheTask: "Êtes-vous sûr de vouloir supprimer la tâche",
  placeholder: "Espace réservé",
  taskDescription: "Description de la tâche",
  describeTaskHere: "Décrire la tâche ici",
  sealNumbers: "Numéros de sceau",
  sealNumber: "Numéro de sceau",
  photosOfSpecialItemsInside: "Photos des articles spéciaux à l'intérieur",
  photosOfCaulked: "Photos du calfeutrage",
  photosOfPackedAndSealed: "Photos emballé et scellé",
  itLooksLikeThereIsNoPhotosYet: "Il semble qu'il n'y ait pas encore de photos",
  youCanStartByAddingANewPhotoOnTheButtonBelow:
    "Vous pouvez commencer par ajouter une nouvelle photo en cliquant sur le bouton ci-dessous",
  addAnotherPhoto: "Ajouter une autre photo",
  checklistDone: "Liste complétée",
  noTaskAdded: "Aucune tâche ajoutée",
  createAnInternalTaskOrARegisterForADraftTask:
    "Créer une tâche interne ou un enregistrement pour une tâche « brouillon »",
  selectAReport: "Sélectionner un rapport",
  crew_schedule_report: "Crew Planning Rapport",
  warehouse_schedule_report: "Entrepôt Planning Rapport",
  atLeastOneBranchMustBeSelected: "Au moins une agence doit être sélectionnée",
  reportTypeIsRequired: "Le type de rapport est requis",
  noReportGenerated: "Aucun rapport généré",
  reportGeneratedSuccessfully: "Rapport généré avec succès",
  reportsGeneratedSuccessfully: "reports generated avec succès",
  youMustSelectAtLeast1BranchToPrint: "Vous devez sélectionner au moins 1 agence pour imprimer",
  leaderName: "Nom du Responsable",
  memberName: "Nom du Membre",
  equipmentName: "Nom de l'Équipement",
  multiDay: "Multi-jours",
  theTaskIsFinishedSoItCannotBeRemoved: "La tâche est terminée, elle ne peut pas être supprimée.",
  showSupplierNameOnTheSSCCLabel: "Afficher le nom du fournisseur sur l'étiquette SSCC",
  dateFor: "Date pour",
  isThisAMultiDayTask: "Est-ce une tâche sur plusieurs jours ?",
  endDateCantBeBeforeStartDate: "La date de fin ne peut pas être antérieure à la date de début",
  quickSearch: "Recherche Rapide",
  newSubscriber: "Nouvel Abonné",
  searchForAnUserByTyping: "Rechercher un utilisateur en tapant",
  enterContactType: "Entrer contact type",
  unselectAll: "Tout Désélectionner",
  thereAreNoOrderBelongingToTheSelectedBranchesFor:
    "Il n'y a aucune commande appartenant à la/aux agence(s) sélectionnée(s) pour",
  thereAreNoOrderBelongingToTheSelectedBranchesForToday:
    "Il n'y a aucune commande appartenant à la/aux agence(s) sélectionnée(s) pour aujourd'hui",
  multi_day: "Multi-jours",
  fullDay: "Journée complète",
  between: "entre",
  unavailableOn: "Indisponible le",
  h: "h",
  m: "m",
  withPhotos: "Avec photos",
  withoutPhotos: "Sans photos",
  manageEmailSubscriptions: "Gérer email subscriptions",
  reportName: "Nom du rapport",
  subscribers: "Abonnés",
  editActivities: "Modifier Activities",
  emailActivities: "Activités e-mail",
  activities: "Activités",
  timestamp: "horodatage",
  changes: "Modifications",
  modifiedBy: "Modifié Par",
  selectedFilters: "Filtres Sélectionnés",
  deactivate: "Désactiver",
  areYouSureYouWantToDeactivateThisReportEmailSubscription:
    "Êtes-vous sûr de vouloir désactiver cet abonnement au rapport par e-mail ?",
  youWillNoLongerReceiveEmailsForTheSelectedReport:
    "Vous ne recevrez plus d'e-mails pour le rapport sélectionné.",
  deactivateEmailScheduleForThisReport: "Désactiver la planification e-mail pour ce rapport ?",
  yesDeactivate: "Oui, Désactiver",
  cancelGoBack: "Annuler et Retour",
  noEmailSubscriptionsRegistered: "Aucun abonnement e-mail enregistré",
  addAdminUser: "Ajouter un utilisateur administrateur",
  oneTime: "Une fois",
  emailFrequency: "Fréquence d'e-mail",
  noOfTasks: "Nb de tâches",
  orderCreated: "Commande créée",
  totalOrders: "Total des commandes",
  ordersCompleted: "Commandes terminées",
  totalTasks: "Total des tâches",
  tasksCompleted: "Tâches terminées",
  exportingCSV: "Exportation CSV",
  taskBooked: "Tâche réservée",
  hideTasks: "Masquer les tâches",
  showTasks: "Afficher les tâches",
  lifetime: "À vie",
  reportLifetimeData: "Rapport lifetime data",
  originBranch: "Agence d'origine",
  destinationBranch: "Agence de destination",
  teamBranches: "Agences de l'équipe",
  receiveOnlyOnce: "Recevoir une seule fois",
  receiveEveryWeek: "Recevoir chaque semaine",
  receiveOnceAMonth: "Recevoir une fois par mois",
  sendOn: "Envoyer le",
  sendEvery: "Envoyer chaque...",
  onceYouClickOn: "Une fois que vous cliquez sur",
  youWillReceiveThisReportWithAllTheSelectedFiltersAndSetFrequency:
    "vous recevrez ce rapport avec tous les filtres sélectionnés (listés ci-dessus) et la fréquence définie.",
  emailDeliveryMayBeDelayedDueFactorsBeyondOurControl:
    "La livraison des e-mails peut être retardée en raison de facteurs indépendants de notre volonté.",
  pleaseWhitelistToAvoidEmailsGoingToSpam:
    "Veuillez ajouter shipeezi.com à votre liste blanche pour éviter que les e-mails n'aillent dans les spams.",
  subscriberMustBeRegisteredOnShipeezi: "L'abonné doit être inscrit sur Shipeezi",
  enterADayOfTheMonthBetween1and28: "Entrez un jour du mois entre 1 et 28",
  selectReportType: "Sélectionner le type de rapport",
  allReports: "Tous les rapports",
  selectTaskReportType: "Sélectionner le type de rapport de tâche",
  generateAndDownload: "Générer et Télécharger",
  workOrder: "Bon de travail",
  applicableOnlyOnInventoryConditionReport: "Applicable uniquement sur le rapport d'état de l'inventaire",
  applicableOnlyOnLoadAndTransshipmentReport: "Applicable uniquement sur le rapport de chargement et transbordement",
  applicableOnInventoryConditionReportMechanicalAndEletricalChecklistHightValuePropertyDemange:
    "Applicable au rapport d'état de l'inventaire, liste de contrôle mécanique et électrique, inventaire à haut risque/haute valeur, rapport de dommages matériels, rapport de chargement et transbordement, rapport de liste de contrôle (si sélectionné)",
  listOfReports: "Liste des rapports",
  allAvailableReportsForThisOrderWillBeGeneratedInOneBatchWhichMayTakeLongerThanUsual:
    "Tous les rapports disponibles pour cette commande seront générés en un seul lot, ce qui peut prendre plus de temps que d'habitude.",
  pleaseNoteThatGrayedOutReportsAreCurrentlyUnavailbaleForThisOrder:
    "Veuillez noter que les rapports grisés sont actuellement indisponibles pour cette commande.",
  youCanChooseTheSpecificReportsYouNeedAndEachSelectedReportWillBeGeneratedAsAnIndividualFileWhichMayTakeLongerThanUsual:
    "Vous pouvez choisir les rapports spécifiques dont vous avez besoin, et chaque rapport sélectionné sera généré en tant que fichier individuel, ce qui peut prendre plus de temps que d'habitude.",
  security: "Sécurité",
  enableTwoFactorAuthenticationToLogin: "Activer l'authentification à deux facteurs pour se connecter",
  enableAnExternalMethodToAuthenticateLogin: "Activer une méthode externe pour authentifier la connexion.",
  limitUnsuccessfulLogonAttempts: "Limiter les tentatives de connexion infructueuses",
  anThe4thFailedAttemptTheAccountWillBeLockedFor30Seconds:
    "À la 4e tentative échouée, le compte sera verrouillé pendant 30 secondes ;",
  onThe5thFailedAttemptTheAccountWillBeLockedFor60Seconds:
    "À la 5e tentative échouée, le compte sera verrouillé pendant 60 secondes ;",
  anyFailedAttemptsAfterThe5thTheAccountWillBeLockedFor120Seconds:
    "Toute tentative échouée après la 5e, le compte sera verrouillé pendant 120 secondes.",
  onThe6thFailedAttemptTheAccountWillBeLockedFor120Seconds:
    "À la 6e tentative échouée, le compte sera verrouillé pendant 120 secondes ;",
  anyFailedAttemptsAfterThe6thTheAccountWillBeLockedFor120Seconds:
    "Toute tentative échouée après la 6e, le compte sera verrouillé pendant 120 secondes.",
  autoTerminateSessionsAfter8HoursFromLogin: "Terminer automatiquement les sessions après 8 heures de connexion",
  thePlatformCalculates8HoursFromTheMostRecentLoginAndTerminatesTheSessionRequiringTheUserToLogInAgain:
    "La plateforme calcule 8 heures à partir de la dernière connexion et termine la session, obligeant l'utilisateur à se reconnecter.",
  aWarningAppears15MinutesBeforeTheSessionTeminates:
    "Un avertissement apparaît 15 minutes avant la fin de la session.",
  minimumPasswordComplexityPolicy: "Politique de complexité minimale du mot de passe",
  passwordsMustFulfilMinimumRequirementsForAComplexPasswordWhenCreatingOrResettingAPassword:
    "Les mots de passe doivent respecter les exigences minimales de complexité lors de la création ou de la réinitialisation d'un mot de passe.",
  prohibitPasswordReuse: "Interdire la réutilisation du mot de passe",
  prohibitUsersFromReusingAPreviousPasswordWhenCreatingOrResettingAPassword:
    "Interdire aux utilisateurs de réutiliser un mot de passe précédent lors de la création ou de la réinitialisation d'un mot de passe.",
  automatedPasswordResetPolicy: "Politique de réinitialisation automatique du mot de passe",
  passwordsMustBeChangedEvery90Days: "Les mots de passe doivent être changés tous les 90 jours.",
  operationsApp: "Application Opérations",
  inventoryNumberingIsTheStartingInventoryNumberEditable:
    "Numérotation d'inventaire : Le numéro d'inventaire de départ est-il modifiable ?",
  enforceAppLockScreen: "Imposer l'écran de verrouillage de l'application",
  usingTheAppForMilitaryPurpose: "Utilisation de l'application à des fins militaires ?",
  ifAUserIsInactiveForASetPeriodTheAppLocksAutomaticallyForSecurityUsersChooseAPinAtFirstLoginAndCanResetItUsingTheirUsernameAndPasswordThisPreventsUnauthorizedAccessToSensitiveData:
    "Si un utilisateur est inactif pendant une période définie, l'application se verrouille automatiquement par sécurité. Les utilisateurs choisissent un code PIN à la première connexion et peuvent le réinitialiser avec leur nom d'utilisateur et mot de passe. Cela empêche l'accès non autorisé aux données sensibles.",
  enterInactivityTime: "Saisir le temps d'inactivité",
  fieldRelatedSettings: "Paramètres liés au terrain",
  loadIntoStorageBoxIsMandatoryInUpliftTask: "Le chargement dans une boîte de stockage est obligatoire pour la tâche de majoration",
  systemConfigurationIsNotAvailablePleaseContactTheAdministratorForAssistance:
    "La configuration du système n'est pas disponible. Veuillez contacter l'administrateur pour obtenir de l'aide.",
  updatedSuccessfully: "Mis à jour avec succès",
  ifVolumeConfirmationIsMandatoryThenStorageBoxMandatoryOptionMustBeSetToFalse:
    "Si la confirmation du volume est obligatoire, alors l'option boîte de stockage obligatoire doit être définie sur faux.",
  volumeConfirmation: "Confirmation du Volume",
  autofillBasedOnTheTask: "Remplissage automatique basé sur la tâche",
  allowMultipleSelection: "Autoriser la sélection multiple",
  inventoryFields: "Champs d'inventaire",
  expanseManagement: "Gestion des dépenses",
  others: "Autres",
  cost: "Coût",
  onceDeletedThisEntryWillBePermanentlyRemoved:
    "Une fois supprimée, cette entrée sera définitivement retirée.",
  loadingTaskInformation: "Chargement des informations de la tâche...",
  taskNotFound: "Tâche non trouvée",
  couldNotLoadRequestedTaskDetails: "Impossible de charger les détails de la tâche demandée.",
  recalculateExpenses: "Recalculer les Dépenses",
  isTimeSlotRequiredForMultiDayTask: "Un créneau horaire est-il requis pour une tâche sur plusieurs jours ?",
  fixedTimeSlot: "Créneau horaire fixe",
  variableTimeSlot: "Créneau horaire variable",
  addAnotherDate: "Ajouter une autre date",
  itShouldBeAtLeastTwoDates: "Il doit y avoir au moins deux dates.",
  endTimeMustBeGreaterThanStartTime: "L'heure de fin doit être supérieure à l'heure de début.",
  generatingYourReportMightTakeLongerThanUsual:
    "La génération de votre rapport peut prendre plus de temps que d'habitude.",
  weWillNotifyYouAsSoonAsItsReadyForDownload:
    "Nous vous notifierons dès qu'il sera prêt à télécharger. Vous pouvez fermer cette fenêtre en toute sécurité entre-temps.",
  categorizeItemsInOperationsApp: "Catégoriser les articles dans l'application opérations",
  checkedFieldsWillBeMarkedAsAMandatory: "Les champs cochés seront marqués comme obligatoires.",
  selectCategories: "Sélectionner les catégories",
  mandatoryFields: "Champs Obligatoires",
  mandatoryFieldsByCategory: "Champs obligatoires par catégorie",
  noAccess: "Aucun accès",
  fullAccess: "Accès complet",
  partialAccess: "Accès partiel",
  newAccessRuleAdded: "Nouvelle règle d'accès '{{accessRuleName}}' ajoutée",
  newAccessRuleAddedAndSetAsInactive:
    "Nouvelle règle d'accès '{{accessRuleName}}' ajoutée et définie comme inactive",
  accessRuleUpdatedSuccessfully: "Règle d'accès '{{accessRuleName}}' mise à jour avec succès",
  accessRuleDeletedSuccessfully: "Règle d'accès '{{accessRuleName}}' supprimée avec succès",
  thisIsASystemDefaultAccessRuleAndCannotBeModifiedYouAreWelcomeToCreateANewAccessRuleOrDuplicateAsNeeded:
    "Il s'agit d'une règle d'accès par défaut du système qui ne peut pas être modifiée. Vous pouvez créer une nouvelle règle d'accès ou la dupliquer selon vos besoins.",
  thisAccessRuleIsUtilizedBy: "Cette règle d'accès est utilisée par {{group}}",
  returnToPermissions: "Retour aux autorisations",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeactivated:
    "Cette règle est actuellement utilisée par des groupes et ne peut pas être désactivée.",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeleted:
    "Cette règle est actuellement utilisée par des groupes et ne peut pas être supprimée.",
  pleaseUseOnlyLettersNumbersAndSpacesSpecialCharactersAreNotAllowed:
    "Veuillez utiliser uniquement des lettres, des chiffres et des espaces. Les caractères spéciaux ne sont pas autorisés.",
  enterNameForThisAccessRule: "Entrez un nom pour cette règle d'accès",
  describeThisAccessRuleInFewWords: "Décrivez cette règle d'accès en quelques mots",
  failedToAssignPermissionsToAccessRulePleaseTryAgain:
    "Impossible d'attribuer les autorisations à la règle d'accès. Veuillez réessayer.",
  yourPermissionsHaveBeenUpdatedPleaseLogInAgainToApplyTheNewChanges:
    "Un administrateur a mis à jour les autorisations d'accès de votre groupe. Pour appliquer les modifications, vous devez vous déconnecter et vous reconnecter.",
  signBackIn: "Se reconnecter",
  groupAccessRuleUpdated: "Règle d'accès du groupe mise à jour",
  theAccessRuleNameAlreadyExistsPleaseChooseADifferentName:
    "Le nom de la règle d'accès '{{accessRuleName}}' existe déjà. Veuillez choisir un nom différent.",
  enterNickname: "Saisir le Surnom",
  nicknameIsForYourOwnReference: "Le surnom est pour votre propre référence",
  dateOfDeparture: "Date de Départ",
  arrivalAtAod: "Arrivée à AoD",
  enterOrder: "Saisir la commande",
  enterEmail: "Saisir l'E-mail",
  enterMobileNumber: "Saisir le numéro de portable",
  realTimeTrackingUnavailable: "Real-Heure Suivi Indisponible",
  liveTrackingIsUnavailableOnYourCurrentPlanUnlockThisFeatureByUpgradingYourPlanOrContactingOurSupportTeamForAssistance:
    "Le suivi en temps réel n'est pas disponible sur votre plan actuel. Débloquez cette fonctionnalité en mettant à niveau\nvotre plan ou en contactant notre équipe de support.",
  typeOfContact: "Type de Contact",
  notifyVia: "Notifier par",
  refineByOrder: "Affiner par commande",
  bolBooking: "BoL/Réservation",
  pol: "PoL",
  utilization: "Utilisation",
  destinationAirport: "Aéroport de Destination",
  display: "Afficher",
  items2: "Articles",
  exportCSV: "Exporter CSV",
  numberOfRowsPerPage: "Nombre de lignes par page",
  errorField: "Erreur",
  showHideColumn: "Afficher/Masquer columns",
  typeAndClickEnterToAdd: "Saisissez et appuyez sur Entrée pour ajouter",
  communicationSentSuccessfully: "Communication envoyée avec succès!",
  deSelectAll: "Tout Désélectionner",
  selectOrders: "Sélectionner les commandes",
  addSelectedOption: "Ajouter Sélectionné Commandes",
  volumeAdded: "Volume Ajouté",
  noLinkNotYet: "Pas encore de commandes liées !",
  notifyUsers: "Notifier les Utilisateurs",
  notificationSentSuccessfully: "Notification envoyée avec succès!",
  continueBooking: "Continuer la Réservation",
  saveADraft: "Enregistrer un Brouillon",
  grossWeightKg: "Poids brut (Kg)",
  saveThisSearch: "Enregistrer cette recherche",
  serial: "Série",
  groupManagementCreatedSuccessfully: "Groupe '{{groupName}}' créé avec succès",
  groupManagementUpdatedSuccessfully: "Groupe '{{groupName}}' mis à jour avec succès",
  errorUpdateGroupManagement:
    "Une erreur s'est produite lors de la mise à jour du groupe '{{groupName}}'. Veuillez contacter le support Shipeezi pour obtenir de l'aide",
  groupInfoViewOnly:
    "Il s'agit d'un groupe système par défaut qui ne peut pas être modifié, mais vous pouvez y ajouter ou en retirer des membres",
  groupNameAlreadyExists:
    "Le nom du groupe '{{groupName}}' existe déjà. Veuillez choisir un nom différent.",
  departure: "Départ",
  arrival: "Arrivée",
  itLooksLikeYoureAboutToLeaveTheBookingProcessIfYouExitNowYourBookingWillNotBeCompletedAndAllTheInformationYouveEnteredSoFarWillBeLost:
    "Il semble que vous êtes sur le point de quitter le processus de réservation. Si vous quittez maintenant, votre réservation ne sera pas complétée et toutes les informations saisies seront perdues.",
  importantOnceYouLeaveTheresNoGuaranteeThatTheSameAvailabilityAndRatesWillStillApplyIfYouStartTheBookingAgain:
    "Important : Une fois que vous partez, il n'y a aucune garantie que la même disponibilité et les mêmes tarifs s'appliqueront si vous recommencez la réservation.",
  areYouSureYouWantToCancel: "Êtes-vous sûr de vouloir annuler ?",
  connectionTimeout: "Délai de connexion dépassé : veuillez réessayer",
  timeoutDetail:
    "Cela prend plus de temps que prévu. Il peut s'agir d'un problème temporaire. Veuillez actualiser la page ou réessayer dans quelques instants.",
  retry: "Réessayer",
  nothingToDisplayHere: "Rien à afficher ici !",
  toGetStartedFillOutTheSearchFormWithYourFreightDetailsAndHitTheSearchButtonToSeeTheBestAvailableOptions:
    'To get started, fill out the search form with your freight details and hit the "Search" button to see the best available options.',
  averagePassword: "Mot de passe moyen",
  tariff: "Tarif",
  roadFreightPickUp: "Fret routier\n(enlèvement)",
  thcO: "THC-O",
  exportService: "Exporter service",
  thcD: "THC-D",
  importService: "Importer service",
  roadFreightDelivery: "Fret routier (livraison)",
  carbonOffset: "Compensation carbone",
  transportMode: "Mode de transport",
  rateValidity: "Validité du taux",
  totalCargoWeight: "Poids total de la cargaison",
  inspectionServices: "Services d'inspection",
  customClearance: "Personnalisé Clearance",
  etaAtWarehouse: "ETA à l'entrepôt",
  edd: "EDD",
  etaUnpack: "ETA déballage",
  supplierPortalBannerMessagePaymentPending:
    "Selon l'<strong>Incoterm {{incoterm}}</strong>, les coûts doivent être payés par l'acheteur. La réservation sera confirmée après le paiement.",
  supplyChainBannerMessagePaymentPending:
    "Selon l'<strong>Incoterm {{incoterm}}</strong>, les coûts doivent être payés pour confirmer la réservation.",
  originTerminalHandlingCharge: "Frais de manutention terminale origine",
  destinationTerminalHandlingCharge: "Frais de manutention terminale destination",
  portOfLoadingPoL: "Port de chargement (PoL)",
  portOfDischargePoD: "Port de Déchargement (PoD)",
  movementType: "Type de mouvement",
  freightCharges: "Frais de fret",
  payWithCard: "Payer par carte",
  notRequired: "Non requis",
  paymentWillBeAvailableToTheBuyerSoon: "Le paiement sera bientôt disponible pour l'acheteur.",
  theBuyerHasPaidSuccessfully: "L'acheteur a payé avec succès.",
  thisBookingHasExpiredAndBeenCancelled: "Cette réservation a expiré et a été annulée.",
  onceConfirmedThisWillBeSentToTheCarrierYouAreNotAbleToMakeAnyAdditionalChanges:
    "Une fois confirmé, cela sera envoyé au transporteur et vous ne pourrez plus apporter de modifications.",
  payBooking: "Payer la réservation",
  paidOn: "Payé le",
  noAllocated: "Non allocated",
  thisFieldDoesntAllowSpecialCharacters: "Ce champ n'accepte pas les caractères spéciaux",
  anErrorOccurredWhileProcessingYourRequestPleaseTryAgainOrContactSupport:
    "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer ou contacter le support.",
  anErrorOccurredWhileProcessingYourRejectionPleaseTryAgainOrContactSupport:
    "Une erreur s'est produite lors du traitement de votre rejet. Veuillez réessayer ou contacter le support.",
  errorProcessingRejection: "Erreur lors du traitement du rejet",
  errorProcessingRequest: "Erreur lors du traitement de la demande",
  areYouAnExistingShipeeziUser: "Êtes-vous déjà un utilisateur Shipeezi ?",
  yesGoToLoginPage: "Oui, aller à la page de connexion",
  noRegisterAsAnAgent: "Non, s'inscrire en tant qu'agent",
  selectCompany: "Sélectionner l'Entreprise",
  enterName: "Saisir le nom",
  connect: "Connecter",
  anErrorOccurredWhileTryingToConnectTheCompaniesPleaseTryAgainLater:
    "Une erreur s'est produite en tentant de connecter les entreprises. Veuillez réessayer plus tard.",
  invalidOrExpiredLink: "Lien invalide ou expiré",
  thisInvitationLinkIsInvalidOrHasAlreadyExpiredPleaseContactUsToReceiveANewInvitation:
    "Ce lien d'invitation est invalide ou a déjà expiré. Veuillez nous contacter pour recevoir une nouvelle invitation.",
  paymentPending: "Paiement en attente",
  processing: "En traitement",
  searchFreight: "Rechercher le Fret",
  freightBooking: "Réservation de Fret",
  YourShipeeziID: "Votre ID Shipeezi",
  noOfOrders: "Nb de commandes",
  carriersFound: "Transporteurs found",
  LowToHigh: "Bas to Élevé",
  HighToLow: "Élevé to Bas",
  directRoutes: "Routes Directes",
  alternateRoutes: "Routes Alternatives",
  alternate: "Alternatif",
  direct: "Direct",
  Shipmentno: "Expédition Non",
  passwordResetSuccesfully: "Réinitialisation du mot de passe réussie",
  frieghtid: "ID Freight",
  passwordRestLinkExpired: "Le lien de réinitialisation du mot de passe a expiré",
  valid: "Valide",
  customerIsNotAllowedToReceiveNotification: "Le client n'est pas autorisé à recevoir des notifications",
  carbonFootprint: "Empreinte Carbone",
  PlaceOfDestination: "Lieu de destination",
  advanceShippingNoticeIsRequired: "Un avis d'expédition anticipé est requis",
  weightCantBe0: "Le poids ne peut pas être 0",
  shipTermsIsRequired: "Les conditions d'expédition sont requises",
  selectOfficeFromTheDropdown: "Sélectionnez le bureau dans la liste déroulante",
  marksAndNumber: "Marques et Numéro",
  requiredDocument: "Documents Obligatoires",
  supportingDocuments: "Documents de Soutien",
  optionalShipmentData: "Facultatif Expédition Data",
  requiredVolumeConfirmation: "La confirmation du volume est obligatoire",
  shipmentsSettings: "Expéditions",
  seaTrackingEnabled: "Suivi maritime activé",
  airTrackingEnabled: "Suivi aérien activé",
  accessRuleCreatedSuccessfully: "Nouvelle règle d'accès '{{accessRuleName}}' ajoutée",
  accessRuleDuplicatedSuccessfully: "Nouvelle règle d'accès '{{accessRuleName}}' ajoutée et définie comme inactive",
  accessRuleInfoViewOnly:
    "Il s'agit d'une règle d'accès par défaut du système qui ne peut pas être modifiée. Vous pouvez créer une nouvelle règle d'accès ou la dupliquer selon vos besoins.",
  viewGroupAccessRuleTitle: "Cette règle d'accès est utilisée par {{groupCount}} groupes",
  accessRuleNameHaveSpecialCharacter:
    "Veuillez utiliser uniquement des lettres, des chiffres et des espaces. Les caractères spéciaux ne sont pas autorisés.",
  updatedPreference: "Préférences du tableau de données mises à jour !",
  subscriberThatLinkedToOrdersIsNotAllowedToBeDelete:
    "Les abonnés liés à des commandes ne peuvent pas être supprimés !",
  minimumPageSizeGreaterThanTen: "La taille minimale de page est 10",
  subscriberSuccessfullyAdded: "Abonné ajouté avec succès",
  defaultTeam: "Par défaut Équipe",
  customTeam: "Personnalisé Équipe",
  created: "Créé",
  noMatchingRecordsFound: "Aucun enregistrement correspondant trouvé",
  tryAdjustingYourFilters: "Essayez d'ajuster vos filtres.",
  noRecordFound: "Aucun enregistrement trouvé",
  haveTask: "A une tâche",
  dontHaveTask: "Pas de tâche",
  forContainerOnRow: "Pour le conteneur en ligne",
  column: "Colonne",
  storeName: "Store Nom",
  loadedStatus: "Loaded Statut",
  markAsDefault: "Marquer as default",
  enterTemplateName: "Entrer le nom du modèle",
  enterSubject: "Entrer subject",
  enterFromName: "Entrer le nom de l'expéditeur",
  enterStatus: "Entrer status",
  enterAvailableIn: "Entrer available in",
  enterAutomation: "Entrer automation",
  enterLastUpdate: "Entrer la dernière mise à jour",
  addBusinessIcon: "Ajouter une icône d'entreprise",
  addBusinessLogo: "Ajouter Business Logo",
  addIcon: "Ajouter une icône",
  fromName: "From Nom",
  formatsJPG_GIF_PNG: "Formats : JPG, GIF, PNG",
  maxSize2MB: "Taille max : 2 Mo",
  attachments: "Pièces jointes",
  pushNotification: "Notification push",
  salesApp: "Application commerciale",
  linkedAutomation: "Automatisation liée",
  noAutomationsLinked: "Aucune automatisation associée",
  signup: {
    left: {
      title: "Une plateforme, chaque déplacement",
      subtitle:
        "Commencez votre essai gratuit et découvrez comment Shipeezi unifie chaque partie de votre flux de travail, des ventes aux opérations en passant par l'entreposage.",
      card1Title: "La simplicité à grande échelle",
      card1Desc:
        "Shipeezi rassemble tous vos processus en un seul endroit, aidant votre équipe à travailler plus intelligemment et plus rapidement à travers le monde.",
      card2Title: "Plus de contrôle, moins de coûts",
      card2Desc:
        "Avec tout connecté, vous gagnerez du temps, réduirez les erreurs et diminuerez les coûts — tout en offrant à vos clients une expérience fluide.",
      trusted: "Approuvé par les leaders de l'industrie dans le monde entier",
    },
    right: {
      createAccount: "Créer votre compte",
      subtitle:
        "Vous êtes à quelques instants d'avoir une visibilité et un contrôle complets sur vos expéditions !",
      haveAccount: "Vous avez un compte?",
      signIn: "Se connecter",
      thankYou: "Merci d'avoir demandé un compte chez Shipeezi",
      pendingApproval: "Notre équipe vous contactera avant d'activer votre compte",

      // Step 2
      step2Title: "Parlez-nous de votre entreprise",
      step2Subtitle: "Nous adapterons Shipeezi aux besoins de votre entreprise",
      companyName: "Nom de l'entreprise",
      companyType: "Type d'entreprise",
      selectYourPlatform: "Sélectionnez votre plateforme",

      // Step 3
      step3Title: "Que souhaiteriez-vous améliorer avec Shipeezi ?",
      step3Subtitle: "Choisissez les domaines de votre entreprise que vous souhaitez simplifier et développer",
      sales: "Ventes",
      operations: "Opérations",
      warehousing: "Entreposage",

      // botões genéricos
      next: "Suivant",
      back: "Retour",

      // (para etapas futuras, mas já deixo pronto)
      requestAccount: "Demander account",
      termsOfUse: "Conditions d'Utilisation",
      privacyPolicy: "Politique de confidentialité",
      and: "et",
      byContinuingYouReAgreeingToShipeeziS: "En continuant, vous acceptez les conditions de Shipeezi",
      getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime:
        "Recevez des e-mails de Shipeezi sur les mises à jour produit, les actualités du secteur et les événements. Si vous changez d'avis, vous pouvez vous désabonner à tout moment.",
      captchaExpired: "Captcha expiré",

      step4Title: "Aidez-nous à comprendre votre processus de vente",
      step4Subtitle: "Vos réponses nous aideront à configurer Shipeezi pour votre équipe",

      // Questions
      videoSurveysQuestion: "Offrez-vous des visites vidéo à vos clients ?",
      salesRepsQuestion: "Combien de commerciaux votre entreprise a-t-elle ?",
      yes: "Oui",
      no: "Non",
      range_1_10: "1-10",
      range_11_20: "11-20",
      range_above_30: "Plus de 30",

      // Titles/subtitles por área (Step 4)
      salesStepTitle: "Aidez-nous à comprendre votre processus de vente",
      salesStepSubtitle: "Vos réponses nous aideront à configurer Shipeezi pour votre équipe",

      operationsStepTitle: "Parlez-nous de vos opérations",
      operationsStepSubtitle: "Nous configurerons Shipeezi en fonction de la façon dont votre entreprise fonctionne aujourd'hui",

      warehousingStepTitle: "Parlez-nous de votre entreposage",
      warehousingStepSubtitle:
        "Nous optimiserons votre configuration d'entreposage et d'inventaire dans Shipeezi",

      // Warehousing
      storageQuestion: "Offrez-vous du stockage à vos clients ?",
      warehousesCountQuestion: "Combien d'entrepôts gérez-vous ?",

      // Operations
      shipmentType: "Type d'expédition",
      local: "Local",
      international: "International",
      interstate: "Interétatique",
      military: "Militaire",
      annualShipmentVolume: "Volume annuel d'expéditions",
      v_1_4: "1-4",
      v_5_600: "5-600",
      v_601_10000: "601 - 10,000",
      v_10001_20000: "10,001 - 20,000",
      v_20001_plus: "20,001 +",

      step5Title: "Super ! Nous avons presque terminé !",
      step5Subtitle: "Nous aimerions savoir comment vous avez découvert Shipeezi !",

      thankYouV2Title: "Merci de votre inscription !",
      thankYouV2Description:
        "Notre équipe vous contactera prochainement pour activer votre compte. Vous serez alors prêt à découvrir Shipeezi — une plateforme, chaque mouvement.",
      returnToWebsite: "Retour à notre site web",

      // Discovery options
      discover: {
        website: "Notre site web",
        email: "Marketing par e-mail",
        google: "Google",
        newsletter: "Lettre d'information",
        aiTools: "Outils IA",
        referral: "Parrainage",
        whereLabel: "Où ?",
        whoReferredLabel: "Qui vous a recommandé ?",
        other: "Autre",
      },
      wh_1_10: "1-10",
      wh_11_30: "11-30",
      wh_above_30: "Plus de 30",
      trustedBy: "Approuvé par les leaders du secteur dans le monde",
      paymentTerms: "Conditions de paiement",
      privacyAndCompliance: "Politique de confidentialité et conformité",
      saasAgreement: "Contrat SAAS et SLA",
      termsOfSale: "Conditions de vente",
      termsPrefix: "En continuant, vous acceptez les",
      ownWords: {
        questionLabel: "Quels sont vos défis ou obstacles actuels ?",
        placeholder: "Tapez quelque chose...",
        characters: "caractères",
        helperShort: "Votre message doit comporter au moins 50 caractères.",
        helperLong: "Veuillez limiter votre message à 500 caractères.",
      },
    },
  },
  common: {
    close: "Fermer",
    save: "Enregistrer",
    saving: "Enregistrement",
  },
  onboarding: {
    pageTitle: "Intégration",
    left: {
      title: "Bienvenue chez Shipeezi !\nUne plateforme, chaque déplacement",
      subtitle:
        "Vous n'êtes qu'à quelques étapes de la configuration de votre compte. Shipeezi vous aidera à simplifier les processus, connecter votre équipe et vous donner un contrôle total sur chaque mouvement. Commençons.",
    },
    steps: {
      introduction: "Introduction",
      companyDetails: "Détails de l'Entreprise",
      myBilling: "Ma facturation",
      members: "Membres",
      uploadCentre: "Centre de Téléversement",
      complete: "Terminer",
    },
    uploadCentre: {
      title: "Centre de Téléversement",
      description:
        "Ici, vous pouvez téléverser vos propres fichiers (comme l'inventaire, le personnel ou les listes de services) ou commencer avec la liste par défaut de Shipeezi. Vous pouvez toujours mettre à jour plus tard.",
      uploadOwnList: "Téléverser ma propre liste",
      uploadOwnListDescription: "Importez vos propres données pour personnaliser Shipeezi dès le départ.",
      useDefaultList: "Utiliser la liste par défaut de Shipeezi (ISO17451-1:2016)",
      useDefaultListDescription:
        "Commencez rapidement avec notre liste préconfigurée, construite sur la norme mondiale ISO17451-1:2016. Vous pouvez la mettre à jour ou l'enrichir à tout moment.",
      downloadTemplate: "Téléchargez notre modèle CSV ici",
      complete: "Terminer",
    },
    complete: {
      title: "Bienvenue chez Shipeezi — où visibilité, contrôle et simplicité se rejoignent.",
      subtitle: "",
      button: "Commencer",
      leftTitle: "Configuration terminée !",
      leftSubtitle: "Vous êtes prêt à gérer chaque déplacement sur une seule plateforme.",
    },
    buttons: {
      goBackToLogin: "Retour à la connexion",
      skip: "Passer pour le moment",
      downloadCsvTemplate: "Téléchargez notre modèle CSV ici",
      next: "Suivant",
      back: "Retour",
    },
    introduction: {
      companyDetails:
        "Ajoutez les informations de votre entreprise, l'adresse professionnelle, le contact principal et les détails de l'e-mail, afin que nous puissions configurer votre compte correctement.",
      members:
        "Invitez les membres de votre équipe et attribuez les bonnes autorisations pour leur donner accès là où ils en ont besoin.",
      uploadCentre:
        "Téléversez vos informations et données initiales afin que Shipeezi puisse tout connecter facilement pour vous.",
    },
    members: {
      title: "Membres",
      description:     "Invitez les personnes qui utiliseront Shipeezi avec vous. Attribuez leur rôle et succursale pour un accès adapté dès le départ. Vous pourrez toujours mettre à jour ou ajouter des membres plus tard.",
      registeredMembers: "Membres enregistrés",
      firstName: "Prénom",
      lastName: "Nom",
      email: "E-mail",
      memberCode: "Code membre",
      branch: "Succursale",
      mobile: "Mobile",
      accessGroup: "Groupe d'accès",
      memberType: "Type de membre",
      additionalMembers: "Membres supplémentaires",
      uploadMembers: "Téléverser des membres",
      addMembers: "Ajouter des membres",
      name: "Nom",
      group: "Groupe",
      type: "Type",
      noAdditionalMembers: "Aucun membre supplémentaire",
      downloadTemplate: "Télécharger le modèle",
      uploadCSV: "Téléverser CSV",
      addMember: "Ajouter un membre",
      userCode: "Code utilisateur",
    },
    billing: {
      useSameAdmin: 'Use the same “administrator user" details',
      contactName: "Billing Contact Nom",
      email: "E-mail",
      phone: "Numéro de téléphone",
      address: "Adresse",
      paymentMethod: "Paiement method",
      noPaymentMethod: "Aucun mode de paiement enregistré",
      addPaymentMethod: "Ajouter un mode de paiement",
      creditCard: "Carte de crédit",
      nameOnCard: "Nom sur la carte",
    },
  },
  notShared: "Non partagé",
  partiallyShared: "Partagé partiellement",
  fullyShared: "Entièrement partagé",
  scac: "SCAC",
  inventorySummary: "Résumé de l'inventaire",
  networkDetails: "Détails",
  networkRoles: "Rôles",
  networkWeightAndMeasurements: "POIDS ET MESURES",
  networkPickup: "Enlèvement",
  networkDelivery: "Livraison",
  networkGeneralComments: "COMMENTAIRES GÉNÉRAUX",
  networkActualInventory: "Inventaire réel",
  networkQuotedInventory: "Inventaire devisé",
  networkPhotosAndVideos: "PHOTOS ET VIDÉOS",
  networkDocuments: "Documents",
  networkSettingsBannerMessage:
    "Choisissez les champs de données de la section ci-dessous que vous souhaitez afficher à l'agent du réseau lors de l'acceptation de la tâche.",
  failedToSaveNetworkSettings: "Impossible d'enregistrer les paramètres réseau. Veuillez réessayer.",
  assignToAnAgent: "Attribuer à un agent?",
  selectAnAgent: "Sélectionner un agent",
  additionalInstructions: "Instructions supplémentaires",
  enterAdditionalInstructions: "Entrer additional instructions",
  agentName: "Nom de l'agent",
  started: "Démarré",
  taskAddedSuccessfully: "Tâche ajoutée avec succès!",
  thisInstructionWillBeVisibleInTheEmailAndTaskView:
    "Cette instruction sera visible dans la vue E-mail et Tâche.",
  moreJobTypes: "Plus job types",
  moreTaskTypes: "Plus de types de tâches",
  moreTriggers: "Plus triggers",
  selectTaskTypes: "Sélectionner les types de tâches",
  selectOrderTypes: "Sélectionner les types de commandes",
  selectTriggers: "Sélectionner les déclencheurs",
  typeCode: "Code type",
  newChecklist: "Nouvelle liste de contrôle",
  enterQuestionHere: "Saisir la question ici",
  responseType: "Type de réponse",
  addLogic: "Ajouter une logique",
  shortDescription: "Brève description",
  enterDescriptionHere: "Entrer la description ici",
  singleChoiceQuestion: "Question à choix unique",
  multipleChoiceQuestion: "Question à choix multiple",
  inputText: "Texte de saisie",
  inputNumber: "Nombre de saisie",
  selectDate: "Sélectionner une date",
  addSignature: "Ajouter une signature",
  checklistItem: "Élément de liste",
  enterOptions: "Saisir les options",
  option: "Option",
  addQuestion: "Ajouter une question",
  defaultState: "État par défaut",
  taskTypes: "Types de Tâches",
  jobTypes: "Types de Travaux",
  ifAnswer: "Si réponse",
  is: "est",
  isNot: "n'est pas",
  then: "alors",
  enterText: "Saisir le texte",
  enterNumber: "Saisir le nombre",
  selectOption: "Sélectionner une option",
  isLesserThan: "est inférieur à",
  isGreaterThan: "est supérieur à",
  selected: "sélectionné",
  notSelected: "non sélectionné",
  if: "Si",
  requireEvidence: "Exiger une preuve",
  askQuestion: "Poser une question",
  chooseTheEvidenceThatllBeRequiredWhenThisAnswerIsSelected:
    "Choisissez les preuves qui seront requises lorsque cette réponse sera sélectionnée.",
  youShouldAddAtLeastOneOption: "Vous devez ajouter au moins une option.",
  youShouldAddAtLeastTwoOptions: "Vous devez ajouter au moins deux options.",
  allOptionsShouldHaveAName: "Toutes les options doivent avoir un nom.",
  methodOfPreparation: "Méthode de Préparation",
  itemCharacteristics: "Caractéristiques de l'Article",
  highRiskHighValueChecklist: "Élevé Risk/Élevé Valeur Checklist",
  proGearChecklist: "Liste de contrôle Pro-Gear",
  isHighRisk: "Est Haut Risque",
  notHighRisk: "Pas Haut Risque",
  isProGear: "Est Pro-Gear",
  notProGear: "Pas Pro-Gear",
  meChecklistNotDone: "Liste de contrôle M&E non effectuée",
  unsavedItem: "Article non enregistré, enregistrez pour appliquer tous les filtres correctement",
  youHaveUnsavedChanges: "Vous avez des modifications non enregistrées.",
  doYouWantToSaveBeforeLeaving: "Voulez-vous enregistrer avant de partir",
  timezoneIssue: "Problème de fuseau horaire",
  allQuestionsMustHaveATitleAndAllLogicsFieldsMustBeFilled:
    "Toutes les questions doivent avoir un titre et tous les champs logiques doivent être remplis.",
  areYouSureYouWantToDeleteThisLogic: "Êtes-vous sûr de vouloir supprimer cette logique",
  deleteLogic: "Supprimer la Logique",
  atLeastOneOptionIsRequired: "Au moins une option est requise",
  atLeastTwoOptionsAreRequired: "Au moins deux options sont requises",
  templateNameAlreadyExists: "Le nom du modèle existe déjà !",
  userUploaded: "Utilisateur uploads",
  systemGenerated: "Téléversements système",
  uploadFiles: "Téléverser des fichiers",
  orDragAndDropHere: "ou faites glisser et déposez des fichiers ici",
  maxFileSizeLimit: "Taille maximale du fichier : 25 Mo. Formats acceptés :",
  quickOrder: "Commande Rapide",
  createQuickOrder: "Créer une Commande Rapide",
  automaticSequenceUnavailableEnterReferenceManually:
    "La séquence automatique n'est pas disponible. Veuillez saisir la référence manuellement.",
  enableQuickOrder: "Activer la commande rapide",
  showOrderReportInManagement: "Afficher le rapport de commandes dans Management",
  reportsAvailableForSharingViaOpsApp:
    "Rapports disponibles pour le partage via Ops App",
  noReportsAvailableForSharingViaOpsApp:
    "Aucun rapport disponible pour le partage via Ops App",
  orderReport: "Rapport de commandes",
  orderAlreadyExists: "La commande existe déjà",
  searchOrAddCustomer: "Rechercher ou ajouter un client",
  aCustomerWithSameIdAlreadyExists: "Un client avec le même ID a déjà été ajouté",
  addANoteAsEvidence: "Ajouter une note comme preuve",
  addAPhotoAsEvidence: "Ajouter une photo comme preuve",
  displayInDispatchModule: "Afficher dans le module d'expédition",
  leavingTheWarehouse: "Quitter l'entrepôt",
  leads: "Prospects",
  estimates: "Estimations",
  proposal: "Proposition",
  invoicing: "Facturation",
  creditNotes: "Notes de crédit",
  expenses: "Dépenses",
  claims: "Réclamations",
  storageBoxUnit: "Boîte de Stockage et Unité",
  storageAccount: "Compte de Stockage",
  finance: "Finance",
  packageType: "Type d'emballage",
  methodType: "Type de méthode",
  itemInstruction: "Instruction de l'article",
  communicationCentre: "Centre de Communication",
  leadSoure: "Source du prospect",
  help: "Aide",
  askDumont: "Demander à Dumont",
  dumontHelpDocumentation: "Aide et documentation",
  dumontSendFeedback: "Envoyer Feedback",
  dumontContactSupport: "Contacter le Support",
  dumontLearnHowToUseDumont: "Apprenez à utiliser Dumont",
  dumontHelpUsImproveDumont: "Aidez-nous à améliorer Dumont",
  dumontGetHelpFromTeam: "Obtenez de l'aide de notre équipe",
  dumontQuickActions: "Actions rapides",
  dumontContactOurSupport: "Contacter notre support",
  dumontGetHelpWithIssues: "Obtenez de l'aide pour les problèmes et questions",
  dumontSendUsYourFeedback: "Envoyez-nous vos commentaires",
  dumontShareThoughtsAndSuggestions: "Partagez vos idées et suggestions",
  dumontCommonQuestions: "Questions fréquentes",
  dumontHowToCreateCustomAgent: "Comment créer un agent personnalisé ?",
  dumontHowToCreateCustomAgentAnswer: "Vous pouvez créer des agents personnalisés depuis l'onglet Agents dans Dumont.",
  dumontWhatCanDumontHelp: "En quoi Dumont peut-il aider ?",
  dumontWhatCanDumontHelpAnswer:
    "Dumont peut aider avec les devis, les opérations, l'entreposage et les questions logistiques générales.",
  dumontHowToAccessChatHistory: "Comment accéder à mon historique de discussion ?",
  dumontHowToAccessChatHistoryAnswer:
    "Ouvrez l'onglet Historique dans la barre latérale pour voir et rechercher les conversations passées.",
  dumontCanCustomizeAgentCapabilities: "Puis-je personnaliser les capacités de l'agent ?",
  dumontResources: "Ressources",
  dumontKnowledgeBase: "Base de connaissances",
  dumontCompleteGuidesAndTutorials: "Guides complets et tutoriels",
  dumontSelectAnOption: "Sélectionner une option",
  dumontFeedbackHelpsImprove: "Votre avis nous aide à améliorer Dumont",
  dumontIssueType: "Type de problème",
  dumontSubject: "Sujet",
  dumontBriefDescriptionOfIssue: "Brève description du problème",
  dumontMessage: "Message",
  dumontPleaseDescribeIssueDetail: "Veuillez décrire votre problème en détail",
  dumontIncludeErrorMessages: "Incluez tout message d'erreur le cas échéant",
  dumontGotIt: "Compris",
  dumontCancel: "Annuler",
  dumontSendFeedbackButton: "Envoyer feedback",
  dumontSendMessage: "Envoyer message",
  dumontSupportRequestSentSuccessfully: "Votre demande de support a été envoyée avec succès",
  dumontFeedbackSentSuccessfully: "Votre commentaire a été envoyé avec succès",
  dumontSearchPlaceholder: "Rechercher...",
  dumontNavigation: "Navigation",
  dumontNewChat: "Nouveau chat",
  dumontChats: "Discussions",
  dumontNoChatsFound: "Aucune discussion trouvée",
  dumontNoRecentChats: "Non recent chats",
  dumontAgents: "Agents",
  dumontNoAgentsFound: "Aucun agent trouvé",
  dumontReturnToShipeezi: "Retour à Shipeezi",
  dumontHelp: "Aide",
  dumontWelcomeMessage:
    "Bonjour, {{userName}} ! Je suis Dumont, votre assistant IA. Comment puis-je vous aider aujourd'hui ?",
  dumontWelcomeMessageBusiness:
    "Bonjour, {{userName}} ! Je suis Dumont, l'assistant commercial. Je suis spécialisé dans les ventes et les devis. Comment puis-je vous aider ?",
  dumontWelcomeMessageOperations:
    "Bonjour, {{userName}} ! Je suis Dumont, l'assistant opérations. Je peux vous aider avec les expéditions, les livraisons et les opérations. De quoi avez-vous besoin ?",
  dumontWelcomeMessageWarehousing:
    "Bonjour, {{userName}} ! Je suis Dumont, l'assistant entreposage. Je peux vous aider avec l'inventaire et les opérations d'entrepôt. Comment puis-je vous aider ?",
  dumontDispatchQuickActions: "Actions rapides",
  dumontHistory: "Historique",
  dumontConversationHistory: "Historique des conversations",
  dumontNoConversationsFound: "Aucune conversation trouvée",
  dumontNoConversationHistory: "Pas encore d'historique de conversation",
  dumontTryDifferentSearchTerm: "Essayez un terme de recherche différent",
  dumontStartNewConversation: "Commencer une nouvelle conversation",
  dumontFileTooLarge: "Le fichier est trop volumineux. Taille maximale : 10 Mo.",
  dumontUnsupportedFileType: "Type de fichier non pris en charge. Veuillez sélectionner des fichiers TXT, PDF ou DOC/DOCX.",
  dumontDocumentProcessing:
    "Le traitement PDF/DOC sera bientôt disponible. Veuillez utiliser des fichiers TXT pour le moment.",
  dumontFileProcessingError: "Erreur lors du traitement du fichier. Veuillez réessayer.",
  dumontAskDumont: "Demander à Dumont",
  dumontAskDumontAnything: "Demandez n'importe quoi à Dumont",
  dumontUpload: "Téléverser",
  dumontUsesAI: "Dumont utilise l'IA. Les réponses ne sont pas toujours exactes.",
  dumontCopyConversation: "Copier conversation",
  dumontExportChat: "Exporter chat",
  dumontClearConversation: "Effacer conversation",
  dumontLoadingAgents: "Chargement des agents...",
  dumontAgentsTitle: "Agents",
  dumontCreateAgent: "Créer un agent",
  dumontSearchAgents: "Rechercher agents",
  dumontNoAgentsAvailable: "Non agents available",
  dumontAgentsAvailableSoon: "Les agents seront bientôt disponibles",
  featureLocked: "Fonctionnalité verrouillée",
  accountNotHaveAccess: "Votre compte n'a pas accès à cette fonctionnalité pour le moment.",
  reachSupportTeam: "Contactez notre équipe de support",
  forDetails: " pour les détails.",
  titleFeatureRequestSupport: "Demander l'accès à cette fonctionnalité",
  sendRequestSupport: "Envoyer une demande au support",
  itLooksLikeYouDontHaveAcessThisFeatureYet:
    "Il semble que vous n'ayez pas encore accès à cette fonctionnalité. Si vous souhaitez l'utiliser, veuillez envoyer une demande à notre équipe de support.",
  feature: "Fonctionnalité",
  pleaseDescribeYouIntendUseFeature: "Veuillez décrire comment vous comptez utiliser cette fonctionnalité",
  yourMessageShouldLeast50Characters: "Votre message doit comporter au moins 50 caractères.",
  minCharacters: "Votre message doit comporter au moins {{count}} caractères.",
  maxCharacters: "Votre message ne doit pas dépasser {{count}} caractères",
  yourRequestHasBeenSentOurSupportTeam: "Votre demande a été envoyée à notre équipe de support",
  TermsConditions: "Conditions générales",
  Iso14451: "ISO14451-1:2016",
  Iso17451: "ISO17451 - 1:2016",
  dumontConversationHistory: "Conversation Historique",
  dumontNoConversationHistory: "Non conversation history",
  dumontStartNewConversation: "Commencez une nouvelle conversation pour la voir ici",
  dumontAgentsTitle: "Agents Dumont",
  dumontCreateAgent: "Créer un agent",
  dumontSearchAgents: "Rechercher agents...",
  dumontComingSoon: "Bientôt disponible...",
  dumontBusinessAssistant: "Assistant commercial",
  dumontBusinessAssistantDesc: "Spécialisé dans les ventes et devis",
  dumontOperationsAssistant: "Assistant opérations",
  dumontOperationsAssistantDesc: "Tout votre expert en opérations",
  dumontWarehousingAssistant: "Assistant d'entreposage",
  dumontWarehousingAssistantDesc: "Expert en opérations d'inventaire et d'entrepôt",
  dumontAskDumont: "Demander à Dumont...",
  dumontUsesAI: "Dumont utilise l'intelligence artificielle. Vérifiez les réponses.",
  dumontLearnHowToUseDumont: "Apprenez à utiliser Dumont efficacement",
  dumontContactOurSupport: "Contacter notre support",
  dumontGetHelpWithIssues: "Obtenez de l'aide pour tout problème ou question",
  dumontHowToCreateCustomAgentAnswer:
    'To create a custom agent, navigate to the Agents section and click on the "Create New Agent" button. You can then configure the agent\'s capabilities and settings according to your needs.',
  dumontWhatCanDumontHelp: "En quoi Dumont peut-il m'aider ?",
  dumontWhatCanDumontHelpAnswer:
    "Dumont est votre assistant IA spécialisé en logistique et déménagement. Je peux vous aider avec la planification des expéditions, la gestion des commandes, l'optimisation des itinéraires et répondre aux questions sur vos opérations.",
  dumontHowToAccessChatHistoryAnswer:
    "Cliquez sur l'icône Historique dans la barre latérale pour voir toutes vos conversations passées avec Dumont. Vous pouvez rechercher dans votre historique et reprendre toute conversation précédente.",
  dumontCanCustomizeAgentCapabilitiesAnswer:
    "Oui ! Chaque agent peut être personnalisé pour s'adapter à votre flux de travail spécifique. Vous pouvez ajuster leurs capacités, définir des paramètres spécifiques et configurer les sources de données auxquelles ils ont accès.",
  dumontFeedbackType: "Type de Feedback",
  dumontYourFeedback: "Votre avis",
  dumontTellUsWhatYouThink: "Dites-nous ce que vous en pensez...",
  dumontSendFeedbackButton: "Envoyer Feedback",
  dumontIssueType: "Type de Issue",
  dumontBriefDescriptionOfIssue: "Brève description de votre problème",
  dumontPleaseDescribeIssueDetail: "Veuillez décrire votre problème en détail...",
  dumontIncludeErrorMessages: "Incluez tout message d'erreur ou les étapes pour reproduire le problème",
  dumontSendMessage: "Envoyer Message",
  dumontSupportRequestSentSuccessfully:
    "Votre demande de support a été envoyée avec succès. Notre équipe répondra dans les 24 heures.",
  dumontFeedbackSentSuccessfully:
    "Vos commentaires ont été envoyés avec succès. Nous apprécions votre contribution !",
  dumontPleaseSelectTextFile: "Veuillez sélectionner un fichier texte (.txt)",
  dumontDocumentAttached: "Document joint",
  dumontRemoveDocument: "Retirer document",
  dumontDefaultResponse:
    "Merci de nous avoir contactés ! J'analyse votre demande et vous fournirai la meilleure solution.",
  dumontSales: "Ventes",
  dumontOperations: "Opérations",
  dumontLogistics: "Logistique",
  thisLinkIsNotValidPleaseCheckIfYouHaveAccessedTheCorrectLink:
    "Ce lien n'est pas valide. Veuillez vérifier que vous avez accédé au bon lien.",
  youCanSafelyCloseThisWindowNowIfYouNeedAnyFurtherAssistanceFeelFreeToReachOutHaveAGreatDay:
    "Vous pouvez fermer cette fenêtre en toute sécurité. Si vous avez besoin d'aide supplémentaire, n'hésitez pas à nous contacter. Bonne journée !",
  anErrorOccurredWhileProcessingYourRequestPleaseTryAgainOrContactSupport:
    "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer ou contacter le support.",
  anErrorOccurredWhileProcessingYourRejectionPleaseTryAgainOrContactSupport:
    "Une erreur s'est produite lors du traitement de votre rejet. Veuillez réessayer ou contacter le support.",
  anErrorOccurredWhileTryingToConnectTheCompaniesPleaseTryAgainLater:
    "Une erreur s'est produite en tentant de connecter les entreprises. Veuillez réessayer plus tard.",
  thisInvitationLinkIsInvalidOrHasAlreadyExpiredPleaseContactUsToReceiveANewInvitation:
    "Ce lien d'invitation est invalide ou a déjà expiré. Veuillez nous contacter pour recevoir une nouvelle invitation.",
  networkSettingsBannerMessage:
    "Choisissez les champs de données de la section ci-dessous que vous souhaitez afficher à l'agent du réseau lors de l'acceptation de la tâche.",
  thisInstructionWillBeVisibleInTheEmailAndTaskView:
    "Cette instruction sera visible dans la vue E-mail et Tâche.",
  chooseTheEvidenceThatllBeRequiredWhenThisAnswerIsSelected:
    "Choisissez les preuves qui seront requises lorsque cette réponse sera sélectionnée.",
  allQuestionsMustHaveATitleAndAllLogicsFieldsMustBeFilled:
    "Toutes les questions doivent avoir un titre et tous les champs logiques doivent être remplis.",
  // Dumont Dispatch Prompts
  dumontDispatchShowTodayOrders: "Afficher les commandes d'expédition du jour",
  dumontDispatchShowTodayOrdersDesc: "Obtenez un résumé de toutes les commandes planifiées pour expédition aujourd'hui",
  dumontDispatchFindCustomer: "Rechercher des commandes par nom de client",
  dumontDispatchFindCustomerDesc: "Rechercher des commandes spécifiques avec les informations client",
  dumontDispatchTrackStatus: "Suivre le statut de la commande",
  dumontDispatchTrackStatusDesc: "Vérifier le statut actuel des commandes dans le système",
  dumontDispatchOptimizeRoutes: "Optimiser les itinéraires de livraison",
  dumontDispatchOptimizeRoutesDesc: "Obtenez des suggestions pour les itinéraires de livraison les plus efficaces",
  dumontDispatchQuickActions: "Actions rapides pour l'expédition",
  dumontWelcomeMessage:
    "Bonjour {{userName}}, je suis Dumont, votre assistant IA spécialisé en logistique et déménagement. Conçu pour simplifier les flux de travail complexes, j'apprends continuellement pour fournir un support plus rapide, plus intelligent et plus précis pour votre entreprise.",
  dumontWelcomeMessageBusiness:
    "Bonjour {{userName}}, je suis Dumont, l'assistant commercial ! 💼 Je suis spécialisé dans les ventes et les devis. Je peux vous aider à créer des devis de fret précis, gérer les relations clients et conclure des affaires plus rapidement. Comment puis-je vous aider aujourd'hui ?",
  dumontWelcomeMessageOperations:
    "Bonjour {{userName}}, je suis Dumont, l'assistant opérations ! 📊 Je suis votre expert en opérations. Je peux vous aider à suivre les expéditions, surveiller les livraisons, gérer les travaux et assurer des opérations logistiques fluides. De quoi avez-vous besoin ?",
  dumontWelcomeMessageWarehousing:
    "Bonjour {{userName}}, je suis Dumont, l'assistant entreposage ! 🏭 Je suis spécialisé dans l'inventaire et les opérations d'entrepôt. Je peux vous aider à gérer les niveaux de stock, suivre l'inventaire, coordonner le stockage et optimiser l'efficacité de l'entrepôt. Comment puis-je vous aider ?",
  // Dumont Fullscreen Sidebar
  dumontSearchPlaceholder: "Rechercher dans les discussions, agents, historique...",
  dumontNewChat: "Nouveau Chat",
  dumontWhatCanIHelpYouWith: "Comment puis-je vous aider ?",
  dumontOptimizeLogisticsOperations: "Optimiser mes opérations logistiques",
  dumontOptimizeLogisticsOperationsDesc:
    "Obtenez des recommandations personnalisées pour améliorer l'efficacité et réduire les coûts",
  dumontTrackShipmentStatus: "Suivre shipment status",
  dumontTrackShipmentStatusDesc: "Obtenez des mises à jour en temps réel sur vos expéditions et estimations de livraison",
  dumontCalculateShippingCosts: "Calculer shipping costs",
  dumontCalculateShippingCostsDesc:
    "Estimez les coûts pour différentes méthodes d'expédition et destinations",
  dumontFindWarehouseLocations: "Trouver les emplacements d'entrepôt",
  dumontFindWarehouseLocationsDesc:
    "Découvrez les emplacements d'entrepôt optimaux pour votre réseau de distribution",
  dumontManageInventoryLevels: "Gérer inventory levels",
  dumontManageInventoryLevelsDesc: "Obtenez des informations sur l'optimisation de l'inventaire et la gestion des stocks",
  dumontScheduleDeliveries: "Planning deliveries",
  dumontScheduleDeliveriesDesc: "Planifiez et optimisez les itinéraires de livraison pour une efficacité maximale",
  dumontHowCanIHelpYou: "Comment puis-je vous aider ?",
  invalidFileType: "Type de fichier invalide",
  uploadFailed: "Échec du téléversement",
  tooManyFiles: "Trop de fichiers",
  filesExceedSizeLimit: "Les fichiers dépassent la limite de taille",
  allFilesUploadedSuccessfully: "Tous les fichiers téléversés avec succès",
  moreBranches: "Plus d'agences",
  maximum10FilesPerUpload: "Maximum 10 fichiers par téléversement.",
  generate: "Générer",
  onCSVWeHaveFoundSomeErrors:
    "Dans le csv <strong>{{csvFileName}}</strong>, nous avons trouvé des erreurs. Vous devez ajuster ces lignes pour continuer :",
  weReSecurelyLoadingYourDataIntoShipeeziSCertifiedFramework:
    "Nous chargeons vos données de manière sécurisée dans le cadre certifié de Shipeezi.",
  weFoundSomeIssuesInYourCSV:
    "Nous avons trouvé des problèmes dans votre « {{csvFileName}} ». Veuillez corriger ces lignes avant de continuer :",
  needHelp: "Besoin d'aide?",
  forTheCorrectFormat: "pour le format correct.",
  noScreenshotsCaptured: "Non screenshots captured",
  noParticipantsAvailable: "Non participants available",
  companySlug: "Identifiant de l'entreprise",
  aUniqueIDUsedToIdentifyThisOrganization: "Un ID unique utilisé pour identifier cette organisation",
  thisSubdomainIsNotAvailablePleaseChooseADifferentOne:
    "Ce sous-domaine n'est pas disponible. Veuillez en choisir un autre.",
  maximum10FilesPerUpload: "Maximum 10 fichiers par téléversement.",
  fileIsTooBig: "Le fichier est trop volumineux. Taille maximale : 25 Mo",
  multiFactorAuthentication: "Authentification Multi-Facteur",
  mfaMultiFactorAuthentication: "Authentification Multi-Facteur",
  configureMfaSettingsPerGroup: "Configurer les paramètres MFA par groupe",
  mfaSettings: "Paramètres MFA",
  enableMfa: "Activer MFA",
  mfaEnabled: "MFA Activé",
  mfaDisabled: "MFA Désactivé",
  authenticationMethod: "Méthode d'Authentification",
  selectMethod: "Sélectionner la méthode",
  environments: "Environnements",
  enabledEnvironments: "Environnements activés",
  web: "Web",
  operationsApp: "Application Opérations",
  salesApp: "Application commerciale",
  savingMfaSettings: "Enregistrement des paramètres MFA...",
  mfaSettingsUpdated: "Paramètres MFA mis à jour avec succès",
  errorUpdatingMfaSettings: "Erreur lors de la mise à jour des paramètres MFA",
  noGroupsFound: "Aucun groupe trouvé",
  mfaVerificationTitle: "Saisir le code de vérification",
  mfaVerificationDescription: "Un code de vérification a été envoyé à :",
  mfaVerificationCode: "Code de vérification",
  verify: "Vérifier",
  resendCode: "Renvoyer le code",
  resendViaEmail: "Renvoyer par E-mail",
  resendViaSms: "Renvoyer par SMS",
  mfaCodeResent: "Code de vérification renvoyé avec succès",
  errorResendingCode: "Erreur lors du renvoi du code. Veuillez réessayer.",
  invalidCode: "Code invalide. Veuillez réessayer.",
  codeExpired: "Code expiré",
  expiresIn: "Expire dans",
  email: "E-mail",
  sms: "SMS",
  smsRequiresPhoneNumber: "SMS nécessite un numéro de téléphone",
  activeLoginSessions: "Sessions de connexion actives",
  operating_system: "Système d'exploitation",
  application: "Application",
  shipeezi_platform: "Plateforme Shipeezi",
  ip_address: "Adresse IP",
  last_active_date: "Dernière Activité",
  maximum10FilesPerUpload: "Maximum 10 fichiers par téléversement.",
  youHaveToSelectAtLeastOnePlatform: "Vous devez sélectionner au moins une plateforme",
  prohibitSimultaneousLogin: "Interdire la connexion simultanée",
  prohibitSimultaneousLoginDescription:
    "Empêcher les utilisateurs de se connecter sur plusieurs appareils ou plateformes en même temps",
  applyToPlatforms: "Appliquer aux plateformes",
  selectEquipmentType: "Sélectionner le type d'équipement",
  infoMessageEquipmentTypeFilterTitle: "Ce filtre est optionnel.",
  infoMessageEquipmentTypeFilterNoSelection: "Aucune sélection → le rapport inclut tous les types d'équipements.",
  infoMessageEquipmentTypeFilterSpecificType:
    "Type spécifique sélectionné → le rapport inclut uniquement les tâches de ce type.",
  infoMessageEquipmentTypeFilterNoTasks:
    "Aucune tâche pour le type sélectionné → le rapport n'affiche aucun résultat.",
  navigation: "NAVIGATION",
  defaultTemplate: "Modèle par Défaut",
  originFile: "Fichier d'Origine",
  templateContent: "Contenu du Modèle",
  onboardingTrigger: "Intégration",
  signupTrigger: "Inscription",
  offboarding: "Départ",
  sendViaVideoSurveyLink: "Envoyer via le lien de visite vidéo",
  sendANewInvitationToTheScheduleVideoSurvey: "Envoyer une nouvelle invitation à la visite vidéo planifiée",
  thereIsNoActiveVideoSurvey: "Il n'y a pas de visite vidéo active.",
  videoSurveyLinkSentToCustomer: "Lien de visite vidéo envoyé au client",
  videoSurveyLinkSendFailed: "Échec de l'envoi du lien de visite vidéo",
  plainText: "Texte brut",
  header: "En-tête",
  copyrightText: "Texte de Copyright",
  shipeeziBranding: "Image de marque Shipeezi",
  scheduleSend: "Planifier l'envoi",
  sendDate: "Date d'envoi",
  sendTime: "Heure d'envoi",
  selectAnUser: "Sélectionner un utilisateur",
  currentShipByDate: "Date d'expédition actuelle",
  originalShipByDate: "Date d'expédition originale",
  branding: "Image de marque",
  legal: "Juridique",
  localization: "Localisation",
  unitSystem: "Système d'unités",
  servicesAndTariffs: "Services et Tarifs",
  dumontYou: "Vous",
  dumontSending: "Envoi...",
  dumontTypeAMessage: "Saisissez un message...",
  dumontThankYou: "Merci !",
  dumontConnectionError: "Un problème est survenu en contactant Dumont. Veuillez réessayer plus tard.",
  dumontUnableToConnect: "Impossible de se connecter à Dumont.",
  dumontNoMessagesToCopy: "Aucun message à copier",
  dumontConversationCopied: "Conversation copiée dans le presse-papiers",
  dumontFailedToCopyConversation: "Impossible de copier la conversation",
  dumontNoMessagesToExport: "Aucun message à exporter",
  dumontChatExportedSuccessfully: "Chat exported avec succès",
  dumontFailedToExportChat: "Impossible d'exporter la discussion",
  dumontNoMessagesToClear: "Aucun message à effacer",
  dumontConversationCleared: "Conversation effacée",
  dumontOpenInNewWindow: "Ouvrir Dumont AI dans une nouvelle fenêtre",
  dumontCloseShortcut: "Cliquez ou appuyez sur ⌘K pour fermer Dumont AI",
  wouldYouLikeToSendAnInviteToAgentName: "Souhaitez-vous envoyer une invitation à {{agentName}} pour rejoindre votre réseau Shipeezi ?",
  selectAtLeastOneItem: "Sélectionnez au moins un élément",
  shipmentNotFound: "Expédition introuvable",
  expensesRecalculatedSuccessfully: "Dépenses recalculées avec succès",
  reconnecting: "Reconnexion",
  pleaseSelectAFile: "Veuillez sélectionner un fichier !",
  commentsSavedSuccessfully: "Commentaires enregistrés avec succès",
  couldNotSaveComments: "Impossible d'enregistrer les commentaires",
  anErrorOccurred: "Une erreur est survenue",
  unknownError: "Erreur inconnue",
  newNotification: "Nouvelle Notification",
  externalAgentAssignmentInfo:
    "Vous êtes assigné à un agent externe, qui recevra une invitation par e-mail pour accepter ou refuser l'assignation. En l'absence de réponse, le système enverra des e-mails de rappel pendant trois jours. Si l'agent ne répond pas dans ce délai, la tâche sera automatiquement annulée.",
  page: "page",
  originCriterion: "Critère d'Origine",
  originCriterionMustBeWOrP: "Le Critère d'Origine doit être 'W' ou 'P'",
  uploadPDF: "Téléverser un PDF",
  addManualItems: "Ajouter des articles manuels",
  editManualItems: "Modifier les articles manuels",
  editInventory: "Modifier l'inventaire",
  describeEachBingoItem: "Saisissez une description pour chaque article ci-dessous. Utilisez la pagination lorsque vous ajoutez de nombreux articles.",
  createInventory: "Créer un inventaire",
  editInventoryManualTitle: "Modifier l'inventaire (articles manuels)",
  customerSurvey: "Enquête Client (Sortie)",
  statementOfAsp: "Déclaration des Services Accessoires Effectués",
  downloadCsv: "Télécharger CSV",
  associateShipmentToOrder: "Associer l'expédition à la commande",
  shipmentSavedAsDraft: "Expédition enregistrée comme brouillon",
  shipmentCreationFailedAtIndex: "Impossible de créer l'expédition {{current}} sur {{total}}. Les expéditions précédentes ont peut-être été enregistrées. Veuillez vérifier la commande ou ajouter les expéditions restantes manuellement.",
  scacCodePlaceholder: "Rechercher ou saisir le code SCAC",
  grade: "Note",
  gradePlaceholder: "ex : A, B, C",
  scacInformation: "Informations SCAC",
  scacDescription: "Description SCAC",
  claimsPhone: "Téléphone Réclamations",
  claimsEmail: "E-mail Réclamations",
  itemIsTv: "L'article est un téléviseur",
  screenSize: "Taille de l'écran",
  screenType: "Type d'écran",
  remoteControl: "Télécommande",
  powerCord: "Cordon d'alimentation",
  tvBaseStand: "Base/support TV",
  baseStandHardware: "Quincaillerie de base/support",
  tv: "TV",
  vehicle: "Véhicule",
  serialNumberVin: "Numéro de série / VIN",
  odometerMiles: "Kilométrage au compteur",
  km: "KM",
  accessoriesIncluded: "Accessoires inclus",
  gasTankEmpty: "Réservoir de carburant vide",
  fuelSystemPurged: "Système de carburant purgé",
  batteryDisconnected: "Batterie débranchée",
  preApprovals: "Pré-approbations",
  noPreApprovals: "Aucune pré-approbation",
  approvalItem: "Élément d'approbation",
  goShareId: "ID Go Share",
  count: "Nombre",
  storageInTransitOriginSit: "Stockage en Transit (SIT Origine)",
  sitInDate: "Date d'entrée SIT",
  sitOutDate: "Date de sortie SIT",
  sitOutDateMustBeAfterSitInDate: "La date de sortie SIT doit être postérieure à la date d'entrée SIT.",
  sitNumber: "Numéro SIT",
  baseCode: "Code de la base",
  baseDescription: "Description de la base",
  areaCode: "Code de zone",
  areaDescription: "Description de la zone",
  zipCode: "Code postal",
  itemIsVehicle: "L'article est un Véhicule",
  vehicleType: "Type de Véhicule",
  motorcycle: "Moto",
  car: "Voiture",
  boat: "Bateau",
  startingNumber: "Numéro de Départ",
  decreaseStartingNumber: "Diminuer le numéro de départ",
  increaseStartingNumber: "Augmenter le numéro de départ",
  editDescriptionForItem: "Modifier la description de l'article",
  itemDescriptionDefaultPlaceholder: "S'applique à tous les articles de cet inventaire",
  defaultManualInventoryItemDescription: "Voir Inventaire",
  customerSignature: "Signature du client",
  removalistName: "Nom du déménageur",
  removalistSignature: "Signature du déménageur",
  removeFile: "Supprimer le fichier",
  removeInventoryPdf: "Supprimer le PDF de l'inventaire",
  removeInventoryPdfConfirmation: "Le PDF de l'inventaire sera supprimé de cette commande. Les articles déjà ajoutés ne seront pas supprimés. Continuer ?",
  viewInventory: "Voir l'Inventaire",
  noDocumentsHaveBeenAddedYet: "Aucun document n'a été ajouté",
  askEnzo: "Demander à Enzo",
  enzoHelpDocumentation: "Aide et Documentation",
  enzoSendFeedback: "Envoyer un Retour",
  enzoContactSupport: "Contacter le Support",
  enzoLearnHowToUseEnzo: "Apprenez à utiliser Enzo efficacement",
  enzoHelpUsImproveEnzo: "Aidez-nous à améliorer Enzo",
  enzoGetHelpFromTeam: "Obtenez de l'aide de notre équipe",
  enzoQuickActions: "Actions Rapides",
  enzoContactOurSupport: "Contactez notre support",
  enzoGetHelpWithIssues: "Obtenez de l'aide pour tout problème ou question",
  enzoSendUsYourFeedback: "Envoyez-nous vos retours",
  enzoShareThoughtsAndSuggestions: "Partagez vos réflexions et suggestions",
  enzoCommonQuestions: "Questions Fréquentes",
  enzoHowToCreateCustomAgent: "Comment créer un agent personnalisé ?",
  enzoHowToCreateCustomAgentAnswer: "Pour créer un agent personnalisé, accédez à la section Agents et cliquez sur le bouton « Créer un Nouvel Agent ». Vous pouvez ensuite configurer les capacités et les paramètres de l'agent selon vos besoins.",
  enzoWhatCanEnzoHelp: "En quoi Enzo peut-il m'aider ?",
  enzoWhatCanEnzoHelpAnswer: "Enzo est votre assistant IA spécialisé en logistique et déménagement. Je peux vous aider dans la planification des expéditions, la gestion des commandes, l'optimisation des itinéraires et répondre à vos questions sur vos opérations.",
  enzoHowToAccessChatHistory: "Comment accéder à mon historique de conversations ?",
  enzoHowToAccessChatHistoryAnswer: "Cliquez sur l'icône Historique dans la barre latérale pour voir toutes vos conversations passées avec Enzo. Vous pouvez rechercher dans votre historique et reprendre n'importe quelle conversation.",
  enzoCanCustomizeAgentCapabilities: "Puis-je personnaliser les capacités des agents ?",
  enzoResources: "Ressources",
  enzoKnowledgeBase: "Base de Connaissances",
  enzoCompleteGuidesAndTutorials: "Guides et tutoriels complets",
  enzoSelectAnOption: "Sélectionnez une option",
  enzoFeedbackHelpsImprove: "Vos retours nous aident à améliorer Enzo",
  enzoIssueType: "Type de Problème",
  enzoSubject: "Sujet",
  enzoBriefDescriptionOfIssue: "Brève description de votre problème",
  enzoMessage: "Message",
  enzoPleaseDescribeIssueDetail: "Veuillez décrire votre problème en détail...",
  enzoIncludeErrorMessages: "Incluez les messages d'erreur ou les étapes pour reproduire le problème",
  enzoGotIt: "Compris",
  enzoCancel: "Annuler",
  enzoSendFeedbackButton: "Envoyer un Retour",
  enzoSendMessage: "Envoyer le Message",
  enzoSupportRequestSentSuccessfully: "Votre demande de support a été envoyée avec succès. Notre équipe répondra dans les 24 heures.",
  enzoFeedbackSentSuccessfully: "Vos retours ont été envoyés avec succès. Nous apprécions votre contribution !",
  enzoSearchPlaceholder: "Rechercher conversations, agents, historique...",
  enzoNavigation: "Navigation",
  enzoNewChat: "Nouvelle Conversation",
  enzoChats: "Conversations",
  enzoNoChatsFound: "Aucune conversation trouvée",
  enzoNoRecentChats: "Aucune conversation récente",
  enzoAgents: "Agents",
  enzoNoAgentsFound: "Aucun agent trouvé",
  enzoReturnToShipeezi: "Retourner à Shipeezi",
  enzoHelp: "Aide",
  enzoWelcomeMessage: "Bonjour, {{userName}}, je suis Enzo, votre assistant IA spécialisé en logistique et déménagement. Conçu pour simplifier les flux de travail complexes, j'apprends en continu pour offrir un support plus rapide, intelligent et précis à votre entreprise.",
  enzoWelcomeMessageBusiness: "Bonjour, {{userName}}, je suis Enzo Assistant Commercial ! 💼 Je suis spécialisé dans les ventes et les devis. Je peux vous aider à créer des devis de fret précis, gérer les relations clients et conclure des affaires plus rapidement. Comment puis-je vous aider aujourd'hui ?",
  enzoWelcomeMessageOperations: "Bonjour, {{userName}}, je suis Enzo Assistant Opérations ! 📊 Je suis votre expert en opérations. Je peux vous aider à suivre les expéditions, surveiller les livraisons, gérer les travaux et assurer des opérations logistiques fluides. De quoi avez-vous besoin ?",
  enzoWelcomeMessageWarehousing: "Bonjour, {{userName}}, je suis Enzo Assistant Entrepôt ! 🏭 Je suis spécialisé dans l'inventaire et les opérations d'entrepôt. Je peux vous aider à gérer les niveaux de stock, suivre l'inventaire, coordonner le stockage et optimiser l'efficacité de l'entrepôt. Comment puis-je aider ?",
  enzoDispatchQuickActions: "Actions rapides pour l'Expédition",
  enzoHistory: "Historique",
  enzoConversationHistory: "Historique des Conversations",
  enzoNoConversationsFound: "Aucune conversation trouvée",
  enzoNoConversationHistory: "Aucun historique de conversations",
  enzoTryDifferentSearchTerm: "Essayez un autre terme de recherche",
  enzoStartNewConversation: "Démarrez une nouvelle conversation pour la voir ici",
  enzoFileTooLarge: "Le fichier est trop volumineux. La taille maximale est de 10 Mo.",
  enzoUnsupportedFileType: "Type de fichier non pris en charge. Veuillez sélectionner des fichiers TXT, PDF ou DOC/DOCX.",
  enzoDocumentProcessing: "Le traitement des PDF/DOC sera disponible prochainement. Veuillez utiliser des fichiers TXT pour l'instant.",
  enzoFileProcessingError: "Erreur lors du traitement du fichier. Veuillez réessayer.",
  enzoAskEnzo: "Demandez à Enzo...",
  enzoAskEnzoAnything: "Demandez n'importe quoi à Enzo",
  enzoUpload: "Téléverser",
  enzoUsesAI: "Enzo utilise l'Intelligence Artificielle. Vérifiez les réponses.",
  enzoCopyConversation: "Copier la conversation",
  enzoExportChat: "Exporter la conversation",
  enzoClearConversation: "Effacer la conversation",
  enzoLoadingAgents: "Chargement des agents...",
  enzoAgentsTitle: "Agents Enzo",
  enzoCreateAgent: "Créer un Agent",
  enzoSearchAgents: "Rechercher des agents...",
  enzoNoAgentsAvailable: "Aucun agent disponible",
  enzoAgentsAvailableSoon: "Les agents seront bientôt disponibles",
  enzoComingSoon: "Bientôt disponible...",
  enzoBusinessAssistant: "Assistant Commercial",
  enzoBusinessAssistantDesc: "Spécialisé dans les ventes et devis",
  enzoOperationsAssistant: "Assistant Opérations",
  enzoOperationsAssistantDesc: "Votre expert en opérations",
  enzoWarehousingAssistant: "Assistant Entrepôt",
  enzoWarehousingAssistantDesc: "Expert en inventaire et opérations d'entrepôt",
  enzoCanCustomizeAgentCapabilitiesAnswer: "Oui ! Chaque agent peut être personnalisé pour s'adapter à votre flux de travail spécifique. Vous pouvez ajuster ses capacités, définir des paramètres spécifiques et configurer les sources de données auxquelles il a accès.",
  enzoFeedbackType: "Type de Retour",
  enzoYourFeedback: "Votre Retour",
  enzoTellUsWhatYouThink: "Dites-nous ce que vous en pensez...",
  enzoPleaseSelectTextFile: "Veuillez sélectionner un fichier texte (.txt)",
  enzoDocumentAttached: "Document joint",
  enzoRemoveDocument: "Supprimer le document",
  enzoDefaultResponse: "Merci de nous avoir contactés ! J'analyse votre demande et vous fournirai la meilleure solution.",
  enzoSales: "Ventes",
  enzoOperations: "Opérations",
  enzoLogistics: "Logistique",
  enzoDispatchShowTodayOrders: "Afficher les commandes d'expédition du jour",
  enzoDispatchShowTodayOrdersDesc: "Obtenez un résumé de toutes les commandes prévues pour l'expédition aujourd'hui",
  enzoDispatchFindCustomer: "Rechercher des commandes par nom de client",
  enzoDispatchFindCustomerDesc: "Recherchez des commandes spécifiques en utilisant les informations du client",
  enzoDispatchTrackStatus: "Suivre le statut de la commande",
  enzoDispatchTrackStatusDesc: "Vérifiez le statut actuel des commandes dans le système",
  enzoDispatchOptimizeRoutes: "Optimiser les itinéraires de livraison",
  enzoDispatchOptimizeRoutesDesc: "Obtenez des suggestions pour les itinéraires de livraison les plus efficaces",
  enzoWhatCanIHelpYouWith: "Comment puis-je vous aider ?",
  enzoOptimizeLogisticsOperations: "Optimiser mes opérations logistiques",
  enzoOptimizeLogisticsOperationsDesc: "Obtenez des recommandations personnalisées pour améliorer l'efficacité et réduire les coûts",
  enzoTrackShipmentStatus: "Suivre le statut de l'expédition",
  enzoTrackShipmentStatusDesc: "Obtenez des mises à jour en temps réel sur vos expéditions et estimations de livraison",
  enzoCalculateShippingCosts: "Calculer les frais d'expédition",
  enzoCalculateShippingCostsDesc: "Estimez les coûts pour différentes méthodes d'expédition et destinations",
  enzoFindWarehouseLocations: "Trouver des emplacements d'entrepôt",
  enzoFindWarehouseLocationsDesc: "Découvrez les emplacements d'entrepôt optimaux pour votre réseau de distribution",
  enzoManageInventoryLevels: "Gérer les niveaux d'inventaire",
  enzoManageInventoryLevelsDesc: "Obtenez des informations sur l'optimisation de l'inventaire et la gestion des stocks",
  enzoScheduleDeliveries: "Planifier les livraisons",
  enzoScheduleDeliveriesDesc: "Planifiez et optimisez les itinéraires de livraison pour une efficacité maximale",
  enzoHowCanIHelpYou: "Comment puis-je vous aider ?",
  fileSizeIsTooLarge: "Le fichier est supérieur à 2 Mo",
  propertyDamageReport: "Rapport de dommages matériels",
  optional: "Facultatif",
  photoRequiredAtUpliftCompletion: "Photo requise à la fin de l'enlèvement",
  customerPhoneNumber: "Numéro de téléphone du client",
  alternativePhone: "Téléphone alternatif",
  alternativeEmail: "E-mail alternatif",
  mailingAddress: "Adresse postale",
  customerFields: "Champs du client",
  requireCustomerInformationFields: "Exiger les champs d'information du client",
  customerFieldsWillBeRequired: "Les champs du client seront obligatoires",
  selectMadatory: "Sélectionner obligatoire",
  military: "Militaire",
  templateType: "Type de modèle",
  assignedTemplate: "Modèle assigné",
  packingList: "Liste de colisage",
  billOfLading: "Connaissement",
  inventoryReport: "Rapport d'inventaire",
  shippingManifest: "Manifeste d'expédition",
  deliveryReceipt: "Accusé de livraison",
  customsDeclaration: "Déclaration en douane",
  saveTemplates: "Enregistrer les modèles",
  shipeeziDefault2: "Par défaut Shipeezi",
  clientCustomTemplate: "Modèle Personnalisé du Client",
  customTemplate: "Modèle Personnalisé",
  reportTemplates: "Modèles de Rapports",
  defineWhichTemplateEachReportUses: "Définissez quel modèle chaque rapport utilise. Les modèles sont enregistrés par entreprise et visibles uniquement pour les comptes Militaires. Identifiez si chaque rapport utilise le modèle par défaut Shipeezi ou un modèle personnalisé du client.",
  accessToThisSectionIsRestrictedByPermissionLevel: "L'accès à cette section est restreint par niveau de permission. Les modifications sont enregistrées par entreprise et masquées pour les comptes Commerciaux.",
  customerPortalAddress: "Adresse du Portail Client",
  definesLinkYourCustomerWillUse: "Définit le lien que vos clients utiliseront pour suivre les commandes et consulter les détails des expéditions",
  dateFormat: "Format de date",
  timeFormat: "Format de l'heure",
  accountPreferences: "Préférences du compte",
  addPreApprovalItem: "Ajouter un élément de pré-approbation",
  removePreApprovalItem: "Supprimer l'élément",
  pleaseFillAllPreApprovalFields: "Remplissez la description de la pré-approbation pour chaque ligne.",
  unitOfMeasure: "Unité de Mesure (UdM)",
  boxes: "Boîtes",
  pairs: "Paires",
  sets: "Ensembles",
  pallets: "Palettes",
  customerLogo: "Logo du Client",
  removeShipmentFromOrder: "Retirer l'Expédition de la Commande",
  thisShipmentHasNoOtherOrdersAssociated: "Cette expédition n'a aucune autre commande associée. Que souhaitez-vous en faire ?",
  revertToDraft: "Revenir au Brouillon",
  leaveAsDraft: "Laisser en Brouillon",
  cancelShipment: "Annuler l'Expédition",
  MB: "Mo",
  "Search...": "Rechercher...",
  activate: "activer",
  inactivate: "désactiver",
  cancelButton: "Annuler",
  cereLifeLocalAmount: "Montant local CereLife",
  commercial: "Commercial",
  confirmDelete: "Supprimer",
  confirmation: "Confirmation",
  containerId: "ID du conteneur",
  createANewPort: "Créer un nouveau port",
  customerLastName: "Nom du client",
  customerPhone: "Téléphone du client",
  dateCannotBeInThePast: "La date ne peut pas être dans le passé",
  decimalPlaces: "Décimales",
  deleteData: "Supprimer les données",
  deletePlaceholderTask: "Supprimer la tâche provisoire",
  editPort: "Modifier le port",
  emailIsInvalid: "L'e-mail n'est pas valide",
  errorFetchingTriggers: "Erreur lors de la récupération des déclencheurs",
  errorLoadingTemplates: "Erreur lors du chargement des modèles",
  errorReadingFile: "Erreur lors de la lecture du fichier",
  errorUpdatingTemplate: "Erreur lors de la mise à jour du modèle",
  errorUploadingFile: "Erreur lors du téléversement du fichier",
  errorValidatingTemplateName: "Erreur lors de la validation du nom du modèle",
  inAMoment: "dans un instant",
  invalidDateTime: "Date et heure invalides",
  invalidTimeFormat: "Format d'heure invalide",
  inviteAgent: "Inviter un agent",
  invoicedAmount: "Montant facturé",
  iso174511Description:
    "Utilisez la liste d'inventaire par défaut Shipeezi certifiée ISO17451-1:2016. Vous pouvez la mettre à jour ou l'étendre à tout moment.",
  itShouldBeAtLeastOneBranch: "Il doit y avoir au moins une succursale",
  itShouldHaveLeastOneBranch: "Vous devez avoir au moins une succursale",
  "label.item.packaging": "Emballage de l'article",
  last: "Dernier",
  loadingLocations: "Chargement des emplacements...",
  militaryReportsDescription: "Configurez les modèles de rapport pour les comptes militaires.",
  noInformationToBeShwon: "Aucune information à afficher",
  noLinkedAutomationsFound: "Aucune automatisation liée trouvée",
  noReports: "Aucun rapport",
  only: "Seulement",
  operationFailed: "L'opération a échoué",
  origins: "Origines",
  picture: "Image",
  pictures: "Images",
  pushCharacterLimitExceeded: "Limite de caractères de la notification push dépassée",
  scheduledTimeCannotBeInThePast: "L'heure planifiée ne peut pas être dans le passé",
  seconds: "secondes",
  selectAContainerNumber: "Sélectionnez un numéro de conteneur",
  selectAtLeastOneTarget: "Sélectionnez au moins une cible",
  selectOptions: "Sélectionner les options",
  sending: "Envoi en cours",
  shipeeziDefaultTemplate: "Modèle par défaut Shipeezi",
  shipmentInformation: "Informations sur l'expédition",
  smsCharacterLimitExceeded: "Limite de caractères SMS dépassée",
  someFilesFailedToUpload: "Certains fichiers n'ont pas pu être téléversés",
  taskUnpublishedCannotBeEdited: "Les tâches non publiées ne peuvent pas être modifiées",
  theLimitOfLinesIs: "La limite de lignes est",
  thisCustomerDoesNotHaveAnEmailToSendInvitation: "Ce client n'a pas d'e-mail pour envoyer l'invitation",
  thisFieldIsNumber: "Ce champ doit être un nombre",
  uploadCategories: "Catégories de téléversement",
  uploadCategoriesDescription: "Téléversez votre liste de catégories pour commencer.",
  uploadCentreDescription:
    "Ici, vous pouvez téléverser vos propres fichiers (inventaire, personnel, listes de services) ou commencer avec la liste par défaut Shipeezi. Vous pourrez toujours la mettre à jour plus tard.",
  useShipeeziSDefaultListDescription:
    "Démarrez rapidement avec notre liste préconfigurée, basée sur la norme mondiale ISO17451-1:2016. Vous pouvez la mettre à jour ou l'étendre à tout moment.",
  url: "URL",
  v: "V",
  youCannotInviteInactiveCustomers: "Vous ne pouvez pas inviter des clients inactifs",
  youDontHavePermissionToAccessShipmentData: "Vous n'avez pas la permission d'accéder aux données d'expédition",
  youHaveToAddAtLeastOneOrder: "Vous devez ajouter au moins une commande",
  youMustEnterAAgentId: "Vous devez saisir un ID d'agent",
  youMustHaveAtLeastOneContact: "Vous devez avoir au moins un contact",
  youMustHaveAtLeastOnePrimaryContact: "Vous devez avoir au moins un contact principal",
  yourPasswordMustBeAtLeast6CharactersLong: "Votre mot de passe doit comporter au moins 6 caractères",
  memberCode: "Code membre",
  uploadOwnListDescription: "Importez vos propres données pour personnaliser Shipeezi dès le départ.",
  downloadCsvTemplate: "Télécharger le modèle CSV",
};
